/* Capkov builder v2 — engine.
   Extracted from snippets/capkov-builder.liquid so the snippet stays under Shopify's
   256 KB template limit. Pure JS, no Liquid: the snippet passes its block id in and
   every per-instance value is read from the [data-capkov-config] JSON inside the root. */
(function(){
  if(window.__capkovBuilderInit) return;
  var RT = function (k, d) { return window.RT ? window.RT(k, d) : d; };   /* texty: RT(id, česky); překlady z window.RD_T */

  window.__capkovBuilderInit = function(capkovUid){
    var root = document.querySelector('[data-capkov-builder][data-capkov-uid="' + String(capkovUid).replace(/"/g, '\\"') + '"]');
    if(!root) return;
    if(!window.__capkov_bundle_patch_v3){
      window.__capkov_bundle_patch_v3 = true;
      // CAPKOV: cross-token map of saved variant IDs, consumed by fetch override below.
      window.__capkov_saved_variant_by_token = window.__capkov_saved_variant_by_token || {};

      var CAPKOV_SKIP_EXTRAS_HEADER = 'X-Capkov-Skip-Extras';

      function normStr(v){
        return (v == null) ? '' : String(v).replace(/^\s+|\s+$/g, '');
      }

      function isTruthy(v){
        v = normStr(v).toLowerCase();
        return v === '1' || v === 'true' || v === 'yes';
      }

      function getHeader(headers, name){
        try{
          if(!headers) return '';
          if(typeof headers.get === 'function'){
            return String(headers.get(name) || headers.get(String(name).toLowerCase()) || '');
          }
          if(Object.prototype.toString.call(headers) === '[object Array]'){
            for(var i=0;i<headers.length;i++){
              var pair = headers[i];
              if(!pair || pair.length < 2) continue;
              if(String(pair[0]).toLowerCase() === String(name).toLowerCase()) return String(pair[1] || '');
            }
            return '';
          }
          if(typeof headers === 'object'){
            return String(headers[name] || headers[String(name).toLowerCase()] || headers[String(name).toUpperCase()] || '');
          }
        }catch(e){}
        return '';
      }

      function hasSkipHeader(init){
        return isTruthy(getHeader(init && init.headers, CAPKOV_SKIP_EXTRAS_HEADER));
      }

      function jsonHasHiddenAddon(obj){
        try{
          if(!obj) return false;
          if(obj.items && obj.items.length){
            for(var i=0;i<obj.items.length;i++){
              var props = obj.items[i] && obj.items[i].properties ? obj.items[i].properties : {};
              if(isTruthy(props['__capkov_hidden_addon']) || isTruthy(props['_capkov_hidden_addon'])) return true;
            }
            return false;
          }
          var props = obj.properties || {};
          return isTruthy(props['__capkov_hidden_addon']) || isTruthy(props['_capkov_hidden_addon']);
        }catch(e){}
        return false;
      }

      function bodyHasHiddenAddon(body, headers){
        try{
          if(!body) return false;
          if(body instanceof FormData){
            return isTruthy(body.get('properties[__capkov_hidden_addon]') || body.get('properties[_capkov_hidden_addon]'));
          }
          if(body instanceof URLSearchParams){
            return isTruthy(body.get('properties[__capkov_hidden_addon]') || body.get('properties[_capkov_hidden_addon]'));
          }
          if(typeof body === 'string'){
            try{
              var usp = new URLSearchParams(body);
              if(isTruthy(usp.get('properties[__capkov_hidden_addon]') || usp.get('properties[_capkov_hidden_addon]'))) return true;
            }catch(e){}
            try{
              return jsonHasHiddenAddon(JSON.parse(body));
            }catch(e){}
            return false;
          }
          if(typeof body === 'object'){
            return jsonHasHiddenAddon(body);
          }
        }catch(e){}
        return false;
      }

      function extractTokenFromBody(body, headers){
        try{
          if(!body) return '';
          if(body instanceof FormData){
            return String(body.get('properties[__capkov_bundle_token]') || body.get('properties[_capkov_bundle_token]') || '').trim();
          }
          if(body instanceof URLSearchParams){
            return String(body.get('properties[__capkov_bundle_token]') || body.get('properties[_capkov_bundle_token]') || '').trim();
          }
          if(typeof body === 'string'){
            try{
              var usp = new URLSearchParams(body);
              var t1 = usp.get('properties[__capkov_bundle_token]') || usp.get('properties[_capkov_bundle_token]');
              if(t1) return String(t1).trim();
            }catch(e){}
            try{
              var obj = JSON.parse(body);
              if(obj && obj.items && obj.items[0] && obj.items[0].properties){
                return String(obj.items[0].properties['__capkov_bundle_token'] || obj.items[0].properties['_capkov_bundle_token'] || '').trim();
              }
              if(obj && obj.properties){
                return String(obj.properties['__capkov_bundle_token'] || obj.properties['_capkov_bundle_token'] || '').trim();
              }
            }catch(e){}
          }
          if(typeof body === 'object'){
            if(body && body.items && body.items[0] && body.items[0].properties){
              return String(body.items[0].properties['__capkov_bundle_token'] || body.items[0].properties['_capkov_bundle_token'] || '').trim();
            }
            if(body && body.properties){
              return String(body.properties['__capkov_bundle_token'] || body.properties['_capkov_bundle_token'] || '').trim();
            }
          }
        }catch(e){}
        return '';
      }

      function extractQtyFromBody(body){
        try{
          if(!body) return 1;
          if(body instanceof FormData) return parseInt(String(body.get('quantity')||'1'),10) || 1;
          if(body instanceof URLSearchParams) return parseInt(String(body.get('quantity')||'1'),10) || 1;
          if(typeof body === 'string'){
            try{
              return parseInt(String(new URLSearchParams(body).get('quantity')||'1'),10) || 1;
            }catch(e){}
            try{
              var obj = JSON.parse(body);
              if(obj && obj.items && obj.items[0]) return parseInt(String(obj.items[0].quantity || '1'), 10) || 1;
              if(obj && obj.quantity != null) return parseInt(String(obj.quantity || '1'), 10) || 1;
            }catch(e){}
          }
          if(typeof body === 'object'){
            if(body && body.items && body.items[0]) return parseInt(String(body.items[0].quantity || '1'), 10) || 1;
            if(body && body.quantity != null) return parseInt(String(body.quantity || '1'), 10) || 1;
          }
        }catch(e){}
        return 1;
      }

      function cloneJson(obj){
        try{ return JSON.parse(JSON.stringify(obj)); }catch(e){}
        return null;
      }

      async function addExtrasForToken(token, qty){
        if(!token) return;
        var key = 'capkov_extras:' + token;
        var raw = null;
        try{ raw = sessionStorage.getItem(key); }catch(e){}
        if(!raw) return;

        var payload = null;
        try{ payload = JSON.parse(raw); }catch(e){ payload = null; }
        if(!payload || !payload.items || !payload.items.length) return;

        var cloned = cloneJson(payload);
        if(!cloned || !cloned.items || !cloned.items.length) return;

        cloned.items.forEach(function(it){
          it.quantity = qty;
          it.properties = it.properties || {};
          it.properties['__capkov_hidden_addon'] = '1';
          it.properties['__capkov_bundle_token'] = token;
        });

        try{
          var headers = {'Content-Type':'application/json','Accept':'application/json'};
          headers[CAPKOV_SKIP_EXTRAS_HEADER] = '1';
          await fetch((window.RU ? RU('/cart/add.js') : '/cart/add.js'), {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({ items: cloned.items })
          });
        }catch(e){}

        try{ document.dispatchEvent(new Event('cart:refresh')); }catch(e){}
        /* AUDIT-A: drawer po přidání s příplatky ukazoval starý součet (HTML sekce z původního add.js vznikl před přidáním řádků příplatků a opožděný morph z cart:change ho vrátil přes čerstvý refresh) → druhý refresh až po něm */
        try{ setTimeout(function(){ try{ document.dispatchEvent(new Event('cart:refresh')); }catch(e){} }, 1800); }catch(e){}
      }

      /* F1: hlavní řádek se nikdy nesmí zůstat bez příplatků (Shopify při množství nad dostupnost vrátí 422 a přidá jen část) */
      function capkovToast(msg){
        try{
          var e = document.createElement('div'); e.setAttribute('role','alert'); e.textContent = msg;
          e.style.cssText = 'position:fixed;left:50%;top:16px;transform:translateX(-50%);z-index:100010;max-width:min(92vw,460px);background:#111;color:#fff;padding:12px 16px;border-radius:12px;font:600 14px/1.4 system-ui,sans-serif;box-shadow:0 10px 30px rgba(0,0,0,.25)';
          document.body.appendChild(e); setTimeout(function(){ try{ e.remove(); }catch(x){} }, 7000);
        }catch(e2){}
      }
      function stockMsg(n){
        return RT('n.1fbf463', 'Máme skladem jen {0} ks').replace('{0}', n);
      }
      async function reconcileFailedAdd(token, reqQty){
        try{
          await new Promise(function(r){ setTimeout(r, 450); });
          var r0 = await origFetch.call(window, (window.RU ? RU('/cart.js') : '/cart.js'), { credentials:'same-origin', cache:'no-store', headers:{ 'Accept':'application/json' } });
          var c = await r0.json();
          var mains = [], addons = 0, q = 0;
          (c.items || []).forEach(function(it){
            var pr = it.properties || {};
            var t = String(pr['__capkov_bundle_token'] || pr['_capkov_bundle_token'] || '').trim();
            if(t !== token) return;
            if(isTruthy(pr['__capkov_hidden_addon'] || pr['_capkov_hidden_addon'])) addons++; else { mains.push(it); q += Number(it.quantity) || 0; }
          });
          if(!mains.length) return;
          if(q < reqQty){
            capkovToast(stockMsg(q));
            /* skutečná dostupnost se zapamatuje pro variantu (Liquid vidí jen součet skladů, ne to, co lze prodat online) a pole množství se srovná */
            try{
              var vId = String(mains[0].variant_id || '');
              if(vId){ window.__capkov_avail = window.__capkov_avail || {}; window.__capkov_avail[vId] = q; }
              var qi2 = document.querySelector('input[name="quantity"]');
              if(qi2){ var idIn = document.querySelector('form[action*="/cart/add"] input[name="id"]'); if(!idIn || String(idIn.value) === vId){ if(parseInt(qi2.value, 10) > q) qi2.value = String(q); } }
            }catch(e){}
          }
          if(!addons) await addExtrasForToken(token, q);
          try{ if(window.__CAPKOV_ENSURE_ADDON_SYNC) setTimeout(function(){ window.__CAPKOV_ENSURE_ADDON_SYNC(); }, 1500); }catch(e){}
        }catch(e){}
      }

      var origFetch = window.fetch;
      if(typeof origFetch === 'function'){
        window.fetch = function(resource, init){
          var url = '';
          try{ url = (typeof resource === 'string') ? resource : (resource && resource.url) ? resource.url : ''; }catch(e){}
          var isCartAdd = (url && url.indexOf('/cart/add') !== -1);
          if(!isCartAdd || hasSkipHeader(init)) return origFetch.apply(this, arguments);

          var body = init && init.body;
          var headers = init && init.headers;
          if(bodyHasHiddenAddon(body, headers)) return origFetch.apply(this, arguments);

          var token = extractTokenFromBody(body, headers);
          var qty = extractQtyFromBody(body);
          /* F1: množství se před přidáním ořízne na dostupnost (atribut max u pole množství) */
          try{
            if(token && body && (body instanceof FormData)){
              var qIn = document.querySelector('input[name="quantity"]');
              var qMax = qIn ? parseInt(qIn.getAttribute('max') || '', 10) : NaN;
              var learned = window.__capkov_avail && window.__capkov_avail[String(body.get('id') || '')];
              if(learned && (!isFinite(qMax) || learned < qMax)) qMax = learned;
              if(isFinite(qMax) && qMax > 0 && qty > qMax){ body.set('quantity', String(qMax)); qty = qMax; capkovToast(stockMsg(qMax)); }
            }
          }catch(e){}

          // CAPKOV: belt-and-suspenders variant override.
          // If a saved design exists for this token, force the cart-add to use its variant.
          // This catches edge cases where the form submit-time override didn't run
          // (e.g. theme re-rendered the form, race with VariantPicker, etc.).
          try{
            if(token && body){
              var savedVid = window.__capkov_saved_variant_by_token && window.__capkov_saved_variant_by_token[token];
              if(savedVid){
                if(body instanceof FormData){
                  try{ body.set('id', String(savedVid)); }catch(e){
                    try{ body.delete('id'); body.append('id', String(savedVid)); }catch(e2){}
                  }
                } else if(body instanceof URLSearchParams){
                  try{ body.set('id', String(savedVid)); }catch(e){}
                }
              }
            }
          }catch(e){}

          try{
            if(token && body && (body instanceof FormData)){
              var map = window.__capkov_files_by_token && window.__capkov_files_by_token[token];
              if(map){
                Object.keys(map).forEach(function(k){
                  /* 8.10.: mockup už nahraný na cpcaps (rd-nahled → URL ve vlastnosti) se jako soubor nepřikládá; při selhání nahrání zůstává soubor jako záloha */
                  try{ if(/_mockup\]$/.test(k)){ var __cur = body.get(k); if(typeof __cur === 'string' && /^https?:\/\//.test(__cur)) return; } }catch(e){}
                  try{ body.delete(k); }catch(e){}
                  var f = map[k];
                  if(!f) return;
                  try{
                    if(f.name) body.append(k, f, f.name);
                    else body.append(k, f);
                  }catch(e){
                    try{ body.append(k, f); }catch(e2){}
                  }
                });
              }
            }
          }catch(e){}

          /* ATCFB 7.10 */
          var __sig = function(ok, status, msg){ try{ if(token) window.dispatchEvent(new CustomEvent('capkov:add-result', { detail: { token: token, ok: !!ok, status: status || 0, message: msg || '' } })); }catch(e){} };
          try{ if(token) window.dispatchEvent(new CustomEvent('capkov:add-start', { detail: { token: token } })); }catch(e){}
          return origFetch.apply(this, arguments).then(function(resp){
            try{
              if(token){ if(resp && resp.ok) addExtrasForToken(token, qty); else reconcileFailedAdd(token, qty); }
            }catch(e){}
            try{
              if(resp && resp.ok) __sig(true, resp.status);
              else if(resp && resp.clone) resp.clone().json().then(function(j){ __sig(false, resp.status, j && (j.description || j.message)); }, function(){ __sig(false, resp.status); });
              else __sig(false, 0);
            }catch(e){ __sig(resp && resp.ok, resp && resp.status); }
            return resp;
          }, function(err){ __sig(false, 0); throw err; });
        };
      }
    }

    function readJson(el){
      if(!el) return null;
      try{ return JSON.parse(el.textContent || el.innerText || ''); }catch(e){ return null; }
    }

    var config = readJson(root.querySelector('script[data-capkov-config]')) || {};
    var capkovConfig = config;
    var uid = config.uid || '';
    var modeKey = config.mode_key || '';
    var kind = config.kind || '';
    var isSocks = modeKey === 'text_socks' || !!config.is_socks;
    if(isSocks) kind = 'text';
    var isWinter = !!config.is_winter;
    var isTote = !!config.is_tote;
    var isEn = !!config.is_en;
    var product = config.product || {};
    var productFormId = String(config.product_form_id || '').trim();
    var previewByMode = config.preview_by_mode || {};
    var framesByMode = config.frames_by_mode || {};
    var fees = config.fees || { placement: 100, color: 50 };

    /* ---------------------------------------------------------------------------
       APPAREL (trika + mikiny)
       Both product families share one mode_key, so a single set of "capkov_apparel"
       placement blocks configures t-shirts and hoodies at the same time.
       Anything left at 0 in a placement block inherits the unified value from the
       "capkov builder v2" block (size slider / lines / chars per line).
       --------------------------------------------------------------------------- */
    var isApparel = !!config.is_apparel;
    var apparelRaw = config.apparel || {};
    var APPAREL_PLACEMENTS = ['front','back','side_left','side_right'];
    var APPAREL_ANCHOR_FALLBACK = {
      front:      { x: 50, y: 34 },
      back:       { x: 50, y: 32 },
      side_left:  { x: 50, y: 46 },
      side_right: { x: 50, y: 46 }
    };

    function apparelNum(v, fb){
      var n = parseFloat(v);
      return isFinite(n) ? n : fb;
    }

    var apparelDefaults = {
      size: (function(){ var n = apparelNum(apparelRaw.text_size_pct, 100); return (n > 0) ? n : 100; })(),
      lines: (function(){ var n = parseInt(apparelNum(apparelRaw.text_lines, 2), 10); return (isFinite(n) && n > 0) ? n : 2; })(),
      chars: (function(){ var n = parseInt(apparelNum(apparelRaw.text_chars, 14), 10); return (isFinite(n) && n > 0) ? n : 14; })(),
      x: apparelNum(apparelRaw.text_x, 50),
      y: apparelNum(apparelRaw.text_y, 34)
    };

    var apparelBlocks = [];
    if(Array.isArray(apparelRaw.placements_json)){
      apparelBlocks = apparelRaw.placements_json;
    }else{
      try{ apparelBlocks = JSON.parse(String(apparelRaw.placements_json || '[]')); }catch(e){ apparelBlocks = []; }
    }
    if(!Array.isArray(apparelBlocks)) apparelBlocks = [];

    var apparelMap = (function(){
      var out = {};
      APPAREL_PLACEMENTS.forEach(function(p){ out[p] = null; });
      apparelBlocks.forEach(function(b){
        if(!b) return;
        var p = String(b.placement || 'front').trim();
        if(APPAREL_PLACEMENTS.indexOf(p) < 0) return;
        if(out[p]) return; /* first block for a placement wins */
        var fb = APPAREL_ANCHOR_FALLBACK[p] || APPAREL_ANCHOR_FALLBACK.front;
        var size = apparelNum(b.text_size, 0);
        var lines = parseInt(apparelNum(b.text_lines, 0), 10);
        var chars = parseInt(apparelNum(b.text_chars, 0), 10);
        out[p] = {
          enabled: (b.enabled === false) ? false : true,
          label_cs: String(b.label_cs || '').trim(),
          label_en: String(b.label_en || '').trim(),
          preview: String(b.preview || '').trim(),
          x: apparelNum(b.text_x, fb.x),
          y: apparelNum(b.text_y, fb.y),
          size: (isFinite(size) && size > 0) ? size : 0,
          lines: (isFinite(lines) && lines > 0) ? lines : 0,
          chars: (isFinite(chars) && chars > 0) ? chars : 0,
          frame: {
            left: apparelNum(b.frame_left, 500),
            top: apparelNum(b.frame_top, 480),
            w: apparelNum(b.frame_w, 600),
            h: apparelNum(b.frame_h, 600),
            min: apparelNum(b.frame_min, 60),
            max: apparelNum(b.frame_max, 100)
          },
          fee: apparelNum(b.fee, 0),
          addon_variant_id: String(b.addon_variant_id || '').trim()
        };
      });
      return out;
    })();

    function apparelFor(p){
      if(!isApparel) return null;
      return apparelMap[p] || null;
    }

    /* Unified text size: placement override first, otherwise the block-level slider. */
    function apparelTextSizePct(p){
      var a = apparelFor(p);
      if(a && a.size > 0) return a.size;
      return apparelDefaults.size;
    }

    function apparelLinesFor(p){
      var a = apparelFor(p);
      var cnt = (a && a.lines > 0) ? a.lines : apparelDefaults.lines;
      if(!isFinite(cnt) || cnt < 1) cnt = 1;
      if(cnt > 5) cnt = 5;
      return cnt;
    }

    function apparelCharsFor(p){
      var a = apparelFor(p);
      var ch = (a && a.chars > 0) ? a.chars : apparelDefaults.chars;
      if(!isFinite(ch) || ch < 1) ch = 1;
      return ch;
    }

    function apparelFeeFor(p){
      var a = apparelFor(p);
      if(a && a.fee > 0) return a.fee;
      var n = parseFloat(fees.placement);
      return isFinite(n) ? n : 100;
    }

    function apparelAddonVariantFor(p){
      var a = apparelFor(p);
      return (a && a.addon_variant_id) ? a.addon_variant_id : '';
    }

    /* Mockups slice the text before currentTextLimit() is reachable, so expose the row count. */
    function maxLinesForPlacement(p){
      if(isApparel) return apparelLinesFor(p);
      return 3;
    }

    /* The fee amounts are plain numbers in the block settings, so the builder has to
       format them itself. It used to hard-code " Kč", which showed Czech koruna on the
       EUR storefront. Currency now comes from the shop. */
    var moneyCfg = config.money || {};
    var MONEY_ISO = String(moneyCfg.iso || 'CZK').toUpperCase();
    var MONEY_RULES = {
      CZK: { suffix: ' Kč', decimals: 0, sep: ',' },
      EUR: { suffix: ' €',  decimals: 2, sep: ',' },
      PLN: { suffix: ' zł', decimals: 2, sep: ',' },
      GBP: { suffix: ' £',  decimals: 2, sep: '.' },
      USD: { suffix: ' $',  decimals: 2, sep: '.' }
    };
    var MONEY = MONEY_RULES[MONEY_ISO] || { suffix: ' ' + MONEY_ISO, decimals: 2, sep: '.' };

    function formatMoney(amount){
      var n = Number(amount);
      if(!isFinite(n)) return '';
      var num = MONEY.decimals > 0
        ? n.toFixed(MONEY.decimals).replace('.', MONEY.sep)
        : String(Math.round(n));
      return num + MONEY.suffix;
    }
    function formatFee(amount){
      var n = Number(amount);
      if(!isFinite(n) || n === 0) return '';
      return '+' + formatMoney(n);
    }

    var addonVariants = config.addon_variants || {};
    var threadVariantMap = config.thread_variant_map || {};
    function normalizeKey(str){
      var s = String(str || '').trim().toLowerCase();
      try{ s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); }catch(e){}
      s = s.replace(/\s+/g, ' ');
      return s;
    }
    var threadVariantMapNorm = {};
    try{
      Object.keys(threadVariantMap || {}).forEach(function(k){
        var v = threadVariantMap[k];
        if(v == null || String(v).trim() === '') return;
        var nk = normalizeKey(k);
        if(nk) threadVariantMapNorm[nk] = v;
      });
    }catch(e){}
    var threadColorsCsv = String(config.thread_colors_csv || '').trim();
    var swatches = Array.isArray(config.swatches) ? config.swatches : null;
    var fonts = Array.isArray(config.fonts) ? config.fonts : null;

    if(!Array.isArray(swatches)){
      if(Array.isArray(config.swatches_json)){
        swatches = config.swatches_json;
      }else{
        try{ swatches = JSON.parse(String(config.swatches_json || '[]')); }catch(e){ swatches = []; }
      }
    }

    if(!Array.isArray(fonts)){
      if(Array.isArray(config.fonts_json)){
        fonts = config.fonts_json;
      }else{
        try{ fonts = JSON.parse(String(config.fonts_json || '[]')); }catch(e){ fonts = []; }
      }
    }

    if(!Array.isArray(swatches)) swatches = [];
    if(!Array.isArray(fonts)) fonts = [];
    var fallbackFontsCsv = String(config.fallback_fonts_csv || '').trim();
    var defaultFontUrl = String(config.default_font_url || '').trim();
    var openBtn = root.querySelector('[data-capkov-open]');
    var modal = root.querySelector('[data-capkov-modal]');
    var scrollEl = root.querySelector('[data-capkov-scroll]') || root.querySelector('.capkov-b2__left');
    var closeEls = root.querySelectorAll('[data-capkov-close]');
    var summaryEl = root.querySelector('[data-capkov-summary]');
    var newBtn = root.querySelector('[data-capkov-new]');
    var resetBtns = Array.prototype.slice.call(root.querySelectorAll('[data-capkov-reset]') || []);
    var errorEl = root.querySelector('[data-capkov-error]');
    var instructionsEl = root.querySelector('[data-capkov-instructions]');

    var placementsWrap = root.querySelector('[data-capkov-placements]');
    var tabsEl = root.querySelector('[data-capkov-tabs]');
    var placementPriceEl = root.querySelector('[data-capkov-placement-price]');
    var placementNoteEl = root.querySelector('[data-capkov-placement-note]');
    var placementsLabelEl = root.querySelector('[data-capkov-placements-label]');
    var toteOrientRow = root.querySelector('[data-capkov-tote-orient-row]');
    var toteOrientTabs = root.querySelector('[data-capkov-tote-orient-tabs]');
    var toteOrientBtns = Array.prototype.slice.call(root.querySelectorAll('[data-capkov-tote-orient]') || []);
    var toteMirrorRow = root.querySelector('[data-capkov-tote-mirror-row]');
    var toteMirrorTabs = root.querySelector('[data-capkov-tote-mirror-tabs]');
    var toteMirrorBtns = Array.prototype.slice.call(root.querySelectorAll('[data-capkov-tote-mirror]') || []);
    var toteSizeRow = root.querySelector('[data-capkov-tote-size-row]');
    var toteSizeSelect = root.querySelector('[data-capkov-tote-text-size]');
    var toteFlipRow = root.querySelector('[data-capkov-tote-flip-row]');
    var toteFlipTabs = root.querySelector('[data-capkov-tote-flip-tabs]');
    var toteFlipBtns = Array.prototype.slice.call(root.querySelectorAll('[data-capkov-tote-flip]') || []);
    var toteRotRow = root.querySelector('[data-capkov-tote-rot-row]');
    var toteRotTabs = root.querySelector('[data-capkov-tote-rot-tabs]');
    var toteRotBtns = Array.prototype.slice.call(root.querySelectorAll('[data-capkov-tote-rot]') || []);
    var contentKindRow = root.querySelector('[data-capkov-content-kind-row]');
    var contentKindTabs = root.querySelector('[data-capkov-content-kind-tabs]');
    var contentKindBtns = Array.prototype.slice.call(root.querySelectorAll('[data-capkov-content-kind]') || []);

    var textUI = root.querySelector('[data-capkov-text-ui]');
    var fontUI = root.querySelector('[data-capkov-font-ui]');
    var imageUI = root.querySelector('[data-capkov-image-ui]');
    var fileInput = root.querySelector('[data-capkov-file]');
    var fileInfo = root.querySelector('[data-capkov-fileinfo]');
    var fileNameEl = root.querySelector('[data-capkov-filename]');
    var fileMetaEl = root.querySelector('[data-capkov-filemeta]');
    var clearFileBtn = root.querySelector('[data-capkov-clear-file]');
    var scaleUI = root.querySelector('[data-capkov-scale-ui]');
    var scaleInput = root.querySelector('[data-capkov-scale]');
    var scaleLabel = root.querySelector('[data-capkov-scale-label]');
    var dragHint = root.querySelector('[data-capkov-draghint]');
    var dragTip = root.querySelector('[data-capkov-dragtip]');
    var sideBadge = root.querySelector('[data-capkov-sidebadge]');
    var winterBackCfg = config.winter_back || {};

    var textInput = root.querySelector('[data-capkov-text]');
    var textLimitEl = root.querySelector('[data-capkov-text-limit]');
    var fontSelect = root.querySelector('[data-capkov-font]');

    var designInput = root.querySelector('[data-capkov-design-name]');
    var designRow = root.querySelector('[data-capkov-design-row]');
    var noteInput = root.querySelector('[data-capkov-note]');

    var colorsEl = root.querySelector('[data-capkov-colors]');
    var colorPriceEl = root.querySelector('[data-capkov-color-price]');

    var selectedColorEl = root.querySelector('[data-capkov-selected-color]');

    var threadRow = root.querySelector('[data-capkov-thread-row]');

    var sizeRow = root.querySelector('[data-capkov-size-row]');
    var sizeTabsEl = root.querySelector('[data-capkov-size-tabs]');
    var sizeLabelEl = root.querySelector('[data-capkov-size-label]');
    var sizeNoteEl = root.querySelector('[data-capkov-size-note]');

    var saveBtn = root.querySelector('[data-capkov-save]');
    var addBtn = root.querySelector('[data-capkov-add]');

    var swatchesEl = root.querySelector('[data-capkov-swatches]');
    var stageEl = root.querySelector('[data-capkov-stage]');
    var baseImg = root.querySelector('[data-capkov-base]');
    var canvas = root.querySelector('[data-capkov-canvas]');
    var ctx = canvas && canvas.getContext ? canvas.getContext('2d') : null;
    var frameEl = root.querySelector('[data-capkov-frame]');
    var overlayImg = root.querySelector('[data-capkov-overlayimg]');

    var textOverlayEl = root.querySelector('[data-capkov-textoverlay]');
    var textOverlayTextEl = root.querySelector('[data-capkov-textoverlay-text]');
    // Keep ownership after the modal is moved outside the builder root.
    root.__capkovBuilderModal = modal;
    try{
      if(modal && modal.parentElement && modal.parentElement !== document.body){
        document.body.appendChild(modal);
      }
    }catch(e){}
    if(overlayImg){
      overlayImg.addEventListener('load', function(){
        try{ updateImageOverlayPreview(); }catch(e){}
      });
    }
    function emptyPlacementState(){
      return {
        text: '',
        font: '',
        contentKind: (kind === 'text' ? 'text' : 'image'),
        threadColor: ((isTote || isSocks) ? (isEn ? 'Black' : 'Černá') : (isEn ? 'White' : 'Bílá')),
        _threadTouched: false,
        file: null,
        bitmap: null,
        previewUrl: '',
        overlay: { x: 0.5, y: 0.5, scale: 100, flipX: false, flipY: false, rot: 0 },
        textOverlay: { x: 0.5, y: 0.5, orient: 'h', mirror: false, rot: 0, sizeTier: 'm' }
      };
    }

    var state = {
      placement: 'front',
      designName: '',
      note: '',
      swatchIndex: -1,
      savedVariantId: '',
      bundleToken: '',
      toteBackEnabled: true,
      byPlacement: {
        front: emptyPlacementState(),
        back: emptyPlacementState(),
        side_left: emptyPlacementState(),
        side_right: emptyPlacementState()
      }
    };

    var _zoomActive = false;
    var zoomResetExternal = null;

    function showError(msg){
      if(!errorEl) return;
      if(!msg){
        errorEl.textContent = '';
        errorEl.setAttribute('data-show','false');
        return;
      }
      errorEl.textContent = msg;
      errorEl.setAttribute('data-show','true');
    }

    function updateSummaryActions(){
      if(!newBtn || !summaryEl) return;
      var has = !!(summaryEl.textContent && String(summaryEl.textContent).trim());
      newBtn.hidden = !has;
    }

    function nukeControlledFormProps(form){
      if(!form) return;
      var nodes = form.querySelectorAll('input[name^="properties["], textarea[name^="properties["]');
      nodes.forEach(function(el){
        var n = el.getAttribute('name') || '';
        if((el.getAttribute('data-capkov-prop') || '') === '1'){
          try{ el.remove(); }catch(e){}
          return;
        }
        if(
          n === 'properties[Personalizace]' || n === 'properties[Personalization]' ||
          n === 'properties[Poznámka]' || n === 'properties[Poznámka k objednávce]' ||
          n === 'properties[Note]' || n === 'properties[Order note]' ||
          n === 'properties[Název designu]' || n === 'properties[Design name]' ||
          n.indexOf('properties[_capkov_') === 0 || n.indexOf('properties[__capkov_') === 0
        ){
          try{ el.remove(); }catch(e){}
        }
      });
    }

    function resetBuilderState(opts){
      opts = opts || {};
      showError('');

      PLACEMENTS.forEach(function(p){
        var st = state.byPlacement[p];
        if(!st) return;
        st.contentKind = (kind === 'text' ? 'text' : 'image');
        st.text = '';
        st.font = '';
        st.threadColor = '';
        revokePreviewUrl(st);
        st.file = null;
        st.bitmap = null;
        st.overlay = { x: 0.5, y: 0.5, scale: 100, flipX: false, flipY: false, rot: 0 };
        st.textOverlay = { x: 0.5, y: 0.5, orient: 'h', mirror: false, rot: 0, sizeTier: 'm' };
      });

      state.designName = '';
      state.note = '';
      state.placement = (PLACEMENTS && PLACEMENTS.length && PLACEMENTS.indexOf('front') < 0) ? PLACEMENTS[0] : 'front';
      state.savedVariantId = '';
      state.bundleToken = '';

      if(summaryEl) summaryEl.textContent = '';
      updateSummaryActions();

      if(designInput) designInput.value = '';
      if(noteInput) noteInput.value = '';
      if(textInput) textInput.value = '';
      try{ if(fileInput) fileInput.value = ''; }catch(e){}

      try{ nukeControlledFormProps(getForm()); }catch(e){}

      syncModeUI();
      renderTabs();
      renderThreadColors();
      renderSwatches();
      try{ renderSizes(); }catch(e){}
      syncUiFromState();
      renderPreview();
    updateSummaryActions();
      try{ if(scrollEl) scrollEl.scrollTop = 0; }catch(e){}

      if(opts.open){
        try{ openModal(); }catch(e){}
      }
    }

    function normalizeSpaces(s){ return String(s||'').replace(/\s+/g,' ').trim(); }
    /* F4/F5: text umístění před zápisem do vlastností: mezery sloučené a oříznuté po řádcích, délka podle limitu umístění, bez mezery na konci po oříznutí */
    function cutTo(x, m){
      if(x.length <= m) return x;
      var y = x.slice(0, m);
      if(/[\ud800-\udbff]$/.test(y)) y = y.slice(0, -1);
      return y.replace(/\s+$/, '');
    }
    function cleanPlText(p, raw){
      var lines = String(raw == null ? '' : raw).replace(/\r\n?/g, '\n').split('\n').map(function(x){ return x.replace(/[ \t\u00a0]+/g, ' ').trim(); });
      if(!isTote){
        var lim = null; try{ lim = currentTextLimit(p); }catch(e){}
        var cnt = (lim && lim.count) || 1, lims = (lim && lim.limits) || [];
        lines = lines.slice(0, cnt).map(function(x, i){ var m = lims[i] != null ? lims[i] : lims[lims.length - 1]; return (m > 0) ? cutTo(x, m) : x; });
      }
      while(lines.length && !lines[lines.length - 1]) lines.pop();
      return lines.join('\n');
    }

    function slugifyDesignName(s){
      var x = String(s||'').trim();
      try{ x = x.normalize('NFD').replace(/[̀-ͯ]/g,''); }catch(e){}
      x = x.replace(/[^a-zA-Z0-9]+/g,'_');
      x = x.replace(/_+/g,'_').replace(/^_+|_+$/g,'');
      x = x.toLowerCase();
      return x || 'design';
    }

    function placementLabel(p){
      if(isTote){
        if(p==='front') return RT('n.4498838', 'Přední strana');
        if(p==='back') return RT('n.93968bf', 'Zadní strana');
      }
      if(isApparel){
        var ap = apparelFor(p);
        var custom = ap ? (isEn ? ap.label_en : ap.label_cs) : '';
        if(custom) return custom;
        if(p==='front') return RT('n.a63b944', 'Předek');
        if(p==='back') return RT('n.d32d2f9', 'Záda');
        if(p==='side_left') return RT('n.d5c40ad', 'Levý rukáv');
        if(p==='side_right') return RT('n.cc11092', 'Pravý rukáv');
        return p;
      }
      if(p==='front') return RT('n.a63b944', 'Předek');
      if(p==='back') return RT('n.4dd1bda', 'Zadek');
      if(p==='side_left') return RT('n.1257ae9', 'Levá strana');
      if(p==='side_right') return RT('n.42781f0', 'Pravá strana');
      return p;
    }

    function placementsList(){
      if(kind === 'color') return ['front'];
      if(isSocks) return ['front'];
      /* 26. 10.: zimní čepice jde vyšít i vzadu (stejný mechanismus a příplatek jako u kšiltovek) */
      if(isWinter) return (config.enable && config.enable.back) ? ['front','back'] : ['front'];
      if(isTote) return ['front','back'];
      if(isApparel){
        /* Apparel NEVER inherits the caps' back/side toggles — sleeves and back are opt-in.
           With no capkov_apparel block the builder offers the front only; every further
           placement shows up once its own (enabled) block exists. */
        var apOut = APPAREL_PLACEMENTS.filter(function(p){
          var a = apparelMap[p];
          return !!(a && a.enabled);
        });
        return apOut.length ? apOut : ['front'];
      }
      var out = ['front'];
      if(config.enable && config.enable.back) out.push('back');
      if(config.enable && config.enable.side_left) out.push('side_left');
      if(config.enable && config.enable.side_right) out.push('side_right');
      return out;
    }

    var PLACEMENTS = placementsList();
    /* A merchant may disable "front", so never start on a placement that isn't offered. */
    try{
      if(PLACEMENTS.length && PLACEMENTS.indexOf(state.placement) < 0) state.placement = PLACEMENTS[0];
    }catch(e){}

    function activePlacement(){
      if(isSocks) return 'front';
      var p = state.placement || 'front';
      return p;
    }
    function activeState(){
      var p = activePlacement();
      return state.byPlacement[p] || state.byPlacement.front;
    }
    var isImageMixed = (kind === 'image' && !isWinter && (!isTote || modeKey === 'tote_image'));

    function textModeKeyForCurrentProduct(){
      if(modeKey === 'image_non_washed') return 'text_non_washed';
      if(modeKey === 'image_washed') return 'text_washed';
      if(modeKey === 'image_winter') return 'text_winter';
      if(modeKey === 'kids_image') return 'kids_text';
      if(modeKey === 'image_distressed') return 'text_distressed';
      if(modeKey === 'image_two_tone') return 'text_two_tone';
      /* tshirt_image -> tshirt_text, hoodie_image -> hoodie_text, apparel_image -> apparel_text */
      if(isApparel && /_image$/.test(modeKey)) return modeKey.replace(/_image$/, '_text');
      return 'text_washed';
    }

    function placementContentKind(p){
      if(!isImageMixed) return kind;
      // CAPKOV: front placement now supports the text/image toggle like the others.
      var st = state.byPlacement[p];
      var ck = st && st.contentKind ? String(st.contentKind) : 'image';
      return (ck === 'text') ? 'text' : 'image';
    }

    function effectiveKind(){
      return placementContentKind(activePlacement());
    }
    try{
      if(isImageMixed){
        // CAPKOV: front placement is now switchable too. Default kind = 'image' for all
        // placements (only if not previously set), but the customer can flip to 'text'.
        ['front','back','side_left','side_right'].forEach(function(pp){
          if(state.byPlacement[pp] && !state.byPlacement[pp].contentKind) state.byPlacement[pp].contentKind = 'image';
        });
      }
    }catch(e){}
    function syncInstructions(){
      if(!instructionsEl) return;

      var eff = effectiveKind();
      var useKey = modeKey;
      if(isImageMixed && eff === 'text'){
        useKey = isTote ? 'tote_text' : textModeKeyForCurrentProduct();
      }

      var ins = (config.instructions && config.instructions[useKey]) ? String(config.instructions[useKey]) : '';
      if(!ins){
        if(eff==='text') ins = RT('n.0c21b75', 'Napiš text a vyber umístění.');
        if(eff==='image') ins = RT('n.9c5a9d8', 'Nahraj obrázek/PDF a dolaď v rámečku.');
        if(eff==='color') ins = RT('n.64f5aed', 'Vyber barvu nitě.');
      }
      instructionsEl.textContent = ins;
    }
    /* qafix: vlastní písmo se kreslí jeho skutečnou tloušťkou (400 z FontFace); 800/900 přidávalo umělé ztučnění a náhled byl tlustší než výšivka. Systémová záloha zůstává tučná. */
    function embW(fam){
      try{ var f = String(fam||'').trim(); if(window.__capkov_loaded_fonts && window.__capkov_loaded_fonts[f]) return '400'; }catch(e){}
      return '800';
    }
    function ensureFontLoaded(fontObj){
      if(!fontObj) return Promise.resolve(false);
      if(typeof fontObj === 'string'){
        var fam = String(fontObj || '').trim();
        if(!fam) return Promise.resolve(false);
        var found = null;
        var list = fonts || capkovConfig.fonts || [];
        for(var i=0;i<list.length;i++){
          if(list[i] && String(list[i].family||'').trim() === fam){
            found = list[i];
            break;
          }
        }
        if(found) fontObj = found;
        else return Promise.resolve(false);
      }

      var family = String(fontObj.family || '').trim();
      var url = String(fontObj.url || fontObj.src || '').trim();
      if(!family || !url) return Promise.resolve(false);
      if(window.__capkov_loaded_fonts && window.__capkov_loaded_fonts[family]) return Promise.resolve(true);
      window.__capkov_loaded_fonts = window.__capkov_loaded_fonts || {};
      // CAPKOV FONT FIX: dedup in-flight loads — repeated preview renders must not
      // spawn a new FontFace fetch each frame while the first one is still loading.
      window.__capkov_loading_fonts = window.__capkov_loading_fonts || {};
      if(window.__capkov_loading_fonts[family]) return window.__capkov_loading_fonts[family];
      try{
        var ff = new FontFace(family, 'url(' + url + ')', { style: fontObj.style || 'normal', weight: fontObj.weight || '400' });
        var loadPromise = ff.load().then(function(loaded){
          try{ document.fonts.add(loaded); }catch(e){}
          window.__capkov_loaded_fonts[family] = true;
          try{ delete window.__capkov_loading_fonts[family]; }catch(e){}
          try{ if(typeof renderPreview === 'function'){ renderPreview(); } }catch(e){}
          return true;
        }).catch(function(){
          try{ delete window.__capkov_loading_fonts[family]; }catch(e){}
          return false;
        });
        window.__capkov_loading_fonts[family] = loadPromise;
        return loadPromise;
      }catch(e){
        return Promise.resolve(false);
      }
    }

    // CAPKOV FONT FIX: warm up every configured webfont as soon as the builder opens,
    // so the first preview draw doesn't race the font download.
    function preloadBuilderFonts(){
      try{
        var list = (Array.isArray(fonts) && fonts.length) ? fonts : ((capkovConfig && Array.isArray(capkovConfig.fonts)) ? capkovConfig.fonts : []);
        list.forEach(function(f){
          if(!f) return;
          var fam = String(f.family || '').trim();
          var u = String(f.url || f.src || '').trim();
          if(fam && u) ensureFontLoaded({ family: fam, url: u, weight: f.weight, style: f.style });
        });
      }catch(e){}
    }

    function buildFontOptions(){
      var items = [];
      if(Array.isArray(fonts) && fonts.length){
        items = fonts.slice();
      } else if(fallbackFontsCsv){
        items = fallbackFontsCsv.split(',').map(function(x){ return { category: RT('n.26a8080', 'Základní'), label: x.trim(), family: x.trim(), url: '' }; }).filter(function(x){ return x.family; });
      }
      items = items.map(function(f){
        var sizePct = 100;
        var sizeSmallPct = null;
        var sizeLargePct = null;
        try{
          var rawSize = (f && (f.size_pct != null ? f.size_pct : (f.size != null ? f.size : (f.default_size != null ? f.default_size : (f.scale != null ? f.scale : 100)))));
          var n = parseFloat(rawSize);
          if(isFinite(n) && n > 0) sizePct = n;
          var rawSmall = (f && (f.size_small_pct != null ? f.size_small_pct : (f.small_size_pct != null ? f.small_size_pct : (f.size_small != null ? f.size_small : null))));
          var ns = parseFloat(rawSmall);
          if(isFinite(ns) && ns > 0) sizeSmallPct = ns;
          var rawLarge = (f && (f.size_large_pct != null ? f.size_large_pct : (f.large_size_pct != null ? f.large_size_pct : (f.size_large != null ? f.size_large : null))));
          var nl = parseFloat(rawLarge);
          if(isFinite(nl) && nl > 0) sizeLargePct = nl;
        }catch(e){}
        sizePct = Math.max(50, Math.min(200, sizePct));
        if(sizeSmallPct == null) sizeSmallPct = Math.round(sizePct * 0.85);
        if(sizeLargePct == null) sizeLargePct = Math.round(sizePct * 1.15);
        sizeSmallPct = Math.max(50, Math.min(200, sizeSmallPct));
        sizeLargePct = Math.max(50, Math.min(200, sizeLargePct));

        return {
          category: String(f.category || RT('n.26465df', 'Fonty')).trim(),
          label: String(f.label || f.name || f.family || '').trim(),
          family: String(f.family || '').trim(),
          url: String(f.url || f.src || '').trim(),
          size_pct: sizePct,
          size_small_pct: sizeSmallPct,
          size_large_pct: sizeLargePct,
          weight: f.weight,
          style: f.style
        };
      }).filter(function(f){ return f.label && f.family; });
      var groups = {};
      var catOrder = [];
      items.forEach(function(f){
        var cat = (f && f.category) ? f.category : '';
        if(!groups[cat]){
          groups[cat] = [];
          catOrder.push(cat);
        }
        groups[cat].push(f);
      });

      if(!fontSelect) return;
      fontSelect.innerHTML = '';

      catOrder.forEach(function(cat){
        var og = document.createElement('optgroup');
        og.label = cat;
        groups[cat].forEach(function(f){
          var opt = document.createElement('option');
          opt.value = f.family;
          opt.textContent = f.label;
          opt.setAttribute('data-font-url', f.url);
          opt.setAttribute('data-font-family', f.family);
          opt.setAttribute('data-font-size-pct', String(f.size_pct || 100));
          opt.setAttribute('data-font-size-small-pct', String(f.size_small_pct || Math.round((f.size_pct || 100)*0.85)));
          opt.setAttribute('data-font-size-large-pct', String(f.size_large_pct || Math.round((f.size_pct || 100)*1.15)));
          og.appendChild(opt);
        });
        fontSelect.appendChild(og);
      });
      if(!fontSelect.value){
        var firstOpt = fontSelect.querySelector('option');
        if(firstOpt) fontSelect.value = firstOpt.value;
      }
      if(defaultFontUrl){
        ensureFontLoaded({ family: 'CapkovDefault', url: defaultFontUrl, weight:'900', style:'normal' });
      }
    }
    function fontSizePctForFamily(family){
      var fam = String(family || '').trim();
      if(!fam) return 100;

      var pct = 100;
      try{
        if(fontSelect){
          var opt = fontSelect.querySelector('option[value="' + cssEscape(fam) + '"]');
          if(opt){
            var raw = opt.getAttribute('data-font-size-pct') || opt.getAttribute('data-font-size') || '';
            var n = parseFloat(raw);
            if(isFinite(n) && n > 0) pct = n;
          }
        }
      }catch(e){}
      if(pct == 100 && Array.isArray(fonts) && fonts.length){
        try{
          for(var i=0;i<fonts.length;i++){
            var f = fonts[i];
            if(!f) continue;
            if(String(f.family || '').trim() === fam){
              var raw2 = (f.size_pct != null ? f.size_pct : (f.size != null ? f.size : 100));
              var n2 = parseFloat(raw2);
              if(isFinite(n2) && n2 > 0) pct = n2;
              break;
            }
          }
        }catch(e){}
      }

      pct = Math.max(50, Math.min(200, pct));
      return pct || 100;
    }
    function fontSizePctForFamilyTier(family, tier){
      var fam = String(family || '').trim();
      if(!fam) return 100;
      var t = String(tier || 'm').toLowerCase();
      if(t !== 's' && t !== 'm' && t !== 'l') t = 'm';
      if(t === 'm') return fontSizePctForFamily(fam);

      var attr = (t === 's') ? 'data-font-size-small-pct' : 'data-font-size-large-pct';
      var pct = null;

      try{
        if(fontSelect){
          var opt = fontSelect.querySelector('option[value="' + cssEscape(fam) + '"]');
          if(opt){
            var raw = opt.getAttribute(attr) || '';
            var n = parseFloat(raw);
            if(isFinite(n) && n > 0) pct = n;
          }
        }
      }catch(e){}

      if(pct == null && Array.isArray(fonts) && fonts.length){
        try{
          for(var i=0; i<fonts.length; i++){
            var f = fonts[i];
            if(!f) continue;
            if(String(f.family || '').trim() === fam){
              var raw2 = (t === 's')
                ? (f.size_small_pct != null ? f.size_small_pct : (f.small_size_pct != null ? f.small_size_pct : null))
                : (f.size_large_pct != null ? f.size_large_pct : (f.large_size_pct != null ? f.large_size_pct : null));
              var n2 = parseFloat(raw2);
              if(isFinite(n2) && n2 > 0) pct = n2;
              break;
            }
          }
        }catch(e){}
      }

      if(pct == null){
        var base = fontSizePctForFamily(fam);
        pct = (t === 's') ? Math.round(base * 0.85) : Math.round(base * 1.15);
      }

      pct = Math.max(50, Math.min(200, pct));
      return pct || 100;
    }
    var THREAD_COLOR_EN = {
      'bila': 'White',
      'white': 'White',
      'cerna': 'Black',
      'black': 'Black',
      'svetle modra': 'Light blue',
      'light blue': 'Light blue',
      'tmave zelena': 'Dark green',
      'dark green': 'Dark green',
      'modra': 'Blue',
      'blue': 'Blue',
      'azurove modra': 'Azure blue',
      'azure blue': 'Azure blue',
      'svetle zelena': 'Light green',
      'light green': 'Light green',
      'stribrna': 'Silver',
      'silver': 'Silver',
      'oranzova': 'Orange',
      'orange': 'Orange',
      'vinova': 'Burgundy',
      'burgundy': 'Burgundy',
      'seda': 'Grey',
      'grey': 'Grey',
      'gray': 'Grey',
      'cervena': 'Red',
      'red': 'Red',
      'zlata': 'Gold',
      'gold': 'Gold',
      'hneda': 'Brown',
      'brown': 'Brown',
      'bronzova': 'Bronze',
      'bronze': 'Bronze',
      'zluta': 'Yellow',
      'yellow': 'Yellow',
      'ruzova': 'Pink',
      'pink': 'Pink',
      'fialova': 'Purple',
      'purple': 'Purple'
    };

    /* Shopify translates the thread-colour CSV per locale, so an English order records
       "Gold" while production works from the Czech list and someone has to rewrite it by
       hand after every order. Keep a canonical Czech name for the order properties. */
    var THREAD_COLOR_CS = {
      'white':'Bílá','bila':'Bílá',
      'black':'Černá','cerna':'Černá',
      'light blue':'Světle modrá','svetle modra':'Světle modrá',
      'dark green':'Tmavě zelená','tmave zelena':'Tmavě zelená',
      'blue':'Modrá','modra':'Modrá',
      'azure blue':'Azurově modrá','azurove modra':'Azurově modrá',
      'light green':'Světle zelená','svetle zelena':'Světle zelená',
      'silver':'Stříbrná','stribrna':'Stříbrná',
      'orange':'Oranžová','oranzova':'Oranžová',
      'burgundy':'Vínová','vinova':'Vínová',
      'grey':'Šedá','gray':'Šedá','seda':'Šedá',
      'red':'Červená','cervena':'Červená',
      'gold':'Zlatá','zlata':'Zlatá',
      'brown':'Hnědá','hneda':'Hnědá',
      'bronze':'Bronzová','bronzova':'Bronzová',
      'yellow':'Žlutá','zluta':'Žlutá',
      'pink':'Růžová','ruzova':'Růžová',
      'purple':'Fialová','fialova':'Fialová'
    };

    function toCzechThreadColor(label){
      var nk = normalizeKey(label);
      return THREAD_COLOR_CS[nk] || String(label || '').trim();
    }

    function toEnglishThreadColor(label){
      var nk = normalizeKey(label);
      return THREAD_COLOR_EN[nk] || String(label||'').trim();
    }

    /* 19. 10.: data-color a vlastnosti objednavky zustavaji kanonicke; preklad jen pro zobrazeni (config.thread_labels mimo cs/en). */
    function threadDisplayLabel(c){
      var m = (config && config.thread_labels) || {};
      var k = normalizeKey(toEnglishThreadColor(c));
      return m[k] || m[normalizeKey(c)] || String(c || '');
    }

    function normalizeThreadColorLabel(label){
      if(isEn) return toEnglishThreadColor(label);
      return String(label||'').trim();
    }

    function parseThreadColors(){
      var csv = threadColorsCsv;
      var fallback = isEn ? ['White','Black'] : ['Bílá','Černá'];
      if(!csv) return fallback;
      var out = [];
      csv.split(',').forEach(function(x){
        var v = normalizeThreadColorLabel(x);
        if(!v) return;
        if(out.indexOf(v) >= 0) return;
        out.push(v);
      });

      return out.length ? out : fallback;
    }

    function findThreadColorByEnglish(list, englishName){
      var target = normalizeKey(englishName);
      for(var i=0; i<(list||[]).length; i++){
        var c = list[i];
        if(normalizeKey(toEnglishThreadColor(c)) === target) return c;
      }
      return '';
    }

    function toteBagColorKey(){
      try{
        var idx = state && typeof state.swatchIndex === 'number' ? state.swatchIndex : -1;
        if(idx >= 0 && idx < swatches.length){
          var sw = swatches[idx] || {};
          return normalizeKey(sw.option_value || sw.label || '');
        }
      }catch(e){}
      return '';
    }

    function preferredToteThreadColor(list){
      list = list || [];
      if(!list.length) return '';
      var bag = toteBagColorKey();
      var isBagBlack = (bag.indexOf('cerna') >= 0 || bag.indexOf('black') >= 0);
      var isBagWhite = (bag.indexOf('bila') >= 0 || bag.indexOf('white') >= 0);

      if(isBagBlack){
        return findThreadColorByEnglish(list, 'White') || list[0];
      }
      if(isBagWhite){
        return findThreadColorByEnglish(list, 'Black') || list[0];
      }
      return findThreadColorByEnglish(list, 'Black') || list[0];
    }

    function maybeAutoSetToteThreadColor(list){
      if(!isTote && !isSocks) return;
      list = list || parseThreadColors();
      ['front','back'].forEach(function(p){
        var st = state && state.byPlacement ? state.byPlacement[p] : null;
        if(!st) return;
        if(st._threadTouched) return;
        var pref = preferredToteThreadColor(list);
        if(pref && list.indexOf(pref) >= 0){
          st.threadColor = pref;
        }
      });
    }

    function isNoFeeColor(c){
      var canon = toEnglishThreadColor(c);
      var k = normalizeKey(canon);
      return (k === 'white' || k === 'black');
    }

    function threadColorHex(label){
      var k = normalizeKey(toEnglishThreadColor(label));
      var map = {
        'white': '#ffffff',
        'black': '#111111',
        'light blue': '#7db7ff',
        'dark green': '#0b6b3a',
        'blue': '#207bc5',
        'azure blue': '#207bc5',
        'light green': '#79e865',
        'silver': '#c4c8cd',
        'orange': '#f47c20',
        'burgundy': '#6b0f2a',
        'grey': '#8f969e',
        'red': '#c0191a',
        'gold': '#caa23a',
        'brown': '#9a6b3a',
        'bronze': '#9a6b3a',
        'yellow': '#f2c500',
        'pink': '#f15aa5',
        'purple': '#7a4de8'
      };
      return map[k] || '#dddddd';
    }

    function updateSelectedColorPill(){
      var st = activeState(); if(selectedColorEl) selectedColorEl.textContent = (st && st.threadColor) ? threadDisplayLabel(st.threadColor) : '';
    }

    var autoApplyTimer = null;
    function scheduleAutoApply(){
      if(kind !== 'color') return;
      try{ if(autoApplyTimer) clearTimeout(autoApplyTimer); }catch(e){}
      autoApplyTimer = setTimeout(function(){
        try{ applyToFormAndExtras(); }catch(e){}
      }, 250);
    }

    function renderThreadColors(){
      if(!colorsEl) return;
      var eff = effectiveKind();
      if(kind !== 'color' && eff !== 'text') return;
      var list = parseThreadColors();
      colorsEl.innerHTML = '';
      if(!list.length) list = (isEn ? ['White','Black'] : ['Bílá','Černá']);

      var st = activeState();
      if(!st) st = state.byPlacement.front;
      if(!st.threadColor || list.indexOf(st.threadColor) === -1){
        st.threadColor = (isTote || isSocks) ? (preferredToteThreadColor(list) || list[0]) : list[0];
      }else if((isTote || isSocks) && !st._threadTouched){
        var pref0 = preferredToteThreadColor(list);
        if(pref0 && list.indexOf(pref0) >= 0){
          st.threadColor = pref0;
        }
      }

      list.forEach(function(c){
        var paid = !isNoFeeColor(c);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'capkov-b2__color';
        btn.setAttribute('data-color', c);
        btn.setAttribute('data-active', (c === st.threadColor) ? 'true' : 'false');
        var dot = document.createElement('span');
        dot.className = 'capkov-b2__dot';
        dot.style.setProperty('--capkov-dot', threadColorHex(c));

        var label = document.createElement('span');
        label.className = 'capkov-b2__color-label';
        label.textContent = threadDisplayLabel(c);

        btn.appendChild(dot);
        btn.appendChild(label);

        if(paid && fees && fees.color){
          var fee = document.createElement('span');
          fee.className = 'capkov-b2__color-fee';
          fee.textContent = formatFee(fees.color);
          btn.appendChild(fee);
        }

        btn.addEventListener('click', function(){
          st.threadColor = c;
          try{ st._threadTouched = true; }catch(e){}
          renderThreadColors();
          updatePricesUI();
          renderPreview();
          if(kind === 'color'){
            try{ applyToFormAndExtras(); }catch(e){ scheduleAutoApply(); }
          }
        });

        colorsEl.appendChild(btn);
      });

      updateSelectedColorPill();
      updatePricesUI();
    }

    /* Apparel placements can each carry their own fee, so the header/note text has to
       summarise them instead of printing the single global "placement fee". */
    function extraPlacementFeeText(){
      if(!isApparel) return formatFee(fees.placement || 100);
      var vals = [];
      PLACEMENTS.forEach(function(p){
        if(p === PLACEMENTS[0]) return;
        var f = apparelFeeFor(p);
        if(vals.indexOf(f) < 0) vals.push(f);
      });
      if(!vals.length) return formatFee(fees.placement || 100);
      if(vals.length === 1) return formatFee(vals[0]);
      vals.sort(function(a,b){ return a - b; });
      return RT('n.a96c64a', 'od') + ' ' + formatFee(vals[0]);
    }

    function updatePricesUI(){
      if(colorPriceEl){
        var paid = !isNoFeeColor((activeState() && activeState().threadColor) ? activeState().threadColor : "");
        if(paid) colorPriceEl.textContent = formatFee(fees.color || 50);
        else colorPriceEl.textContent = RT('n.7103807', 'zdarma');
      }
      if(placementPriceEl){
        if(isTote){
          placementPriceEl.textContent = '';
          placementPriceEl.style.display = 'none';
        }else{
        var hasExtraPlacementFee = !((typeof PLACEMENTS !== 'undefined' && PLACEMENTS.length <= 1));
        if(!hasExtraPlacementFee){
          placementPriceEl.textContent = '';
          placementPriceEl.style.display = 'none';
        }else{
          placementPriceEl.style.display = '';
          placementPriceEl.textContent = extraPlacementFeeText() + ' / ' + RT('n.f1cd2dd', 'další');
        }
        }
      }
      if(placementNoteEl){
        if(isTote){
          placementNoteEl.hidden = true;
          placementNoteEl.textContent = '';
        }else{
        if((kind === 'image' || kind === 'text') && (typeof PLACEMENTS === 'undefined' || PLACEMENTS.length > 1)){
          placementNoteEl.hidden = false;
          placementNoteEl.textContent = RT('n.2363fb8', 'Druhé a další umístění {0}').replace('{0}', extraPlacementFeeText());
        }else{
          placementNoteEl.hidden = true;
          placementNoteEl.textContent = '';
        }
        }
      }
    }
    function getDefaultPreviewSrc(mode, placement){
      var m = previewByMode[mode] || {};
      var leg = previewByMode.legacy || {};
      var src = '';
      if(isApparel){
        var apHere = apparelFor(placement);
        if(apHere && apHere.preview) return apHere.preview;
        var apFallback = config.apparel || {};
        if(placement === 'back' && apFallback.fallback_back) return String(apFallback.fallback_back);
        var apFront = apparelFor('front');
        if(apFront && apFront.preview) return String(apFront.preview);
        if(apFallback.fallback_front) return String(apFallback.fallback_front);
        return String(m.front || leg.front || '');
      }
      if(mode === 'text_socks') return String(m.front || '');
      if(mode === 'text_winter' || mode === 'image_winter'){
        src = m.front || leg.winter || leg.front || '';
        return src;
      }

      if(placement === 'front'){
        src = m.front || leg.front || '';
        return src;
      }

      if(placement === 'back'){
        src = m.back || leg.back || m.front || leg.front || '';
        return src;
      }

      if(placement === 'side_left'){
        src = m.side_left || m.side || m.side_right || leg.side || m.front || leg.front || '';
        return src;
      }

      if(placement === 'side_right'){
        src = m.side_right || m.side || m.side_left || leg.side || m.front || leg.front || '';
        return src;
      }
      src = m[placement] || m.front || leg.front || '';
      return src;
    }

    function swatchImageFor(mode, placement, sw){
      if(!sw) return '';
      if(isWinter && placement === 'back') placement = 'front';   /* zadek zimní čepice = stejné fotky jako předek */
      var modeKeys = [];
      try{
        modeKeys.push(String(mode||''));
        if(config && config.builder_mode) modeKeys.push(String(config.builder_mode));
      }catch(e){}
      var alias = String(mode||'');
      if(alias === 'text_non_washed') modeKeys.push('Text Non Washed');
      if(alias === 'text_washed') modeKeys.push('Text Washed');
      if(alias === 'color_change') modeKeys.push('Změna Barvy');
      if(alias === 'text_socks') modeKeys.push('Ponožky Text', 'Socks Text');
      if(alias === 'text_winter') modeKeys.push('Text Zimní');
      if(alias === 'image_winter') modeKeys.push('Obrázek Zimní');
      if(alias === 'image_washed') modeKeys.push('Obrázek Washed');
      if(alias === 'image_non_washed') modeKeys.push('Obrázek Non Washed');
      if(alias === 'tote_text'){
        modeKeys.push('Tote Bag Text');
        modeKeys.push('Tote Text');
        modeKeys.push('Taška Text');
      }
      if(alias === 'tote_image'){
        modeKeys.push('Tote Bag Obrazek');
        modeKeys.push('Tote Bag Obrázek');
        modeKeys.push('Tote Bag Image');
        modeKeys.push('Tote Obrazek');
        modeKeys.push('Tote Image');
        modeKeys.push('Taška Obrázek');
      }
      if(alias === 'kids_text'){
        modeKeys.push('Kids Text');
      }
      if(alias === 'text_distressed'){
        modeKeys.push('Text Distressed');
        modeKeys.push('Distressed Text');
      }
      if(alias === 'image_distressed'){
        modeKeys.push('Image Distressed');
        modeKeys.push('Obrazek Distressed');
        modeKeys.push('Obrázek Distressed');
        modeKeys.push('Distressed Image');
        modeKeys.push('Distressed Obrazek');
        modeKeys.push('Distressed Obrázek');
      }
      if(alias === 'kids_image'){
        modeKeys.push('Kids Obrazek');
        modeKeys.push('Kids Obrázek');
        modeKeys.push('Kids Image');
      }
      if(alias === 'tshirt_text'){
        modeKeys.push('Trika Text'); modeKeys.push('Trička Text'); modeKeys.push('Tshirt Text');
      }
      if(alias === 'tshirt_image'){
        modeKeys.push('Trika Obrazek'); modeKeys.push('Trika Obrázek');
        modeKeys.push('Trička Obrázek'); modeKeys.push('Tshirt Image');
      }
      if(alias === 'hoodie_text'){
        modeKeys.push('Mikiny Text'); modeKeys.push('Mikina Text'); modeKeys.push('Hoodie Text');
      }
      if(alias === 'hoodie_image'){
        modeKeys.push('Mikiny Obrazek'); modeKeys.push('Mikiny Obrázek');
        modeKeys.push('Mikina Obrázek'); modeKeys.push('Hoodie Image');
      }
      if(alias === 'apparel_text'){
        modeKeys.push('Oblečení Text'); modeKeys.push('Apparel Text');
      }
      if(alias === 'apparel_image'){
        modeKeys.push('Oblečení Obrázek'); modeKeys.push('Apparel Image');
      }
      var seen = {};
      modeKeys = modeKeys.map(function(x){ return String(x||'').trim(); }).filter(function(x){ return x && !seen[x] && (seen[x]=true); });
      try{
        if(sw.images){
          for(var i=0;i<modeKeys.length;i++){
            var mk = modeKeys[i];
            if(sw.images[mk]){
              if(sw.images[mk][placement]) return String(sw.images[mk][placement]||'');
              if((placement === 'side_left' || placement === 'side_right') && sw.images[mk].side) return String(sw.images[mk].side||'');
              if(sw.images[mk].front && placement === 'front') return String(sw.images[mk].front||'');
            }
          }
        }
      }catch(e){}
      var key = '';
      if(placement === 'front') key = 'img_front';
      if(placement === 'back') key = 'img_back';
      if(placement === 'side_left') key = 'img_side_left';
      if(placement === 'side_right') key = 'img_side_right';

      if(key && sw[key]) return String(sw[key]||'');
      if((placement === 'side_left' || placement === 'side_right') && sw.img_side) return String(sw.img_side||'');
      if(placement === 'front' && sw.img_winter && (mode === 'text_winter' || mode === 'image_winter')) return String(sw.img_winter||'');
      try{
        if(sw.images && sw.images.default){
          if(sw.images.default[placement]) return String(sw.images.default[placement]||'');
          if((placement === 'side_left' || placement === 'side_right') && sw.images.default.side) return String(sw.images.default.side||'');
        }
      }catch(e){}

      return '';
    }

    /* ---------------------------------------------------------------------------
       SIZE PICKER
       Entirely derived from the product the modal was opened from: the option list,
       its values and their availability all come from config.product. No theme
       settings involved, and the row stays hidden unless the product really has a
       size option with more than one value (caps/totes are unaffected).
       --------------------------------------------------------------------------- */
    function findSizeOptionIndex(){
      var names = (product.options || []).map(function(n){ return normalizeKey(n); });
      for(var i = 0; i < names.length; i++){
        var n = names[i];
        if(n.indexOf('velikost') !== -1 || n.indexOf('size') !== -1 || n.indexOf('rozmer') !== -1 || n.indexOf('grosse') !== -1) return i;
      }
      return -1;
    }

    function sizeOptionValues(){
      var si = findSizeOptionIndex();
      if(si < 0) return [];
      var out = [], seen = {};
      (product.variants || []).forEach(function(v){
        if(!v || !Array.isArray(v.options)) return;
        var val = String(v.options[si] || '').trim();
        if(!val) return;
        var k = normalizeKey(val);
        if(seen[k]) return;
        seen[k] = true;
        out.push(val);
      });
      return out;
    }

    function hasSizePicker(){
      return sizeOptionValues().length > 1;
    }

    function currentVariantObj(){
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var id = getVariantIdFromForm();
      return variants.find(function(v){ return String(v.id) === String(id); }) || variants[0] || null;
    }

    function currentSizeValue(){
      var si = findSizeOptionIndex();
      if(si < 0) return '';
      if(state.size) return state.size;
      var cur = currentVariantObj();
      return (cur && Array.isArray(cur.options)) ? String(cur.options[si] || '') : '';
    }

    /* Match on size + the colour currently chosen in the builder, keeping any other option. */
    function variantForSize(sizeVal){
      var si = findSizeOptionIndex();
      if(si < 0) return null;
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var cur = currentVariantObj();
      var target = (cur && Array.isArray(cur.options)) ? cur.options.slice() : [];
      if(!target.length) return null;
      target[si] = sizeVal;

      /* The colour comes from the variant the form is on — real product data that is
         never translated. Using the swatch label here made every size read as sold out
         on /en/, where the label is "Black" but the variant says "Černá". */
      return variants.find(function(v){
        if(!Array.isArray(v.options)) return false;
        for(var i = 0; i < target.length; i++){
          if(normalizeKey(v.options[i] || '') !== normalizeKey(target[i] || '')) return false;
        }
        return true;
      }) || null;
    }

    function renderSizes(){
      if(!sizeRow || !sizeTabsEl) return;
      var vals = sizeOptionValues();
      if(vals.length < 2){ sizeRow.hidden = true; return; }
      sizeRow.hidden = false;

      var si = findSizeOptionIndex();
      if(sizeLabelEl && si >= 0 && product.options && product.options[si]){
        sizeLabelEl.textContent = String(product.options[si]);
      }

      var active = currentSizeValue();
      if(!active || vals.map(normalizeKey).indexOf(normalizeKey(active)) < 0) active = vals[0];
      state.size = active;

      sizeTabsEl.innerHTML = '';
      vals.forEach(function(val){
        var v = variantForSize(val);
        var avail = !!(v && v.available !== false);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'capkov-b2__tab';
        btn.textContent = window.capkovOptLabel ? window.capkovOptLabel(val) : val;
        btn.setAttribute('data-capkov-size', val);
        btn.setAttribute('data-sold-out', avail ? 'false' : 'true');
        btn.setAttribute('data-active', (normalizeKey(val) === normalizeKey(active)) ? 'true' : 'false');
        if(!avail){
          try{ btn.setAttribute('aria-label', btn.textContent + ' ' + RT('n.c0db53d', '— vyprodáno')); }catch(e){}
        }
        btn.addEventListener('click', function(){
          state.size = val;
          var vv = variantForSize(val);
          if(vv) scheduleVariantSet(vv);
          renderSizes();
        });
        sizeTabsEl.appendChild(btn);
      });

      if(sizeNoteEl){
        var sel = variantForSize(active);
        var soldOut = !(sel && sel.available !== false);
        sizeNoteEl.textContent = soldOut ? RT('n.6cb883d', 'V této barvě vyprodáno') : '';
      }
    }

    /* Blocks save/add-to-cart on a combination that can't be bought. */
    function sizeSelectionError(){
      if(!hasSizePicker()) return '';
      var val = currentSizeValue();
      if(!val) return RT('n.145e76d', 'Vyber velikost.');
      var v = variantForSize(val);
      if(!v) return RT('n.e184d0d', 'Tato velikost není v této barvě dostupná.');
      if(v.available === false) return RT('n.77bad29', 'Vybraná velikost je vyprodaná.');
      return '';
    }

    function currentSwatch(){
      if(state.swatchIndex < 0 || state.swatchIndex >= swatches.length) return null;
      return swatches[state.swatchIndex];
    }

    function getBaseImageSrc(){
      var placement = activePlacement();
      var sw = currentSwatch();
      var src = swatchImageFor(modeKey, placement, sw);
      if(!src) src = getDefaultPreviewSrc(modeKey, placement);
      return src;
    }
    function getForm(){
      if(productFormId){
        var f = document.getElementById(productFormId);
        if(f && f.tagName && f.tagName.toLowerCase() === 'form') return f;
      }
      var closest = root.closest('form[is="product-form"]');
      if(closest) return closest;
      var sec = root.closest('.shopify-section') || document;
      var f2 = sec.querySelector('form[is="product-form"]');
      return f2 || null;
    }

    function getVariantIdFromForm(){
      var form = getForm();
      if(!form) return '';
      var idInput = form.querySelector('input[name="id"]');
      return idInput ? String(idInput.value||'').trim() : '';
    }

    function findColorOptionIndex(){
      var names = (product.options || []).map(function(n){ return String(n||'').toLowerCase(); });
      var idx = names.findIndex(function(n){ return n.indexOf('color')!==-1 || n.indexOf('colour')!==-1 || n.indexOf('barva')!==-1; });
      return (idx >= 0) ? idx : 0;
    }

    /* Shopify translates the swatch blocks but NOT the variants' colour values, so on
       /en/ a swatch says "Black" while every variant still says "Černá". Name matching
       then finds nothing: colour clicks stop moving the variant and every size looks
       sold out. Swatches are authored in the same order as the product's colours, so
       position is the reliable fallback. */
    function distinctColorValues(){
      var ci = findColorOptionIndex();
      var out = [], seen = {};
      (product.variants || []).forEach(function(v){
        if(!v || !Array.isArray(v.options)) return;
        var val = String(v.options[ci] || '');
        var k = normalizeKey(val);
        if(!val || seen[k]) return;
        seen[k] = true;
        out.push(val);
      });
      return out;
    }

    /* Resolve a swatch to a real variant colour: id -> exact name -> contains -> position. */
    function colorValueForSwatch(sw){
      if(!sw) return '';
      var ci = findColorOptionIndex();
      var variants = Array.isArray(product.variants) ? product.variants : [];

      if(sw.variant_id){
        var byId = variants.find(function(v){ return String(v.id) === String(sw.variant_id); });
        if(byId && Array.isArray(byId.options)) return String(byId.options[ci] || '');
      }

      var wanted = normalizeKey(sw.option_value || sw.value || sw.label || '');
      var colors = distinctColorValues();
      if(wanted){
        var exact = colors.find(function(c){ return normalizeKey(c) === wanted; });
        if(exact) return exact;
        var loose = colors.find(function(c){
          var n = normalizeKey(c);
          return n.indexOf(wanted) !== -1 || wanted.indexOf(n) !== -1;
        });
        if(loose) return loose;
      }

      var idx = swatches.indexOf(sw);
      if(idx >= 0 && idx < colors.length) return colors[idx];
      return '';
    }

    function findVariantBySwatch(sw){
      if(!sw) return null;
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var currentId = getVariantIdFromForm();
      var current = variants.find(function(v){ return String(v.id) === String(currentId); }) || variants[0] || null;
      if(sw.variant_id){
        var hit = variants.find(function(v){ return String(v.id) === String(sw.variant_id); });
        if(hit) return hit;
      }

      var optValue = colorValueForSwatch(sw) || sw.option_value || sw.value || sw.label;
      if(!optValue) return null;

      var colorIndex = findColorOptionIndex();
      var wanted = String(optValue);
      var wantedNorm = normalizeKey(wanted);
      if(current && Array.isArray(current.options)){
        var targetOpts = current.options.slice();
        targetOpts[colorIndex] = wanted;
        var exact = variants.find(function(v){
          if(!Array.isArray(v.options)) return false;
          for(var i=0;i<targetOpts.length;i++){
            if(i === colorIndex){
              if(normalizeKey(v.options[i]||'') !== wantedNorm) return false;
            }else{
              if(String(v.options[i]||'') !== String(targetOpts[i]||'')) return false;
            }
          }
          return true;
        });
        if(exact) return exact;
      }
      var any = variants.find(function(v){
        if(!Array.isArray(v.options)) return false;
        return normalizeKey(v.options[colorIndex]||'') === wantedNorm;
      });
      return any || null;
    }

    function setVariant(variant){
      if(!variant) return;
      var form = getForm();
      if(!form) return;

      var idInput = form.querySelector('input[name="id"]');
      if(idInput){
        var nextId = String(variant.id);
        if(String(idInput.value || '') !== nextId){
          idInput.value = nextId;
          try{ idInput.dispatchEvent(new Event('change', { bubbles:true })); }catch(e){}
          try{ idInput.dispatchEvent(new Event('input', { bubbles:true })); }catch(e){}
        }
      }
      try{
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url.toString());
      }catch(e){}
    }
    var _swatchButtons = [];
    var _swatchesBuilt = false;
    var _swatchesPrefetched = false;

    /* Products often default to a sold-out variant. Move to a buyable SIZE, but never to
       a different COLOUR: silently swapping the colour is how a customer ends up with a
       cap they did not choose. If the chosen colour is sold out in every size, leave it
       alone and let the theme show it as unavailable. */
    function ensureAvailableVariant(){
      var vs = Array.isArray(product.variants) ? product.variants : [];
      if(vs.length < 2) return;
      var cur = null;
      try{ cur = currentVariantObj(); }catch(e){ cur = null; }
      if(!cur || cur.available !== false) return;

      var ci = findColorOptionIndex();
      var si = findSizeOptionIndex();
      /* single-option product (colour only) — nothing safe to switch to */
      if(si < 0 || si === ci) return;
      if(!Array.isArray(cur.options)) return;

      var curColor = normalizeKey(cur.options[ci] || '');
      if(!curColor) return;
      var hit = vs.find(function(v){
        return v && v.available !== false && Array.isArray(v.options) &&
               normalizeKey(v.options[ci] || '') === curColor;
      });
      if(!hit) return;
      try{ state.size = ''; }catch(e){}
      setVariant(hit);
    }

    function determineActiveSwatchIndex(){
      var currentId = getVariantIdFromForm();
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var currentVar = variants.find(function(v){ return String(v.id) === String(currentId); });
      var colorIndex = findColorOptionIndex();
      var currentColor = (currentVar && currentVar.options && currentVar.options[colorIndex]) ? String(currentVar.options[colorIndex]) : '';
      var currentColorNorm = normalizeKey(currentColor);

      var idx = swatches.findIndex(function(sw){
        if(sw && sw.variant_id && String(sw.variant_id) === String(currentId)) return true;
        var ov = (sw && (sw.option_value || sw.value || sw.label)) ? String(sw.option_value || sw.value || sw.label) : '';
        if(!ov || !currentColorNorm) return false;
        return normalizeKey(ov) === currentColorNorm;
      });
      if(idx < 0 && currentColorNorm){
        /* translated storefront: fall back to the swatch whose resolved colour matches */
        idx = swatches.findIndex(function(sw){
          return normalizeKey(colorValueForSwatch(sw)) === currentColorNorm;
        });
      }
      if(idx < 0 && currentColorNorm){
        /* Swatch labels do not always equal the variant option verbatim
           ("Šedá" vs "Melírově šedá"), so fall back to a containment match
           before giving up and highlighting the first swatch. */
        idx = swatches.findIndex(function(sw){
          var ov = normalizeKey((sw && (sw.option_value || sw.value || sw.label)) || '');
          if(!ov) return false;
          return currentColorNorm.indexOf(ov) !== -1 || ov.indexOf(currentColorNorm) !== -1;
        });
      }
      if(idx < 0) idx = 0;
      return idx;
    }

    function updateSwatchActiveUI(){
      if(!_swatchButtons || !_swatchButtons.length) return;
      _swatchButtons.forEach(function(btn, i){
        try{ btn.setAttribute('data-active', (i === state.swatchIndex) ? 'true' : 'false'); }catch(e){}
      });
    }

    function prefetchSwatchImages(){
      if(_swatchesPrefetched) return;
      _swatchesPrefetched = true;
      try{
        var urls = [];
        swatches.forEach(function(sw){
          if(!sw) return;
          var sImg = sw.swatch_image || sw.swatchImage || sw.image || sw.img || '';
          if(sImg) urls.push(String(sImg));
          ['front','back','side_left','side_right'].forEach(function(pl){
            try{
              var u = swatchImageFor(modeKey, pl, sw);
              if(u) urls.push(String(u));
            }catch(e){}
          });
        });
        var seen = {};
        urls.forEach(function(u){
          if(!u || seen[u]) return;
          seen[u] = true;
          var im = new Image();
          try{ im.decoding = 'async'; }catch(e){}
          im.src = u;
        });
      }catch(e){}
    }

    var _swatchVariantTimer = 0;
    function scheduleVariantSet(variant){
      if(!variant) return;
      try{ if(_swatchVariantTimer) clearTimeout(_swatchVariantTimer); }catch(e){}
      _swatchVariantTimer = setTimeout(function(){
        try{ setVariant(variant); }catch(e){}
      }, 0);
    }

    function selectSwatch(idx, opts){
      opts = opts || {};
      if(!swatches.length) return;
      if(idx < 0) idx = 0;
      if(idx >= swatches.length) idx = swatches.length - 1;

      var changed = (idx !== state.swatchIndex);
      state.swatchIndex = idx;
      updateSwatchActiveUI();

      if(isTote || isSocks){
        try{ maybeAutoSetToteThreadColor(); }catch(e){}
        try{ renderThreadColors(); }catch(e){}
      }

      var sw = swatches[idx];
      var v = null;
      if(opts.setVariant !== false){
        try{ v = findVariantBySwatch(sw); }catch(e){ v = null; }
      }
      if(opts.render !== false){
        renderPreview();
      }
      if(v){
        scheduleVariantSet(v);
      }
      if(opts.fromClick && _swatchButtons[idx]){
        try{ _swatchButtons[idx].scrollIntoView({ block:'nearest', inline:'nearest' }); }catch(e){}
      }
      /* Availability is colour-dependent, so the size row has to be redrawn. */
      try{ renderSizes(); }catch(e){}

      return changed;
    }

    function buildSwatchesUI(){
      if(!swatchesEl || _swatchesBuilt) return;
      swatchesEl.innerHTML = '';
      _swatchButtons = [];

      swatches.forEach(function(sw, idx){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'capkov-b2__swatch';
        b.title = String((sw && (sw.label_t || sw.label || sw.option_value || '')) || '');
        b.setAttribute('aria-label', b.title);

        var swImg = sw && (sw.swatch_image || sw.swatchImage || sw.image || sw.img || '');
        var swColor = sw && (sw.swatch_color || sw.swatchColor || sw.color || sw.hex || '');
        if(swImg){
          var im = document.createElement('img');
          im.src = String(swImg);
          im.alt = b.title;
          im.decoding = 'async';
          b.appendChild(im);
        } else if(swColor){
          b.style.background = String(swColor);
        } else {
          b.style.background = '#ddd';
        }

        // CAPKOV FIX: mark sold-out variants visually (matches PDP).
        // Still clickable so PDP variant logic disables Add-to-Cart as expected.
        var __soldOut = false;
        try{
          var __v = findVariantBySwatch(sw);
          if(__v && __v.available === false) __soldOut = true;
        }catch(e){}
        if(__soldOut){
          b.setAttribute('data-sold-out', 'true');
          var __soStr = ' ' + RT('n.f3995dd', '— Vyprodáno');
          try{ b.title = b.title + __soStr; }catch(e){}
          try{ b.setAttribute('aria-label', b.title); }catch(e){}
        }

        b.addEventListener('click', function(){
          selectSwatch(idx, { fromClick:true, setVariant:true, render:true });
        });

        _swatchButtons.push(b);
        swatchesEl.appendChild(b);
      });

      _swatchesBuilt = true;
      prefetchSwatchImages();
    }

    function renderSwatches(){
      if(!swatchesEl) return;
      if(!swatches.length){
        swatchesEl.hidden = true;
        swatchesEl.innerHTML = '';
        _swatchButtons = [];
        _swatchesBuilt = false;
        return;
      }

      swatchesEl.hidden = false;
      buildSwatchesUI();
      var idx = determineActiveSwatchIndex();
      if(state.swatchIndex < 0 || state.swatchIndex >= swatches.length){
        state.swatchIndex = idx;
      } else {
        state.swatchIndex = idx;
      }
      updateSwatchActiveUI();

      if(isTote || isSocks){
        try{ maybeAutoSetToteThreadColor(); }catch(e){}
        try{ renderThreadColors(); }catch(e){}
      }

      renderPreview();
    }

    function renderTabs(){
      if(!tabsEl) return;
      var pls = PLACEMENTS.slice();
      if(isSocks || (isWinter && pls.length < 2)){
        if(placementsWrap) placementsWrap.hidden = true;
      }else{
        if(placementsWrap) placementsWrap.hidden = false;
      }

      tabsEl.innerHTML = '';
      pls.forEach(function(p){
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'capkov-b2__tab';
        if(isTote && p === 'back'){
          var feeTxt = formatFee(fees.placement || 250);
          btn.setAttribute('data-capkov-fee', 'true');
          btn.innerHTML = '<span class="capkov-b2__tab-fee">' + feeTxt + '</span><span class="capkov-b2__tab-label">' + placementLabel(p) + '</span>';
          try{ btn.setAttribute('aria-label', placementLabel(p) + ' ' + feeTxt); }catch(e){}
        }else{
          btn.textContent = placementLabel(p);
        }
        btn.setAttribute('data-placement', p);
        btn.setAttribute('data-active', (p === activePlacement()) ? 'true' : 'false');
        // Decent visual hint: green check when this placement already has content.
        try{ btn.setAttribute('data-capkov-filled', hasPlacementContent(p) ? 'true' : 'false'); }catch(e){}
        btn.addEventListener('click', function(){
          state.placement = p;
          if(kind === 'image' && fileInput){
            try{ fileInput.value = ''; }catch(e){}
          }
          try{ if(zoomResetExternal) zoomResetExternal(); }catch(e){}
          renderTabs();
          syncModeUI();
          syncUiFromState();
          renderThreadColors();
          renderPreview();
        });
        tabsEl.appendChild(btn);
      });
      try{ updatePricesUI(); }catch(e){}
    }
    // Live-update only the "has content" marker on each tab without re-rendering them.
    function updateTabsFilled(){
      if(!tabsEl) return;
      try{
        var btns = tabsEl.querySelectorAll('.capkov-b2__tab');
        for(var i=0; i<btns.length; i++){
          var pp = btns[i].getAttribute('data-placement');
          if(!pp) continue;
          btns[i].setAttribute('data-capkov-filled', hasPlacementContent(pp) ? 'true' : 'false');
        }
      }catch(e){}
    }
    function syncModeUI(){
      var eff = effectiveKind();

      if(designRow) designRow.hidden = true;
      if(contentKindRow){
        var showKindRow = !!isImageMixed;
        contentKindRow.hidden = !showKindRow;
        if(showKindRow && contentKindBtns && contentKindBtns.length){
          contentKindBtns.forEach(function(btn){
            var v = btn.getAttribute('data-capkov-content-kind') || '';
            var on = (v === eff);
            btn.setAttribute('data-active', on ? 'true' : 'false');
            try{ btn.setAttribute('aria-pressed', on ? 'true' : 'false'); }catch(e){}
          });
        }
      }

      if(textUI) textUI.hidden = !(eff === 'text');
      if(fontUI) fontUI.hidden = !(eff === 'text');
      if(imageUI) imageUI.hidden = !(eff === 'image');
      if(placementsLabelEl){
        if(isTote){
          placementsLabelEl.textContent = RT('n.49b9f11', 'Strana');
        }
      }
      if(toteOrientRow) toteOrientRow.hidden = !(isTote && !isWinter && eff === 'text');
      if(toteMirrorRow){
        var showDir = false;
        if(isTote && !isWinter && eff === 'text'){
          var st0 = activeState();
          var o0 = '';
          try{ o0 = String(st0 && st0.textOverlay && (st0.textOverlay.orient || st0.textOverlay.orientation) || ''); }catch(e){ o0=''; }
          o0 = o0.toLowerCase();
          if(o0 !== 'h' && o0 !== 'v'){
            var r0 = 0;
            try{ r0 = parseInt(st0 && st0.textOverlay && st0.textOverlay.rot || 0, 10) || 0; }catch(e){ r0=0; }
            r0 = ((r0 % 360) + 360) % 360;
            o0 = (r0 === 90 || r0 === 270) ? 'v' : 'h';
          }
          showDir = (o0 === 'v');
        }
        toteMirrorRow.hidden = !showDir;
      }
      if(toteSizeRow) toteSizeRow.hidden = !(isTote && !isWinter && eff === 'text');
      if(toteFlipRow) toteFlipRow.hidden = !(isTote && !isWinter && eff === 'image');
      if(toteRotRow) toteRotRow.hidden = !(isTote && !isWinter && eff === 'image');
      if(threadRow) threadRow.hidden = !(kind === 'color' || eff === 'text');

      if(dragHint){
        if(eff === 'image'){
          dragHint.hidden = false;
          dragHint.textContent = RT('n.8dac25e', 'Přetáhni obrázek do přerušovaného rámečku.');
        }else if(isTote && eff === 'text'){
          dragHint.hidden = false;
          dragHint.textContent = RT('n.0960586', 'Přetáhni text do přerušovaného rámečku.');
        }else{
          dragHint.hidden = true;
        }
      }
      if(canvas){
        if(isTote && eff === 'text'){
          canvas.style.pointerEvents = 'auto';
          canvas.style.cursor = 'grab';
        }else{
          canvas.style.pointerEvents = 'none';
          canvas.style.cursor = '';
        }
      }
      if(textOverlayEl && !(isTote && eff === 'text')) textOverlayEl.hidden = true;
      if(dragTip) dragTip.hidden = true;

      try{ syncInstructions(); }catch(e){}
    }

    function currentTextLimit(pp){
      var p = pp || activePlacement();
      var lim = config.limits || {};
      if(isSocks){
        var socksLimit = parseInt(lim.socks, 10);
        return { count: 1, limits: [isFinite(socksLimit) ? Math.max(1, Math.min(2, socksLimit)) : 2] };
      }
      if(kind === 'text' && isWinter){
        var w = parseInt(lim.winter || 14, 10);
        return { count: 1, limits: [isFinite(w) ? w : 14] };
      }

      if(isApparel){
        /* Unified across trika + mikiny: same rows / same chars-per-row on every line. */
        var apCount = apparelLinesFor(p);
        var apChars = apparelCharsFor(p);
        var apLimits = [];
        for(var apI = 0; apI < apCount; apI++) apLimits.push(apChars);
        return { count: apCount, limits: apLimits };
      }

      if(p === 'front'){
        var cnt = parseInt(lim.front_lines || 2, 10);
        if(!isFinite(cnt) || cnt < 1) cnt = 2;
        if(cnt > 3) cnt = 3;
        var l1 = parseInt(lim.front_upper || 12, 10);
        var l2 = parseInt(lim.front_lower || 14, 10);
        var l3 = parseInt(lim.front_third || 14, 10);
        l1 = isFinite(l1) ? l1 : 12;
        l2 = isFinite(l2) ? l2 : 14;
        l3 = isFinite(l3) ? l3 : 14;
        return { count: cnt, limits: [l1, l2, l3].slice(0, cnt) };
      }
      if(p === 'back'){
        var b = parseInt(lim.back || 8, 10);
        return { count: 1, limits: [isFinite(b) ? b : 8] };
      }
      if(p === 'side_left' || p === 'side_right'){
        var s = parseInt(lim.side || 5, 10);
        return { count: 1, limits: [isFinite(s) ? s : 5] };
      }
      return { count: 1, limits: [10] };
    }

    function renderTextLimitHelp(){
      if(isSocks && textInput){
        textInput.maxLength = currentTextLimit().limits[0];
        textInput.rows = 1;
      }
      if(!textLimitEl) return;
      if(isSocks){
        textLimitEl.textContent = String((textInput && textInput.value || '').length) + ' / ' + currentTextLimit().limits[0];
        return;
      }
      if(isTote){
        textLimitEl.textContent = '';
        try{ textLimitEl.style.display = 'none'; }catch(e){}
        return;
      }
      try{ textLimitEl.style.display = ''; }catch(e){}
      if(isApparel){
        var apP = activePlacement();
        var apC = apparelCharsFor(apP);
        var apL = apparelLinesFor(apP);
        textLimitEl.textContent = (apL === 1 ? RT('n.ac06430', 'max {0} znaků na řádek • {1} řádek') : (apL < 5 ? RT('n.4981692', 'max {0} znaků na řádek • {1} řádky') : RT('n.603f00e', 'max {0} znaků na řádek • {1} řádků'))).replace('{0}', apC).replace('{1}', apL);
        return;
      }
      var lim = currentTextLimit() || {};
      var limits = Array.isArray(lim.limits) ? lim.limits : [];
      if(limits.length){
        textLimitEl.textContent = 'max ' + limits.join(' / ');
      }else{
        textLimitEl.textContent = '';
      }
    }

    function uppercaseWeight(){
      var lim = config.limits || {};
      var w = parseFloat(lim.uppercase_weight);
      if(!isFinite(w) || w < 50 || w > 300) w = 100;
      return w / 100;
    }

    function charWeight(ch){
      return ch ? 1 : 0;
    }

    function clampLineByUnits(str, maxUnits){
      var s = String(str || '');
      var max = parseFloat(maxUnits);
      if(!isFinite(max) || max <= 0) return '';
      var units = 0;
      var out = '';
      for(var i = 0; i < s.length; i++){
        var ch = s.charAt(i);
        var w = charWeight(ch);
        if(units + w > max) break;
        units += w;
        out += ch;
      }
      return out;
    }

    function unitsForString(str){
      var s = String(str || '');
      var u = 0;
      for(var i=0;i<s.length;i++) u += charWeight(s.charAt(i));
      return u;
    }

    function splitLineByUnits(str, maxUnits){
      var s = String(str || '');
      var max = parseFloat(maxUnits);
      if(!isFinite(max) || max <= 0) return { fit: '', rest: s };
      var units = 0;
      var i = 0;
      for(; i < s.length; i++){
        var ch = s.charAt(i);
        var w = charWeight(ch);
        if(units + w > max) break;
        units += w;
      }
      return { fit: s.slice(0, i), rest: s.slice(i) };
    }

    function syncUiFromState(){
      showError('');
      var eff = effectiveKind();
      if(designInput) designInput.value = state.designName || '';
      if(noteInput) noteInput.value = state.note || '';
      if(eff === 'text' && textInput){
        textInput.value = activeState().text || '';
      }
      renderTextLimitHelp();
      if(eff === 'text' && fontSelect){
        var f = activeState().font || '';
        if(f) fontSelect.value = f;
        else if(fontSelect.value) activeState().font = fontSelect.value;
      }
      if(eff === 'image'){
        var st = activeState();
        if(fileInfo){
          if(st.file){
            fileInfo.hidden = false;
            if(fileNameEl) fileNameEl.textContent = st.file.name || '';
            if(fileMetaEl) fileMetaEl.textContent = (st.file.type || '') + (st.file.size ? (' • ' + Math.round(st.file.size/1024) + ' KB') : '');
          }else{
            fileInfo.hidden = true;
            if(fileNameEl) fileNameEl.textContent = '';
            if(fileMetaEl) fileMetaEl.textContent = '';
          }
        }
        if(scaleUI){
          scaleUI.hidden = !st.file;
        }
        if(scaleInput && st.overlay){
          var r = getScaleRangeForPlacement(activePlacement());
          scaleInput.min = String(r.min);
          scaleInput.max = String(r.max);
          var s = parseInt(st.overlay.scale || (r.max || 100), 10);
          if(!isFinite(s) || s <= 0) s = (r.max || 100);
          s = clampNum(s, r.min, r.max);
          st.overlay.scale = s;
          scaleInput.value = String(s);
          if(scaleLabel) scaleLabel.textContent = String(s) + '%';
        }
      }
      if(isTote && eff === 'text'){
        var stT = activeState();
        if(stT){
          if(!stT.textOverlay) stT.textOverlay = { x:0.5, y:0.5, orient:'h', mirror:false, rot:0, sizeTier:'m' };
          if(toteSizeSelect){
            var tier = String(stT.textOverlay.sizeTier || 'm');
            if(tier !== 's' && tier !== 'm' && tier !== 'l' && tier !== 'xl') tier = 'm';
            stT.textOverlay.sizeTier = tier;
            toteSizeSelect.value = tier;
          }
          if(toteOrientBtns && toteOrientBtns.length){
            var orient = String(stT.textOverlay.orient || stT.textOverlay.orientation || '').toLowerCase();
            if(orient !== 'h' && orient !== 'v'){
              var rot = parseInt(stT.textOverlay.rot || 0, 10) || 0;
              rot = ((rot % 360) + 360) % 360;
              orient = (rot === 90 || rot === 270) ? 'v' : 'h';
            }
            stT.textOverlay.orient = orient;
            var dirFlip = !!stT.textOverlay.mirror;
            stT.textOverlay.rot = (orient === 'v') ? (dirFlip ? 270 : 90) : 0;
            toteOrientBtns.forEach(function(btn){
              var v = String(btn.getAttribute('data-capkov-tote-orient')||'');
              var on = (v === orient);
              btn.setAttribute('data-active', on ? 'true' : 'false');
              try{ btn.setAttribute('aria-pressed', on ? 'true' : 'false'); }catch(e){}
            });
          }
          if(toteMirrorBtns && toteMirrorBtns.length){
            var mir = !!stT.textOverlay.mirror;
            toteMirrorBtns.forEach(function(btn){
              var v2 = String(btn.getAttribute('data-capkov-tote-mirror')||'').toLowerCase();
              var on2 = (v2 === 'on') ? mir : (v2 === 'off') ? !mir : false;
              btn.setAttribute('data-active', on2 ? 'true' : 'false');
              try{ btn.setAttribute('aria-pressed', on2 ? 'true' : 'false'); }catch(e){}
            });
          }
        }
      }
      if(isTote && eff === 'image'){
        var stI = activeState();
        if(stI){
          if(!stI.overlay) stI.overlay = { x:0.5, y:0.5, scale:100, flipX:false, flipY:false, rot:0 };
          var rr = parseInt(stI.overlay.rot || 0, 10) || 0;
          rr = ((rr % 360) + 360) % 360;
          if(rr !== 90 && rr !== 180 && rr !== 270) rr = 0;
          stI.overlay.rot = rr;
          if(stI.overlay.flipX && stI.overlay.flipY){
            stI.overlay.flipY = false;
          }

          if(toteRotBtns && toteRotBtns.length){
            toteRotBtns.forEach(function(btn){
              var vR = parseInt(btn.getAttribute('data-capkov-tote-rot') || '0', 10) || 0;
              vR = ((vR % 360) + 360) % 360;
              if(vR !== 90 && vR !== 180 && vR !== 270) vR = 0;
              var onR = (vR === rr);
              btn.setAttribute('data-active', onR ? 'true' : 'false');
              try{ btn.setAttribute('aria-pressed', onR ? 'true' : 'false'); }catch(e){}
            });
          }

          if(toteFlipBtns && toteFlipBtns.length){
            toteFlipBtns.forEach(function(btn){
              var ax = String(btn.getAttribute('data-capkov-tote-flip')||'');
              var on = (ax === 'x') ? !!stI.overlay.flipX : (ax === 'y') ? !!stI.overlay.flipY : false;
              btn.setAttribute('data-active', on ? 'true' : 'false');
              try{ btn.setAttribute('aria-pressed', on ? 'true' : 'false'); }catch(e){}
            });
          }
        }
      }
    }
    function clampTextByLimit(txt){
      if(isSocks) return cutTo(String(txt || '').replace(/[\r\n\u2028\u2029]/g, ''), currentTextLimit().limits[0]);
      if(isTote){
        var vT = String(txt || '').replace(/\r\n/g,'\n').replace(/\r/g,'\n');
        var effT = '';
        try{ effT = String(effectiveKind() || ''); }catch(e){ effT = ''; }
        if(effT !== 'text') return vT;
        if(!ctx || !baseImg) return vT;

        var stT = null;
        try{ stT = activeState(); }catch(e){ stT = null; }
        if(!stT) return vT;
        if(!stT.textOverlay) stT.textOverlay = { x:0.5, y:0.5, orient:'h', mirror:false, rot:0, sizeTier:'m' };

        var frT = null;
        try{ frT = getFrameForPlacement(activePlacement()); }catch(e){ frT = null; }
        var rectT = null;
        try{ rectT = frameToStageRect(frT); }catch(e){ rectT = null; }
        if(!rectT || !rectT.w || !rectT.h) return vT;
        var tierT = String(stT.textOverlay.sizeTier || 'm').toLowerCase();
        if(tierT !== 's' && tierT !== 'm' && tierT !== 'l' && tierT !== 'xl') tierT = 'm';
        stT.textOverlay.sizeTier = tierT;

        var SAFE_W_MM = 250;
        var SAFE_H_MM = 310;
        var pxPerMmT = Math.min(rectT.w / SAFE_W_MM, rectT.h / SAFE_H_MM);
        if(!isFinite(pxPerMmT) || pxPerMmT <= 0){
          pxPerMmT = Math.min(rectT.w, rectT.h) / 250;
        }

        var mmT = (tierT === 's') ? 15 : (tierT === 'm') ? 20 : (tierT === 'l') ? 25 : (tierT === 'xl') ? 40 : 20;
        var basePctT = (config && config.tote && config.tote.text_base_pct != null) ? Number(config.tote.text_base_pct) : 100;
        if(!isFinite(basePctT) || basePctT <= 0) basePctT = 100;

        var fontSizeT = Math.max(1, Math.round(mmT * pxPerMmT * (basePctT / 100)));
        var lineHeightFactorT = 1.15;
        var lineHT = Math.max(1, Math.round(fontSizeT * lineHeightFactorT));
        var orientT = String(stT.textOverlay.orient || stT.textOverlay.orientation || '').toLowerCase();
        if(orientT !== 'h' && orientT !== 'v'){
          var r0T = parseInt(stT.textOverlay.rot || 0, 10) || 0;
          r0T = ((r0T % 360) + 360) % 360;
          orientT = (r0T === 90 || r0T === 270) ? 'v' : 'h';
        }
        orientT = (orientT === 'v') ? 'v' : 'h';
        stT.textOverlay.orient = orientT;

        var availHT = (orientT === 'v') ? rectT.w : rectT.h;
        var maxLinesFitT = Math.floor(availHT / lineHT);
        if(!isFinite(maxLinesFitT) || maxLinesFitT < 1) maxLinesFitT = 1;
        if(maxLinesFitT > 120) maxLinesFitT = 120;

        var maxLineWT = (orientT === 'v') ? (rectT.h * 0.98) : (rectT.w * 0.98);
        if(!isFinite(maxLineWT) || maxLineWT <= 1) return vT;

        var ffT = stT.font || (capkovConfig && capkovConfig.default_font_family) || 'system-ui';
        function __capkovToteSetFont(fs){
          ctx.font = embW(ffT) + ' ' + fs + 'px "' + String(ffT).replace(/"/g,'\\"') + '", system-ui, -apple-system, Segoe UI, Roboto, Arial';
        }

        function __capkovToteWrapLines(rawLines, maxW, fs, maxTotal){
          maxTotal = maxTotal || 20;
          if(maxTotal < 1) maxTotal = 1;
          __capkovToteSetFont(fs);

          var out = [];
          for(var i=0; i<rawLines.length; i++){
            var line = String(rawLines[i]||'');
            if(!line.replace(/\s+/g,'').length){
              out.push('');
              if(out.length >= maxTotal) break;
              continue;
            }
            var words = line.trim().split(/\s+/);
            var cur = '';
            for(var wi=0; wi<words.length; wi++){
              var word = words[wi];
              if(!word) continue;
              while(word && ctx.measureText(word).width > maxW){
                var part = '';
                for(var ci=0; ci<word.length; ci++){
                  var next = part + word[ci];
                  if(ctx.measureText(next).width > maxW){
                    break;
                  }
                  part = next;
                }
                if(!part){
                  part = word.slice(0,1);
                }
                out.push(part);
                if(out.length >= maxTotal) return out.slice(0,maxTotal);
                word = word.slice(part.length);
              }

              var test = cur ? (cur + ' ' + word) : word;
              if(ctx.measureText(test).width <= maxW){
                cur = test;
              }else{
                if(cur) out.push(cur);
                if(out.length >= maxTotal) break;
                cur = word;
              }
            }
            if(out.length >= maxTotal) break;
            if(cur || cur === '') out.push(cur);
            if(out.length >= maxTotal) break;
          }
          return out.slice(0,maxTotal);
        }

        function __capkovToteFits(str){
          var raw = String(str || '').split('\n');
          if(raw.length > 80) raw = raw.slice(0, 80);
          var lines = __capkovToteWrapLines(raw, maxLineWT, fontSizeT, Math.min(200, maxLinesFitT + 1));
          return (lines.length <= maxLinesFitT);
        }

        if(__capkovToteFits(vT)) return vT;
        var loT = 0;
        var hiT = vT.length;
        while(loT < hiT){
          var midT = Math.ceil((loT + hiT) / 2);
          var prefT = vT.slice(0, midT);
          if(__capkovToteFits(prefT)){
            loT = midT;
          }else{
            hiT = midT - 1;
          }
        }

        return vT.slice(0, loT);
      }
      var v = String(txt||'');
      var lim = currentTextLimit();
      var count = lim && lim.count ? lim.count : 1;
      var limits = lim && Array.isArray(lim.limits) ? lim.limits : [10];

      v = v.replace(/\r\n/g,'\n').replace(/\r/g,'\n');
      var endsWithNewline = /\n$/.test(v);
      if(count <= 1){
        var one = v.split('\n').join(' ');
        return clampLineByUnits(one, limits[0] || 10);
      }
      var out = new Array(count);
      for(var i=0;i<count;i++) out[i] = '';

      var usedMax = 0;
      var lineIndex = 0;

      var parts = v.split('\n');
      for(var pi=0; pi<parts.length; pi++){
        if(pi > 0){
          lineIndex += 1;
          if(lineIndex >= count) break;
          usedMax = Math.max(usedMax, lineIndex);
        }

        var seg = String(parts[pi] || '');
        while(seg && lineIndex < count){
          var limUnits = parseFloat(limits[lineIndex] != null ? limits[lineIndex] : limits[limits.length-1]);
          if(!isFinite(limUnits) || limUnits <= 0) limUnits = 10;

          var already = out[lineIndex];
          var remaining = limUnits - unitsForString(already);
          if(remaining < 0) remaining = 0;

          var split = splitLineByUnits(seg, remaining);
          out[lineIndex] = (already || '') + (split.fit || '');
          usedMax = Math.max(usedMax, lineIndex);

          seg = String(split.rest || '');
          if(seg){
            lineIndex += 1;
            if(lineIndex >= count) break;
            usedMax = Math.max(usedMax, lineIndex);
            seg = seg.replace(/^\s+/, '');
          }
        }

        if(lineIndex >= count) break;
      }

      var outLines = out.slice(0, Math.min(count, usedMax + 1));
      if(!endsWithNewline){
        while(outLines.length > 1 && String(outLines[outLines.length-1]).trim() === '') outLines.pop();
      }
      return outLines.join('\n');
    }
    function dataURLToBlob(dataUrl){
      var parts = String(dataUrl || '').split(',');
      var meta = parts[0] || '';
      var b64 = parts[1] || '';
      var m = /data:([^;]+);base64/i.exec(meta);
      var mime = m ? m[1] : 'application/octet-stream';
      var bin = atob(b64);
      var len = bin.length;
      var bytes = new Uint8Array(len);
      for(var i=0;i<len;i++) bytes[i] = bin.charCodeAt(i);
      return new Blob([bytes], { type: mime });
    }

    function canvasToBlob(canvasEl, mimeType, quality){
      var type = mimeType || 'image/png';
      var q = (typeof quality === 'number') ? quality : 0.92;
      return new Promise(function(resolve, reject){
        try{
          if(canvasEl && canvasEl.toBlob){
            canvasEl.toBlob(function(blob){
              if(blob){
                resolve(blob);
                return;
              }
              try{
                var url = canvasEl.toDataURL(type, q);
                resolve(dataURLToBlob(url));
              }catch(e2){ reject(e2); }
            }, type, q);
            return;
          }
          var url2 = canvasEl.toDataURL(type, q);
          resolve(dataURLToBlob(url2));
        }catch(e){ reject(e); }
      });
    }
    function getFrameForPlacement(p){
      if(isApparel){
        var a = apparelFor(p) || apparelFor('front');
        if(a && a.frame && a.frame.w > 0 && a.frame.h > 0) return a.frame;
        return { left: 500, top: 480, w: 600, h: 600, min: 60, max: 100 };
      }
      var fm = framesByMode[modeKey] || null;
      if(!fm) return null;
      return fm[p] || fm.front || null;
    }

    function clampNum(v, min, max){
      return Math.max(min, Math.min(max, v));
    }

    function getScaleRangeForPlacement(p){
      var fr = getFrameForPlacement(p);
      var min = fr && fr.min != null ? parseInt(fr.min, 10) : 60;
      var max = fr && fr.max != null ? parseInt(fr.max, 10) : 100;
      if(!isFinite(min)) min = 60;
      if(!isFinite(max)) max = 100;
      min = clampNum(min, 10, 200);
      max = clampNum(max, 10, 200);
      if(min > max){ var t = min; min = max; max = t; }
      return { min: min, max: max };
    }

    function getStageRect(){
      if(!baseImg) return { w:0,h:0,left:0,top:0 };
      var r = baseImg.getBoundingClientRect();
      return { w: r.width, h: r.height, left: r.left, top: r.top };
    }

    function baseImageNatural(){
      var rw = 1600, rh = 1600;
      try{
        var aw = parseFloat(String(baseImg.getAttribute('width')||'')) || 0;
        var ah = parseFloat(String(baseImg.getAttribute('height')||'')) || 0;
        if(aw > 0) rw = aw;
        if(ah > 0) rh = ah;
      }catch(e){}
      return { w: rw, h: rh };
    }

    function getImageBoxInStage(){
      if(!stageEl || !baseImg) return { x: 0, y: 0, w: 0, h: 0 };
      var sr = stageEl.getBoundingClientRect();
      var ir = baseImg.getBoundingClientRect();
      return {
        x: ir.left - sr.left,
        y: ir.top - sr.top,
        w: ir.width,
        h: ir.height
      };
    }

    function frameToStageRect(frame){
      if(!frame) return null;
      var nat = baseImageNatural();
      var st = getStageRect();
      if(!nat.w || !nat.h || !st.w || !st.h) return null;
      var sx = st.w / nat.w;
      var sy = st.h / nat.h;
      return {
        left: frame.left * sx,
        top: frame.top * sy,
        w: frame.w * sx,
        h: frame.h * sy,
        sx: sx,
        sy: sy
      };
    }
    /* ---- Crisp zoom -------------------------------------------------------------
       The text canvas is sized for 1x (CSS px * devicePixelRatio). A CSS scale just
       stretches those pixels, which is what looked soft. Raise the backing store while
       zoomed (CSS size untouched) and redraw, and ask the CDN for a larger mockup. */
    var _ssLevel = 1;
    var _zoomImgLevel = 1;

    /* Embroidery strokes are thin. At plain devicePixelRatio the anti-aliasing blends
       most of a stroke into the dark garment, so white thread reads as grey — and it
       "fixed itself" on zoom purely because zooming raised the density. Apparel
       therefore renders at >=2x density all the time, not just while zoomed. */
    function canvasDensityFor(level){
      var dpr = window.devicePixelRatio || 1;
      var lv = Math.max(1, Math.min(3, level || 1));
      if(isApparel) lv = Math.max(2, lv);
      return Math.max(1, Math.min(4.5, dpr * lv));
    }

    function superSampleCanvas(level){
      if(!canvas || !ctx) return;
      var w = parseFloat(canvas.style.width) || 0;
      var h = parseFloat(canvas.style.height) || 0;
      if(!w || !h) return;
      var eff = canvasDensityFor(level);
      canvas.width = Math.round(w * eff);
      canvas.height = Math.round(h * eff);
      /* drawTextPreview works in CSS pixels, so the transform carries the extra density */
      ctx.setTransform(eff, 0, 0, eff, 0, 0);
      try{ if(effectiveKind() === 'text') drawTextPreview(); }catch(e){}
    }

    function withImageWidth(url, px){
      try{
        var u = new URL(String(url || ''), window.location.href);
        if(!u.searchParams.has('width')) return url;
        u.searchParams.set('width', String(px));
        return u.toString();
      }catch(e){ return url; }
    }

    function setZoomImageLevel(level){
      _zoomImgLevel = (level > 1) ? 2 : 1;
      if(!baseImg) return;
      var want = getBaseImageSrc();
      if(!want) return;
      if(_zoomImgLevel > 1){
        var hi = withImageWidth(want, 3200);
        if(hi === want) return;
        /* preload so the swap never flashes */
        var im = new Image();
        im.onload = function(){
          try{ if(_zoomImgLevel > 1) baseImg.src = hi; }catch(e){}
        };
        im.src = hi;
      }else{
        try{ if(baseImg.getAttribute('src') !== want) baseImg.src = want; }catch(e){}
      }
    }

    function applyZoomQuality(z){
      var lvl = (z > 1.001) ? Math.max(1, Math.min(3, Math.round(z * 2) / 2)) : 1;
      if(lvl === _ssLevel) return;
      _ssLevel = lvl;
      try{ superSampleCanvas(lvl); }catch(e){}
      try{ setZoomImageLevel(lvl); }catch(e){}
    }

    function resizeCanvasToImage(){
      if(!canvas || !baseImg) return;
      if(_zoomActive) return;

      var box = getImageBoxInStage();
      var w = box.w || baseImg.clientWidth || 0;
      var h = box.h || baseImg.clientHeight || 0;
      if(!w || !h) return;
      if(stageEl){
        canvas.style.left = (box.x || 0) + 'px';
        canvas.style.top = (box.y || 0) + 'px';
        canvas.style.right = 'auto';
        canvas.style.bottom = 'auto';
      }

      var dens = canvasDensityFor(_ssLevel);
      canvas.width = Math.round(w * dens);
      canvas.height = Math.round(h * dens);
      canvas.style.width = w + 'px';
      canvas.style.height = h + 'px';
      if(ctx) ctx.setTransform(dens,0,0,dens,0,0);
    }

    function pickTextAnchor(placement){
      var p = (isWinter || isSocks) ? 'front' : placement;
      if(isApparel){
        var ap = apparelFor(p);
        /* Front falls back to the unified X/Y on the builder block, so a front-only
           setup needs no placement block at all. Other placements keep their own. */
        var apFb = (p === 'front')
          ? { x: apparelDefaults.x, y: apparelDefaults.y }
          : (APPAREL_ANCHOR_FALLBACK[p] || APPAREL_ANCHOR_FALLBACK.front);
        return {
          x: (ap && isFinite(ap.x)) ? ap.x : apFb.x,
          y: (ap && isFinite(ap.y)) ? ap.y : apFb.y,
          size: apparelTextSizePct(p)
        };
      }
      var mk = modeKey;
      if(isImageMixed) mk = textModeKeyForCurrentProduct();
      var fallback = {
        front: { x: 50, y: 38, size: 70 },
        back: { x: 50, y: 44, size: 70 },
        side_left: { x: 73, y: 60, size: 60 },
        side_right: { x: 27, y: 60, size: 60 }
      };
      var anchors = null;
      try{
        if(mk === 'text_socks') anchors = capkovConfig.text_anchors_socks || { front: { x: 53.1, y: 31.9, size: 70 } };
        else if(mk === 'text_winter' && capkovConfig && capkovConfig.text_anchors_winter) anchors = capkovConfig.text_anchors_winter;
        else if(mk === 'text_non_washed' && capkovConfig && capkovConfig.text_anchors_nw) anchors = capkovConfig.text_anchors_nw;
        else if(mk === 'text_distressed' && capkovConfig && capkovConfig.text_anchors_distressed) anchors = capkovConfig.text_anchors_distressed;
        else if((mk === 'text_two_tone' || modeKey === 'image_two_tone') && capkovConfig && capkovConfig.text_anchors_two_tone) anchors = capkovConfig.text_anchors_two_tone;
        else if(capkovConfig && capkovConfig.text_anchors) anchors = capkovConfig.text_anchors;
      }catch(e){}
      var a = (anchors && anchors[p]) ? anchors[p] : null;
      var fb = fallback[p] || fallback.front;
      return {
        x: (a && typeof a.x === 'number') ? a.x : fb.x,
        y: (a && typeof a.y === 'number') ? a.y : fb.y,
        size: (a && typeof a.size === 'number') ? a.size : fb.size
      };
    }

    function socksCalibratedFontSize(ctx2, family, size, height, anchorSize){
      if(!isSocks) return size;
      if(family !== 'Čapkov Font' && !/\/latest_1\.woff2(?:\?|$)/.test(fontUrlForFamily(family))) return size;
      ctx2.save();
      ctx2.font = embW(family) + ' 100px "' + String(family).replace(/"/g, '\\"') + '"';
      var metrics = ctx2.measureText('AB');
      ctx2.restore();
      var glyphHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
      // size=70: AB is 3.5% of the photo height at the existing 90% font correction.
      // Measure the loaded font so its em/cap-height ratio cannot skew calibration.
      return glyphHeight > 0
        ? Math.max(1, height * 0.035 * (anchorSize / 70) * (fontSizePctForFamily(family) / 90) * 100 / glyphHeight)
        : size;
    }

    function drawEmbroideryTextLine(ctx2, line, x, y, fontSize, ff, fill){
      /* saténová výšivka: sdílený renderer z capkov-rd-vdc.js (stejný vzhled jako na úvodní stránce, ve wizardu a v kvízu); bez něj klasický plochý text */
      var __sat = window.RdVdc && window.RdVdc.satin, __hx = String(fill || '').trim();
      if(__hx && __hx.charAt(0) !== '#') __hx = '#' + __hx;
      if(__sat && /^#[0-9a-f]{3}([0-9a-f]{3})?$/i.test(__hx) && fontSize > 0){
        try{
          var __tm = ctx2.getTransform ? ctx2.getTransform() : null, __sc = (__tm && __tm.a) || 1, __cw = (ctx2.canvas.width / __sc) || 1, __ch = (ctx2.canvas.height / __sc) || 1;
          var __cap = (typeof baseImg !== 'undefined' && baseImg) ? __sat.cap(baseImg, x / __cw * 100, y / __ch * 100, function(){ try{ drawTextPreview(); }catch(e){} }) : null;
          __sat.draw(ctx2, { lines: [String(line)], fs: fontSize, lh: 1, x: x, y: y, font: embW(ff) + ' {px}px "' + String(ff).replace(/"/g,'\\"') + '", system-ui, -apple-system, Segoe UI, Roboto, Arial', hex: __hx, cap: __cap });
          return;
        }catch(__e){}
      }
      ctx2.save();
      ctx2.font = embW(ff) + ' ' + fontSize + 'px "' + String(ff).replace(/"/g,'\\"') + '", system-ui, -apple-system, Segoe UI, Roboto, Arial';
      /* iOS WebKit misaligns textAlign:'center' when the string contains emoji — center manually */
      ctx2.textAlign = 'left';
      ctx2.textBaseline = 'middle';
      ctx2.shadowColor = 'transparent';
      ctx2.shadowBlur = 0;
      ctx2.shadowOffsetX = 0;
      ctx2.shadowOffsetY = 0;
      ctx2.setLineDash([]);
      ctx2.globalAlpha = 1;
      ctx2.fillStyle = fill;
      var lw = 0;
      try{ lw = ctx2.measureText(line).width; }catch(e){}
      ctx2.fillText(line, x - (lw / 2), y);
      ctx2.restore();
    }
    function drawToteTextPreview(){
      if(!ctx || !canvas) return;
      try{ resizeCanvasToImage(); }catch(e){}

      var box0 = null;
      try{ box0 = getImageBoxInStage(); }catch(e){ box0 = null; }
      var w = (box0 && box0.w) ? box0.w : (canvas.clientWidth || (baseImg ? baseImg.clientWidth : 0));
      var h = (box0 && box0.h) ? box0.h : (canvas.clientHeight || (baseImg ? baseImg.clientHeight : 0));

      if(!w || !h){
        if(drawToteTextPreview._retryCount == null) drawToteTextPreview._retryCount = 0;
        if(drawToteTextPreview._retryCount < 10){
          drawToteTextPreview._retryCount++;
          requestAnimationFrame(function(){ try{ drawToteTextPreview(); }catch(e){} });
        }
        return;
      }
      drawToteTextPreview._retryCount = 0;

      ctx.clearRect(0,0,w,h);

      var st = activeState();
      var rawText = String(st.text || '').replace(/\r\n/g,'\n').replace(/\r/g,'\n');
      if(!rawText.replace(/\s+/g,'').length){
        if(dragTip) dragTip.hidden = true;
        if(textOverlayEl) textOverlayEl.hidden = true;
        if(textLimitEl){
          textLimitEl.textContent = '';
          try{ textLimitEl.style.display = 'none'; }catch(e){}
        }
        return;
      }

      var placement = activePlacement();
      var fr = getFrameForPlacement(placement);
      var rect = frameToStageRect(fr);
      if(!rect){
        if(dragTip) dragTip.hidden = true;
        if(textOverlayEl) textOverlayEl.hidden = true;
        if(textLimitEl){
          textLimitEl.textContent = '';
          try{ textLimitEl.style.display = 'none'; }catch(e){}
        }
        return;
      }
      var ff = st.font || capkovConfig.default_font_family || 'system-ui';
      var ffUrl = fontUrlForFamily(ff);
      if(ffUrl){
        ensureFontLoaded({ family: ff, url: ffUrl });
      }else{
        try{ ensureFontLoaded(ff); }catch(e){}
      }

      var fill = threadColorHex(st.threadColor || '') || '#ffffff';

      if(!st.textOverlay) st.textOverlay = { x:0.5, y:0.5, orient:'h', mirror:false, rot:0, sizeTier:'m' };
      var tier = String(st.textOverlay.sizeTier || 'm').toLowerCase();
      if(tier !== 's' && tier !== 'm' && tier !== 'l' && tier !== 'xl') tier = 'm';
      st.textOverlay.sizeTier = tier;
      var SAFE_W_MM = 250;
      var SAFE_H_MM = 310;

      var pxPerMm = Math.min(rect.w / SAFE_W_MM, rect.h / SAFE_H_MM);
      if(!isFinite(pxPerMm) || pxPerMm <= 0){
        pxPerMm = Math.min(rect.w, rect.h) / 250;
      }
      var mm = (tier === 's') ? 15 : (tier === 'm') ? 20 : (tier === 'l') ? 25 : (tier === 'xl') ? 40 : 20;
      var basePct = (config && config.tote && config.tote.text_base_pct != null) ? Number(config.tote.text_base_pct) : 100;
      if(!isFinite(basePct) || basePct <= 0) basePct = 100;

      var fontSize = Math.max(1, Math.round(mm * pxPerMm * (basePct / 100)));
      st.textOverlay._fontPx = fontSize;
      st.textOverlay._sizeMm = mm;
      function setFont(fs){
        ctx.font = embW(ff) + ' ' + fs + 'px "' + ff + '", system-ui, -apple-system, Segoe UI, Roboto, Arial';
      }

      function wrapLinesToWidth(rawLines, maxW, fs, maxTotal){
        maxTotal = maxTotal || 20;
        if(maxTotal < 1) maxTotal = 1;

        setFont(fs);

        var out = [];
        for(var i=0; i<rawLines.length; i++){
          var line = String(rawLines[i]||'');
          if(!line.replace(/\s+/g,'').length){
            out.push('');
            if(out.length >= maxTotal) break;
            continue;
          }
          var words = line.trim().split(/\s+/);
          var cur = '';
          for(var wi=0; wi<words.length; wi++){
            var word = words[wi];
            if(!word) continue;
            while(word && ctx.measureText(word).width > maxW){
              var part = '';
              for(var ci=0; ci<word.length; ci++){
                var next = part + word[ci];
                if(ctx.measureText(next).width > maxW){
                  break;
                }
                part = next;
              }
              if(!part){
                part = word.slice(0,1);
              }
              out.push(part);
              if(out.length >= maxTotal) return out.slice(0,maxTotal);
              word = word.slice(part.length);
            }

            var test = cur ? (cur + ' ' + word) : word;
            if(ctx.measureText(test).width <= maxW){
              cur = test;
            }else{
              if(cur) out.push(cur);
              if(out.length >= maxTotal) break;
              cur = word;
            }
          }
          if(out.length >= maxTotal) break;
          if(cur || cur === '') out.push(cur);
          if(out.length >= maxTotal) break;
        }
        return out.slice(0,maxTotal);
      }

      var lineHeightFactor = 1.15;

      function measureBox(fs, lines, rotDeg){
        setFont(fs);
        var maxW = 0;
        for(var i=0; i<lines.length; i++){
          var s = String(lines[i] || '');
          if(!s) continue;
          var mw = ctx.measureText(s).width;
          if(mw > maxW) maxW = mw;
        }
        var lineH = Math.max(1, Math.round(fs * lineHeightFactor));
        var totalH = lines.length * lineH;

        var rawW = maxW;
        var rawH = totalH;

        rotDeg = parseInt(rotDeg || 0, 10) || 0;
        rotDeg = ((rotDeg % 360) + 360) % 360;
        var wR = rawW, hR = rawH;
        if(rotDeg === 90 || rotDeg === 270){
          wR = rawH;
          hR = rawW;
        }
        return { w:wR, h:hR, rawW:rawW, rawH:rawH, lineH:lineH, totalH:totalH };
      }
      var orient = String(st.textOverlay.orient || st.textOverlay.orientation || '').toLowerCase();
      if(orient !== 'h' && orient !== 'v'){
        var r0 = parseInt(st.textOverlay.rot || 0, 10) || 0;
        r0 = ((r0 % 360) + 360) % 360;
        orient = (r0 === 90 || r0 === 270) ? 'v' : 'h';
      }
      orient = (orient === 'v') ? 'v' : 'h';
      st.textOverlay.orient = orient;

      var dirFlip = !!st.textOverlay.mirror;
      var rot = (orient === 'v') ? (dirFlip ? 270 : 90) : 0;
      st.textOverlay.rot = rot;

      var lineH = Math.max(1, Math.round(fontSize * lineHeightFactor));
      var availH = (orient === 'v') ? rect.w : rect.h;
      var maxLinesFit = Math.floor(availH / lineH);
      if(!isFinite(maxLinesFit) || maxLinesFit < 1) maxLinesFit = 1;
      if(maxLinesFit > 120) maxLinesFit = 120;
      var maxLineW = (orient === 'v') ? (rect.h * 0.98) : (rect.w * 0.98);

      var rawLines = rawText.split('\n');
      if(rawLines.length > 80) rawLines = rawLines.slice(0, 80);
      var lines = wrapLinesToWidth(rawLines, maxLineW, fontSize, Math.min(200, maxLinesFit + 1));

      var overflow = (lines.length > maxLinesFit);
      var box = measureBox(fontSize, lines, rot);
      var fitOk = (!overflow && box && (box.w <= rect.w + 0.5) && (box.h <= rect.h + 0.5));

      st.textOverlay._fitOk = fitOk;
      st.textOverlay._boxW = box ? box.w : null;
      st.textOverlay._boxH = box ? box.h : null;
      if(textLimitEl){
        if(fitOk){
          textLimitEl.textContent = '';
          try{ textLimitEl.style.display = 'none'; }catch(e){}
        }else{
          textLimitEl.textContent = RT('n.0bf569b', 'Text se nevejde do rámečku. Zkrať ho nebo zvol menší velikost.');
          try{ textLimitEl.style.display = ''; }catch(e){}
        }
      }
      var ox = isFinite(st.textOverlay.x) ? st.textOverlay.x : 0.5;
      var oy = isFinite(st.textOverlay.y) ? st.textOverlay.y : 0.5;
      var minX = (box.w / 2) / rect.w;
      var maxX = 1 - minX;
      var minY = (box.h / 2) / rect.h;
      var maxY = 1 - minY;
      if(minX > maxX){ minX = maxX = 0.5; }
      if(minY > maxY){ minY = maxY = 0.5; }
      ox = Math.max(minX, Math.min(maxX, ox));
      oy = Math.max(minY, Math.min(maxY, oy));
      st.textOverlay.x = ox; st.textOverlay.y = oy;

      var cx = rect.left + (rect.w * ox);
      var cy = rect.top + (rect.h * oy);
      if(dragTip){
        var dismissed = !!(st && st.textOverlay && st.textOverlay._dragHintDismissed);
        dragTip.hidden = dismissed ? true : false;
      }
      function __capkovIsLightHex(hex){
        hex = String(hex||'').trim();
        var m = /^#([0-9a-f]{6})$/i.exec(hex);
        if(!m) return false;
        var n = m[1];
        var r = parseInt(n.slice(0,2), 16);
        var g = parseInt(n.slice(2,4), 16);
        var b = parseInt(n.slice(4,6), 16);
        if(!isFinite(r) || !isFinite(g) || !isFinite(b)) return false;
        var lum = (0.2126*r + 0.7152*g + 0.0722*b) / 255;
        return lum > 0.65;
      }
      var __capkovOutline = __capkovIsLightHex(fill) ? 'rgba(0,0,0,0.35)' : 'rgba(255,255,255,0.35)';

      if(textOverlayEl && textOverlayTextEl){
        var imgBox2 = getImageBoxInStage();
        try{
          textOverlayEl.hidden = false;
          textOverlayEl.style.left = (imgBox2.x + rect.left) + 'px';
          textOverlayEl.style.top = (imgBox2.y + rect.top) + 'px';
          textOverlayEl.style.width = rect.w + 'px';
          textOverlayEl.style.height = rect.h + 'px';
          textOverlayTextEl.textContent = lines.join('\n');

          textOverlayTextEl.style.left = (ox * 100) + '%';
          textOverlayTextEl.style.top = (oy * 100) + '%';
          textOverlayTextEl.style.fontSize = fontSize + 'px';
          textOverlayTextEl.style.fontFamily = '"' + String(ff).replace(/"/g,'\\"') + '", system-ui, -apple-system, Segoe UI, Roboto, Arial';
          textOverlayTextEl.style.fontWeight = '800';
          textOverlayTextEl.style.lineHeight = String(lineHeightFactor);
          textOverlayTextEl.style.color = fill;
          textOverlayTextEl.style.transform = 'translate(-50%,-50%) rotate(' + rot + 'deg)';
          var sh = '0 1px 0 ' + __capkovOutline + ', 1px 0 0 ' + __capkovOutline + ', 0 -1px 0 ' + __capkovOutline + ', -1px 0 0 ' + __capkovOutline + ', 1px 1px 0 ' + __capkovOutline + ', -1px 1px 0 ' + __capkovOutline + ', 1px -1px 0 ' + __capkovOutline + ', -1px -1px 0 ' + __capkovOutline;
          textOverlayTextEl.style.textShadow = sh;
          try{ ctx.clearRect(0,0,w,h); }catch(e){}
        }catch(e){
          try{ textOverlayEl.hidden = true; }catch(err){}
        }
      }else{
        ctx.save();
        ctx.beginPath();
        ctx.rect(rect.left, rect.top, rect.w, rect.h);
        ctx.clip();

        ctx.translate(cx, cy);
        ctx.rotate(rot * Math.PI / 180);
        setFont(fontSize);
        /* iOS WebKit misaligns textAlign:'center' when the string contains emoji — center manually */
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = fill;

        ctx.lineJoin = 'round';
        ctx.miterLimit = 2;
        ctx.lineWidth = Math.max(1, Math.round(fontSize * 0.08));
        ctx.strokeStyle = __capkovOutline;

        var startY2 = -(box.totalH / 2) + (box.lineH / 2);
        for(var j2=0; j2<lines.length; j2++){
          if(!lines[j2] && lines[j2] !== '') continue;
          if(!String(lines[j2]).length) continue;
          var yy2 = startY2 + (j2 * box.lineH);
          var lw2 = 0;
          try{ lw2 = ctx.measureText(lines[j2]).width; }catch(eM){}
          try{ ctx.strokeText(lines[j2], -(lw2 / 2), yy2); }catch(e2){}
          ctx.fillText(lines[j2], -(lw2 / 2), yy2);
        }

        ctx.restore();
      }
    }

    function drawTextPreview(){
      if(!ctx || !canvas) return;

      if(isTote){
        drawToteTextPreview();
        return;
      }

      var w = baseImg ? baseImg.clientWidth : 0;
      var h = baseImg ? baseImg.clientHeight : 0;
      if(!w || !h) return;

      ctx.clearRect(0,0,w,h);

      var st = activeState();
      var rawText = String(st.text || '').replace(/\r\n/g,'\n').replace(/\r/g,'\n');
      if(!rawText.replace(/\s+/g,'').length) return;

      var placement = activePlacement();
      var anchor = pickTextAnchor(placement);
      var ff = (st.font || (fontSelect && fontSelect.value)) ? String(st.font || fontSelect.value) : (capkovConfig.default_font_family || 'system-ui');
      var url = '';
      if(fontSelect){
        var opt = fontSelect.querySelector('option[value="' + cssEscape(ff) + '"]');
        if(opt) url = String(opt.getAttribute('data-font-url')||'').trim();
      }
      if(url) ensureFontLoaded({ family: ff, url: url });

      var lim = currentTextLimit();
      var maxLines = (lim && lim.count) ? lim.count : 1;
      var lines = rawText.split('\n').slice(0, maxLines).map(function(s){ return String(s||'').trim(); });
      var hasAny = false;
      for(var li=0; li<lines.length; li++){
        if(lines[li]){ hasAny = true; break; }
      }
      if(!hasAny) return;
      var fill = threadColorHex(st.threadColor || '') || '#fff';
      var base = Math.min(w,h);
      /* The 12px floor is an absolute-pixel guard: on a small phone preview it clamps
         while the desktop preview does not, so the same design renders ~3x larger
         relative to the garment on mobile. Apparel scales purely with the preview so
         phone and desktop are the same picture at different sizes. */
      var fontSize;
      if(isApparel){
        fontSize = Math.max(1, base * 0.10 * (anchor.size / 100));
      }else{
        fontSize = Math.max(1, base * 0.10 * (anchor.size / 100));
      }
      var sizePct = fontSizePctForFamily(ff);
      if(sizePct && sizePct != 100){
        fontSize = isApparel ? Math.max(1, fontSize * (sizePct / 100))
                             : Math.max(1, fontSize * (sizePct / 100));
      }
      fontSize = socksCalibratedFontSize(ctx, ff, fontSize, h, anchor.size);
      var isSmallStage = false;
      var maxW = w * (placement === 'front' ? (isSmallStage ? 0.58 : 0.65) : (placement === 'back' ? (isSmallStage ? 0.46 : 0.50) : (isSmallStage ? 0.30 : 0.32)));
      if(isSocks) maxW = w * 0.12; // Center 53.1%, within the 47–60% cuff.
      if(isWinter) maxW = w * (isSmallStage ? 0.70 : 0.75);
      var maxH = h * (placement === 'front' ? (isSmallStage ? 0.18 : 0.22) : (placement === 'back' ? (isSmallStage ? 0.16 : 0.18) : (isSmallStage ? 0.14 : 0.16)));
      if(isWinter) maxH = h * (isSmallStage ? 0.22 : 0.26);
      if(isApparel){
        /* The admin slider owns the size and the character limit guarantees the fit, so the
           text must NOT auto-shrink per customer input — every order prints the same height.
           These bounds only stop text from bleeding off the mockup in an extreme setup. */
        maxW = w * 0.94;
        maxH = h * 0.94;
      }
      ctx.save();
      ctx.font = embW(ff) + ' ' + fontSize + 'px "' + String(ff).replace(/"/g,'\\"') + '", system-ui, -apple-system, Segoe UI, Roboto, Arial';
      var longest = 0;
      for(var mi=0; mi<lines.length; mi++){
        var t = lines[mi] || '';
        var mw = ctx.measureText(t).width;
        if(mw > longest) longest = mw;
      }
      ctx.restore();

      if(longest > maxW && longest > 0){
        var k = maxW / longest;
        fontSize = isApparel ? Math.max(1, fontSize * k) : Math.max(1, fontSize * k);
      }

      var x = (anchor.x / 100) * w;
      var y = (anchor.y / 100) * h;

      var lineGap = fontSize * 1.15;
      var totalH = lines.length * lineGap;
      if(totalH > maxH && totalH > 0){
        var kh = maxH / totalH;
        fontSize = isApparel ? Math.max(1, fontSize * kh) : Math.max(1, fontSize * kh);
        lineGap = fontSize * 1.15;
        totalH = lines.length * lineGap;
      }
      var startY = y - (totalH / 2) + (lineGap / 2);

      for(var i=0;i<lines.length;i++){
        if(lines[i]) drawEmbroideryTextLine(ctx, lines[i], x, startY + (i*lineGap), fontSize, ff, fill);
      }
    }

    function updateFramePreview(){
      if(!frameEl) return;
      if(_zoomActive) return;
      var eff = effectiveKind();
      if(eff !== 'image' && !(isTote && eff === 'text')){ frameEl.hidden = true; return; }
      var fr = getFrameForPlacement(activePlacement());
      var rect = frameToStageRect(fr);
      if(!rect){ frameEl.hidden = true; return; }

      var box = getImageBoxInStage();

      frameEl.hidden = false;
      frameEl.style.left = (box.x + rect.left) + 'px';
      frameEl.style.top = (box.y + rect.top) + 'px';
      frameEl.style.width = rect.w + 'px';
      frameEl.style.height = rect.h + 'px';
    }

    function updateImageOverlayPreview(){
      if(!overlayImg) return;
      if(_zoomActive) return;
      if(effectiveKind() !== 'image'){
        overlayImg.hidden = true;
        return;
      }
      var st = activeState();
      if(!st.bitmap && !st.previewUrl){
        overlayImg.hidden = true;
        if(dragTip) dragTip.hidden = true;
        return;
      }

      var fr = getFrameForPlacement(activePlacement());
      var rect = frameToStageRect(fr);
      if(!rect){
        overlayImg.hidden = true;
        if(dragTip) dragTip.hidden = true;
        return;
      }

      var box = getImageBoxInStage();

      overlayImg.hidden = false;
      if(dragTip){
        var dismissed = !!(st && st.overlay && st.overlay._dragHintDismissed);
        dragTip.hidden = dismissed ? true : false;
      }
      var nextSrc = st.previewUrl || '';
      if(overlayImg.src !== nextSrc){
        overlayImg.src = nextSrc;
      }
      var imgW = overlayImg.naturalWidth || 1;
      var imgH = overlayImg.naturalHeight || 1;
      var rot = (st.overlay && st.overlay.rot != null) ? (parseInt(st.overlay.rot, 10) || 0) : 0;
      rot = ((rot % 360) + 360) % 360;
      if(rot !== 90 && rot !== 180 && rot !== 270) rot = 0;
      if(st.overlay) st.overlay.rot = rot;
      var fit = (rot === 90 || rot === 270) ? Math.min(rect.w / imgH, rect.h / imgW) : Math.min(rect.w / imgW, rect.h / imgH);
      var scalePct = (st.overlay && st.overlay.scale) ? st.overlay.scale : 100;
      var r = getScaleRangeForPlacement(activePlacement());
      scalePct = clampNum(parseInt(scalePct, 10) || (r.max || 100), r.min, r.max);
      if(st.overlay) st.overlay.scale = scalePct;
      var sc = fit * (scalePct / 100);

      var drawW = imgW * sc;
      var drawH = imgH * sc;
      var bboxW = (rot === 90 || rot === 270) ? drawH : drawW;
      var bboxH = (rot === 90 || rot === 270) ? drawW : drawH;
      var ox = (st.overlay ? st.overlay.x : 0.5);
      var oy = (st.overlay ? st.overlay.y : 0.5);
      var minX = (bboxW / 2) / rect.w;
      var maxX = 1 - minX;
      var minY = (bboxH / 2) / rect.h;
      var maxY = 1 - minY;
      if(minX > maxX){ minX = maxX = 0.5; }
      if(minY > maxY){ minY = maxY = 0.5; }
      ox = Math.max(minX, Math.min(maxX, ox));
      oy = Math.max(minY, Math.min(maxY, oy));
      if(st.overlay){ st.overlay.x = ox; st.overlay.y = oy; }

      var cx = rect.left + (rect.w * ox);
      var cy = rect.top + (rect.h * oy);

      overlayImg.style.width = drawW + 'px';
      overlayImg.style.height = drawH + 'px';
      overlayImg.style.left = (box.x + cx) + 'px';
      overlayImg.style.top = (box.y + cy) + 'px';
      var fx = (st.overlay && st.overlay.flipX) ? -1 : 1;
      var fy = (st.overlay && st.overlay.flipY) ? -1 : 1;
      overlayImg.style.transform = 'translate(-50%,-50%) rotate(' + rot + 'deg) scale(' + fx + ',' + fy + ')';
    }

    function updateSideBadge(){
      var on = !!(isWinter && activePlacement() === 'back');
      try{ if(sideBadge) sideBadge.hidden = !on; }catch(e){}
      try{
        if(stageEl){
          if(on) stageEl.setAttribute('data-capkov-side', 'back');
          else stageEl.removeAttribute('data-capkov-side');
        }
      }catch(e){}
    }
    /* Zadní strana zimní čepice používá fotku předku, takže mockup pro výrobu dostane výrazný štítek ZADNÍ STRANA / BACK. */
    async function stampBackMockup(file){
      var url = '';
      try{
        if(!file) return file;
        url = URL.createObjectURL(file);
        var img = await loadImage(url);
        var w = img.naturalWidth || img.width || 0, h = img.naturalHeight || img.height || 0;
        if(!w || !h) return file;
        var cv = document.createElement('canvas');
        cv.width = w; cv.height = h;
        var cx = cv.getContext('2d');
        cx.drawImage(img, 0, 0, w, h);
        var fs = Math.max(16, Math.round(w * 0.04));
        var label = 'ZADNÍ STRANA / BACK';
        cx.font = '800 ' + fs + 'px system-ui, -apple-system, Segoe UI, Roboto, Arial';
        var tw = cx.measureText(label).width;
        var padX = fs * 0.9, padY = fs * 0.55, bw = tw + padX * 2, bh = fs + padY * 2;
        var bx = (w - bw) / 2, by = h * 0.035;
        cx.fillStyle = '#13233f';
        cx.beginPath();
        if(cx.roundRect) cx.roundRect(bx, by, bw, bh, bh / 2); else cx.rect(bx, by, bw, bh);
        cx.fill();
        cx.fillStyle = '#fff'; cx.textBaseline = 'middle'; cx.textAlign = 'center';
        cx.fillText(label, w / 2, by + bh / 2 + 1);
        var blob = await canvasToBlob(cv, 'image/jpeg', 0.92);
        return new File([blob], 'mockup.jpg', { type: 'image/jpeg' });
      }catch(e){ return file; }
      finally{ try{ if(url) URL.revokeObjectURL(url); }catch(e2){} }
    }
    function renderPreview(){
      publishBuilderState();
      if(!baseImg) return;
      try{ updateSideBadge(); }catch(e){}
      var eff = effectiveKind();
      var src = getBaseImageSrc();
      if(src && baseImg.getAttribute('src') !== src){
        try{ baseImg.style.opacity = '0.78'; }catch(e){}
        baseImg.src = src;
      }
      resizeCanvasToImage();
      updateFramePreview();
      updateImageOverlayPreview();
      if(eff === 'text'){
        drawTextPreview();
      }else{
        if(ctx) ctx.clearRect(0,0,canvas.width,canvas.height);
        if(textOverlayEl) textOverlayEl.hidden = true;
      }
    }

    if(baseImg){
      baseImg.addEventListener('load', function(){
        resizeCanvasToImage();
        updateFramePreview();
        updateImageOverlayPreview();
        try{ baseImg.style.opacity = '1'; }catch(e){}
        if(effectiveKind()==='text') drawTextPreview();
      });
    }

    window.addEventListener('resize', function(){
      resizeCanvasToImage();
      updateFramePreview();
      updateImageOverlayPreview();
      if(effectiveKind()==='text') drawTextPreview();
    });
    try{
      if(window.ResizeObserver && stageEl){
        var ro = new ResizeObserver(function(){
          resizeCanvasToImage();
          updateFramePreview();
          updateImageOverlayPreview();
          if(effectiveKind()==='text') drawTextPreview();
        });
        if(baseImg) ro.observe(baseImg);
        ro.observe(stageEl);
      }
    }catch(e){}
    var __previewWatch = { active:false, raf:0, w:0, h:0, x:0, y:0 };
    /* ---------------------------------------------------------------------------
       ZOOM — apparel only.
       Pointer devices: hovering the preview magnifies in place and follows the cursor.
       Touch: an explicit magnifier button turns zoom on, and only then do drag-to-pan
       and pinch apply. Gestures are never intercepted while zoom is off, so normal
       scrolling keeps working.
       Everything is queried from `modal`, not `root` — the modal is re-parented to
       <body> on init, so root.querySelector cannot see it.
       While zoomed, _zoomActive freezes the preview layout math, which reads
       getBoundingClientRect() and would otherwise re-lay-out the canvas every frame.
       --------------------------------------------------------------------------- */
    function setupZoom(){
      var scope = modal || root;
      if(!scope) return;
      var clip = scope.querySelector('[data-capkov-zoomclip]');
      var wrap = scope.querySelector('[data-capkov-zoom]');
      if(!clip || !wrap) return;
      var toggleBtn = scope.querySelector('[data-capkov-zoomtoggle]');
      var plusPath = scope.querySelector('[data-capkov-zoomplus]');

      var MIN = 1, MAX = 4, HOVER = 2.4, TAP_IN = 2.2;
      var scale = 1, tx = 0, ty = 0, zoomMode = false;
      var pointers = {}, pointerCount = 0, pinch = null, pan = null;

      var coarse = false;
      try{
        coarse = (window.matchMedia && (window.matchMedia('(hover: none)').matches || window.matchMedia('(pointer: coarse)').matches)) || ('ontouchstart' in window);
      }catch(e){ coarse = false; }

      function dist(a, b){ var dx = a.x - b.x, dy = a.y - b.y; return Math.sqrt(dx*dx + dy*dy); }
      function list(){
        var out = [];
        for(var k in pointers){ if(Object.prototype.hasOwnProperty.call(pointers, k)) out.push(pointers[k]); }
        return out;
      }

      /* Measured on the live hoodie: at scale 2.4 the mockup's getBoundingClientRect()
         reports 1342x1786 at offset -391,-521 instead of 559x744 at 0,0. So while the
         transform is live — including the 180ms transition back to 1x — every rect the
         preview layout reads is wrong. Unfreezing on the same tick as the un-zoom made
         the canvas re-lay-out from a mid-animation box and the text visibly jumped.
         Stay frozen until the transition has actually settled. */
      var _unfreeze = 0;

      function finishUnzoom(){
        _unfreeze = 0;
        _zoomActive = false;
        wrap.style.transformOrigin = '50% 50%';
        try{ applyZoomQuality(1); }catch(e){}
        try{ renderPreview(); }catch(e){}
      }

      function apply(anim){
        wrap.style.transition = anim ? 'transform .18s ease' : 'none';
        wrap.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
        var on = scale > 1.001;
        var was = _zoomActive;
        clip.setAttribute('data-zoomed', on ? 'true' : 'false');
        /* Panning must beat dragging the artwork inside the frame while zoomed. */
        try{ if(overlayImg) overlayImg.style.pointerEvents = on ? 'none' : ''; }catch(e){}

        if(_unfreeze){ try{ clearTimeout(_unfreeze); }catch(e){} _unfreeze = 0; }

        if(on){
          _zoomActive = true;
          try{ applyZoomQuality(scale); }catch(e){}
          return;
        }
        if(!was){ _zoomActive = false; return; }
        /* transform-origin is reset in finishUnzoom too — snapping it back mid-transition
           slides the content on its own. */
        if(anim){ _unfreeze = setTimeout(finishUnzoom, 240); }
        else { finishUnzoom(); }
      }

      function clampPan(){
        var r = clip.getBoundingClientRect();
        var mx = Math.max(0, (r.width  * scale - r.width)  / 2);
        var my = Math.max(0, (r.height * scale - r.height) / 2);
        tx = Math.max(-mx, Math.min(mx, tx));
        ty = Math.max(-my, Math.min(my, ty));
      }

      function setZoomMode(on){
        zoomMode = !!on;
        if(toggleBtn) toggleBtn.setAttribute('aria-pressed', zoomMode ? 'true' : 'false');
        /* the "+" stroke turns the magnifier into a minus when zoom is on */
        if(plusPath) plusPath.style.display = zoomMode ? 'none' : '';
        /* Only swallow touch gestures while actually zooming. */
        try{ clip.style.touchAction = zoomMode ? 'none' : ''; }catch(e){}
        if(zoomMode){
          lockOrigin();
          scale = TAP_IN; tx = 0; ty = 0; clampPan(); apply(true);
        }else{
          scale = MIN; tx = 0; ty = 0; apply(true);
        }
      }

      function reset(anim){
        zoomMode = false;
        if(toggleBtn) toggleBtn.setAttribute('aria-pressed', 'false');
        if(plusPath) plusPath.style.display = '';
        try{ clip.style.touchAction = ''; }catch(e){}
        scale = MIN; tx = 0; ty = 0;
        apply(anim !== false);
      }

      if(toggleBtn){
        toggleBtn.addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          setZoomMode(!zoomMode);
        });
      }

      /* The only thing worth magnifying is the print area, so the loupe locks onto it.
         Following the cursor made the design slide around under the pointer. */
      function focusOriginPct(){
        try{
          var f = null;
          if(effectiveKind() === 'image'){
            var fr = getFrameForPlacement(activePlacement());
            var nat = baseImageNatural();
            if(fr && nat.w && nat.h){
              f = { x: ((fr.left + fr.w / 2) / nat.w) * 100, y: ((fr.top + fr.h / 2) / nat.h) * 100 };
            }
          }
          if(!f){
            var a = pickTextAnchor(activePlacement());
            if(a) f = { x: a.x, y: a.y };
          }
          if(!f) return { x: 50, y: 50 };
          /* anchor % is relative to the mockup, transform-origin to the stage box */
          var box = getImageBoxInStage();
          var r = clip.getBoundingClientRect();
          if(!r.width || !r.height || !box.w || !box.h) return { x: 50, y: 50 };
          return {
            x: Math.max(0, Math.min(100, ((box.x + (f.x / 100) * box.w) / r.width) * 100)),
            y: Math.max(0, Math.min(100, ((box.y + (f.y / 100) * box.h) / r.height) * 100))
          };
        }catch(e){ return { x: 50, y: 50 }; }
      }

      function lockOrigin(){
        /* must be read before the transform is applied, the rects are untransformed then */
        var o = focusOriginPct();
        wrap.style.transformOrigin = o.x + '% ' + o.y + '%';
      }

      if(!coarse){
        /* ---- pointer devices: hover loupe, pinned to the print area ---- */
        clip.setAttribute('data-zoomable', 'true');
        var hoverLocked = false;
        clip.addEventListener('mouseenter', function(){
          if(hoverLocked) return;
          if(drag && drag.active) return;
          lockOrigin();
          scale = HOVER; tx = 0; ty = 0;
          apply(true);
        });
        clip.addEventListener('mouseleave', function(){ reset(true); });
        /* Dragging artwork must not fight the loupe. */
        clip.addEventListener('mousedown', function(){ hoverLocked = true; reset(false); });
        window.addEventListener('mouseup', function(){ hoverLocked = false; });
      }else{
        /* ---- touch: pan + pinch, but only once zoom mode is on ---- */
        clip.addEventListener('pointerdown', function(e){
          if(!zoomMode || e.pointerType === 'mouse') return;
          if(!pointers[e.pointerId]) pointerCount++;
          pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
          if(pointerCount === 2){
            var p = list();
            pinch = { d: dist(p[0], p[1]), s: scale, tx: tx, ty: ty,
                      cx: (p[0].x + p[1].x) / 2, cy: (p[0].y + p[1].y) / 2 };
            pan = null;
          }else if(pointerCount === 1){
            pan = { x: e.clientX, y: e.clientY, tx: tx, ty: ty };
          }
        });

        clip.addEventListener('pointermove', function(e){
          if(!zoomMode || !pointers[e.pointerId]) return;
          pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
          if(pinch && pointerCount >= 2){
            var p = list();
            var nd = dist(p[0], p[1]);
            if(pinch.d > 0){
              scale = Math.max(MIN, Math.min(MAX, pinch.s * (nd / pinch.d)));
              var mx = (p[0].x + p[1].x) / 2, my = (p[0].y + p[1].y) / 2;
              tx = pinch.tx + (mx - pinch.cx);
              ty = pinch.ty + (my - pinch.cy);
              clampPan(); apply(false);
            }
            if(e.cancelable) e.preventDefault();
          }else if(pan && pointerCount === 1){
            tx = pan.tx + (e.clientX - pan.x);
            ty = pan.ty + (e.clientY - pan.y);
            clampPan(); apply(false);
            if(e.cancelable) e.preventDefault();
          }
        }, { passive: false });

        function endPointer(e){
          if(pointers[e.pointerId]){ delete pointers[e.pointerId]; pointerCount = Math.max(0, pointerCount - 1); }
          if(pointerCount < 2) pinch = null;
          if(pointerCount !== 0) return;
          pan = null;
          if(!zoomMode) return;
          if(scale <= 1.05){ setZoomMode(false); return; }
          clampPan(); apply(true);
        }
        clip.addEventListener('pointerup', endPointer);
        clip.addEventListener('pointercancel', endPointer);
      }

      zoomResetExternal = function(){ reset(false); };
    }

    function startPreviewWatch(){
      if(__previewWatch.active) return;
      __previewWatch.active = true;
      function tick(){
        if(!__previewWatch.active) return;
        try{
          if(!_zoomActive && modal && modal.getAttribute('data-open') === 'true'){
            var box = getImageBoxInStage();
            var w2 = box.w || 0;
            var h2 = box.h || 0;
            var x2 = box.x || 0;
            var y2 = box.y || 0;
            if(w2 && h2 && (Math.abs(w2-__previewWatch.w) > 0.5 || Math.abs(h2-__previewWatch.h) > 0.5 || Math.abs(x2-__previewWatch.x) > 0.5 || Math.abs(y2-__previewWatch.y) > 0.5)){
              __previewWatch.w = w2; __previewWatch.h = h2; __previewWatch.x = x2; __previewWatch.y = y2;
              resizeCanvasToImage();
              updateFramePreview();
              updateImageOverlayPreview();
              if(effectiveKind() === 'text') drawTextPreview();
            }
          }
        }catch(e){}
        __previewWatch.raf = requestAnimationFrame(tick);
      }
      __previewWatch.raf = requestAnimationFrame(tick);
    }
    function stopPreviewWatch(){
      __previewWatch.active = false;
      try{ if(__previewWatch.raf) cancelAnimationFrame(__previewWatch.raf); }catch(e){}
      __previewWatch.raf = 0;
    }
    var drag = { active:false, startX:0, startY:0, startOx:0, startOy:0 };
    function onPointerDown(e){
      if(effectiveKind() !== 'image') return;
      var st = activeState();
      if(!st.previewUrl) return;
      var fr = getFrameForPlacement(activePlacement());
      var rect = frameToStageRect(fr);
      if(!rect) return;

      drag.active = true;
      drag.startX = e.clientX;
      drag.startY = e.clientY;
      drag.startOx = st.overlay.x;
      drag.startOy = st.overlay.y;
      try{ if(st && st.overlay) st.overlay._dragHintDismissed = true; }catch(err){}
      if(dragTip) dragTip.hidden = true;
      try{ overlayImg.style.cursor = 'grabbing'; }catch(err){}
      try{ overlayImg.setPointerCapture(e.pointerId); }catch(err){}
      e.preventDefault();
    }
    function onPointerMove(e){
      if(!drag.active) return;
      var st = activeState();
      var fr = getFrameForPlacement(activePlacement());
      var rect = frameToStageRect(fr);
      if(!rect) return;
      var dx = e.clientX - drag.startX;
      var dy = e.clientY - drag.startY;
      var nx = drag.startOx + (dx / rect.w);
      var ny = drag.startOy + (dy / rect.h);
      var imgW = overlayImg ? overlayImg.naturalWidth : 0;
      var imgH = overlayImg ? overlayImg.naturalHeight : 0;
      if(imgW && imgH){
        var r = getScaleRangeForPlacement(activePlacement());
        var scalePct = clampNum(parseInt((st.overlay.scale || (r.max || 100)), 10) || (r.max || 100), r.min, r.max);
        var rot = (st.overlay && st.overlay.rot != null) ? (parseInt(st.overlay.rot, 10) || 0) : 0;
        rot = ((rot % 360) + 360) % 360;
        if(rot !== 90 && rot !== 180 && rot !== 270) rot = 0;
        var fit = (rot === 90 || rot === 270) ? Math.min(rect.w / imgH, rect.h / imgW) : Math.min(rect.w / imgW, rect.h / imgH);
        var sc = fit * (scalePct / 100);
        var drawW = imgW * sc;
        var drawH = imgH * sc;

        var bboxW = (rot === 90 || rot === 270) ? drawH : drawW;
        var bboxH = (rot === 90 || rot === 270) ? drawW : drawH;

        var minX = (bboxW / 2) / rect.w;
        var maxX = 1 - minX;
        var minY = (bboxH / 2) / rect.h;
        var maxY = 1 - minY;
        if(minX > maxX){ minX = maxX = 0.5; }
        if(minY > maxY){ minY = maxY = 0.5; }
        nx = Math.max(minX, Math.min(maxX, nx));
        ny = Math.max(minY, Math.min(maxY, ny));
      }else{
        nx = Math.max(0, Math.min(1, nx));
        ny = Math.max(0, Math.min(1, ny));
      }

      st.overlay.x = nx;
      st.overlay.y = ny;
      updateImageOverlayPreview();
    }
    function onPointerUp(){
      drag.active = false;
      try{ if(overlayImg) overlayImg.style.cursor = 'grab'; }catch(err){}
    }
    if(overlayImg){
      overlayImg.addEventListener('pointerdown', onPointerDown);
      overlayImg.addEventListener('pointermove', onPointerMove);
      overlayImg.addEventListener('pointerup', onPointerUp);
      overlayImg.addEventListener('pointercancel', onPointerUp);
      overlayImg.addEventListener('lostpointercapture', onPointerUp);
    }
    var tdrag = { active:false, startX:0, startY:0, startOx:0, startOy:0 };
    function onTextPointerDown(e){
      if(!isTote) return;
      if(effectiveKind() !== 'text') return;
      var st = activeState();
      if(!st) return;
      var raw = String(st.text || '');
      if(!raw.replace(/\s+/g,'').length) return;

      var fr = getFrameForPlacement(activePlacement());
      var rect = frameToStageRect(fr);
      if(!rect) return;
      try{
        var ir = baseImg ? baseImg.getBoundingClientRect() : null;
        if(ir){
          var ix = e.clientX - ir.left;
          var iy = e.clientY - ir.top;
          if(ix < rect.left || ix > (rect.left + rect.w) || iy < rect.top || iy > (rect.top + rect.h)) return;
        }
      }catch(err){}

      if(!st.textOverlay) st.textOverlay = { x:0.5, y:0.5, orient:'h', mirror:false, rot:0, sizeTier:'m' };

      tdrag.active = true;
      tdrag.startX = e.clientX;
      tdrag.startY = e.clientY;
      tdrag.startOx = st.textOverlay.x;
      tdrag.startOy = st.textOverlay.y;
      try{ st.textOverlay._dragHintDismissed = true; }catch(err){}
      if(dragTip) dragTip.hidden = true;
      try{ canvas.style.cursor = 'grabbing'; }catch(err){}
      try{ canvas.setPointerCapture(e.pointerId); }catch(err){}
      e.preventDefault();
    }
    function onTextPointerMove(e){
      if(!tdrag.active) return;
      if(effectiveKind() !== 'text') return;
      var st = activeState();
      if(!st || !st.textOverlay) return;
      var fr = getFrameForPlacement(activePlacement());
      var rect = frameToStageRect(fr);
      if(!rect) return;

      var dx = e.clientX - tdrag.startX;
      var dy = e.clientY - tdrag.startY;
      var nx = tdrag.startOx + (dx / rect.w);
      var ny = tdrag.startOy + (dy / rect.h);
      var bw = (st.textOverlay._boxW != null) ? Number(st.textOverlay._boxW) : (rect.w * 0.4);
      var bh = (st.textOverlay._boxH != null) ? Number(st.textOverlay._boxH) : (rect.h * 0.2);
      if(!isFinite(bw) || bw <= 0) bw = rect.w * 0.4;
      if(!isFinite(bh) || bh <= 0) bh = rect.h * 0.2;
      var minX = (bw / 2) / rect.w;
      var maxX = 1 - minX;
      var minY = (bh / 2) / rect.h;
      var maxY = 1 - minY;
      if(minX > maxX){ minX = maxX = 0.5; }
      if(minY > maxY){ minY = maxY = 0.5; }

      nx = Math.max(minX, Math.min(maxX, nx));
      ny = Math.max(minY, Math.min(maxY, ny));

      st.textOverlay.x = nx;
      st.textOverlay.y = ny;
      drawTextPreview();
    }
    function onTextPointerUp(){
      tdrag.active = false;
      try{ if(canvas && (isTote && effectiveKind()==='text')) canvas.style.cursor = 'grab'; }catch(err){}
    }
    if(canvas){
      canvas.addEventListener('pointerdown', onTextPointerDown);
      canvas.addEventListener('pointermove', onTextPointerMove);
      canvas.addEventListener('pointerup', onTextPointerUp);
      canvas.addEventListener('pointercancel', onTextPointerUp);
      canvas.addEventListener('lostpointercapture', onTextPointerUp);
    }
    function fontUrlForFamily(family){
      var fam = String(family || '').trim();
      if(!fam) return '';
      try{
        if(fontSelect){
          var opt = fontSelect.querySelector('option[value="' + cssEscape(fam) + '"]');
          if(opt){
            var u = String(opt.getAttribute('data-font-url') || '').trim();
            if(u) return u;
          }
        }
      }catch(e){}
      try{
        var list = fonts || (capkovConfig && capkovConfig.fonts) || [];
        if(Array.isArray(list)){
          for(var i=0; i<list.length; i++){
            var f = list[i];
            if(!f) continue;
            if(String(f.family || '').trim() === fam){
              var u2 = String(f.url || f.src || '').trim();
              if(u2) return u2;
              break;
            }
          }
        }
      }catch(e){}

      return '';
    }
    async function ensurePdfJs(){
      if(window.pdfjsLib && window.pdfjsLib.getDocument) return window.pdfjsLib;

      function loadScript(src){
        return new Promise(function(resolve,reject){
          var s = document.createElement('script');
          s.src = src;
          s.async = true;
          s.onload = function(){ resolve(true); };
          s.onerror = function(){ reject(new Error('load failed')); };
          document.head.appendChild(s);
        });
      }
      var sources = [
        { script: '/assets/pdf.min.js', worker: '/assets/pdf.worker.min.js' },
        { script: 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js', worker: 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js' },
        { script: 'https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.min.js', worker: 'https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js' },
        { script: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.min.js', worker: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.worker.min.js' }
      ];

      var chosenWorker = '';
      for(var i=0;i<sources.length;i++){
        try{
          await loadScript(sources[i].script);
          if(window.pdfjsLib && window.pdfjsLib.getDocument){
            chosenWorker = sources[i].worker || '';
            break;
          }
        }catch(e){}
      }

      if(window.pdfjsLib && window.pdfjsLib.GlobalWorkerOptions){
        try{
          window.pdfjsLib.GlobalWorkerOptions.workerSrc = chosenWorker || 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
        }catch(e){}
      }

      return window.pdfjsLib;
    }

    async function rasterizePdf(file){
      var lib = await ensurePdfJs();
      if(!lib) throw new Error('PDF.js not available');
      var ab = await file.arrayBuffer();
      var pdf = await lib.getDocument({ data: ab }).promise;
      var page = await pdf.getPage(1);
      var viewport = page.getViewport({ scale: 2 });
      var c = document.createElement('canvas');
      c.width = viewport.width;
      c.height = viewport.height;
      var cctx = c.getContext('2d');
      await page.render({ canvasContext: cctx, viewport: viewport }).promise;
      return await new Promise(function(resolve){
        c.toBlob(function(blob){
          var url = blob ? URL.createObjectURL(blob) : '';
          resolve({ blob: blob, url: url, w: c.width, h: c.height });
        }, 'image/png', 0.92);
      });
    }

    async function fileToPreview(file){
      var type = String(file.type||'');
      var name = String(file.name||'').toLowerCase();
      if(type === 'application/pdf' || name.endsWith('.pdf')){
        return await rasterizePdf(file);
      }
      var url = URL.createObjectURL(file);
      return { blob: null, url: url, w: 0, h: 0 };
    }

    function revokePreviewUrl(st){
      try{ if(st.previewUrl && st.previewUrl.startsWith('blob:')) URL.revokeObjectURL(st.previewUrl); }catch(e){}
      st.previewUrl = '';
    }
    if(designInput){
      designInput.addEventListener('input', function(){ state.designName = designInput.value || ''; });
    }
    if(noteInput){
      noteInput.addEventListener('input', function(){
        state.note = noteInput.value || '';
        scheduleAutoApply();
      });
    }
    if(toteOrientTabs){
      toteOrientTabs.addEventListener('click', function(ev){
        var tgt = ev.target;
        if(!tgt) return;
        var btn = tgt.closest ? tgt.closest('button[data-capkov-tote-orient]') : null;
        if(!btn) return;
        var next = String(btn.getAttribute('data-capkov-tote-orient') || 'h').toLowerCase();
        var st = activeState();
        if(!st) return;
        if(!st.textOverlay) st.textOverlay = { x:0.5, y:0.5, orient:'h', mirror:false, rot:0, sizeTier:'m' };
        next = (next === 'v') ? 'v' : 'h';
        st.textOverlay.orient = next;
        st.textOverlay.rot = (next === 'v') ? (st.textOverlay.mirror ? 270 : 90) : 0;
        try{
          if(textInput && String(effectiveKind() || '') === 'text'){
            var beforeTxt = String(st.text || '');
            var clampedTxt = clampTextByLimit(beforeTxt);
            if(clampedTxt !== beforeTxt){
              st.text = clampedTxt;
            }
            st.textOverlay._textByTier = st.textOverlay._textByTier || {};
            var __tierO = String(st.textOverlay.sizeTier || 'm').toLowerCase();
            if(__tierO !== 's' && __tierO !== 'm' && __tierO !== 'l' && __tierO !== 'xl') __tierO = 'm';
            st.textOverlay._textByTier[__tierO] = String(st.text || '');
          }
        }catch(e){}
        syncModeUI();
        syncUiFromState();
        renderPreview();
      });
    }
    if(toteMirrorTabs){
      toteMirrorTabs.addEventListener('click', function(ev){
        var tgt = ev.target;
        if(!tgt) return;
        var btn = tgt.closest ? tgt.closest('button[data-capkov-tote-mirror]') : null;
        if(!btn) return;
        var next = String(btn.getAttribute('data-capkov-tote-mirror') || 'off').toLowerCase();
        var st = activeState();
        if(!st) return;
        if(!st.textOverlay) st.textOverlay = { x:0.5, y:0.5, orient:'h', mirror:false, rot:0, sizeTier:'m' };
        st.textOverlay.mirror = (next === 'on');
        st.textOverlay.rot = (st.textOverlay.orient === 'v') ? (st.textOverlay.mirror ? 270 : 90) : 0;
        syncUiFromState();
        renderPreview();
      });
    }
    if(toteSizeSelect){
      toteSizeSelect.addEventListener('change', function(){
        var st = activeState();
        if(!st) return;
        if(!st.textOverlay) st.textOverlay = { x:0.5, y:0.5, orient:'h', mirror:false, rot:0, sizeTier:'m' };
        st.textOverlay._textByTier = st.textOverlay._textByTier || {};

        var prevTier = String(st.textOverlay.sizeTier || 'm').toLowerCase();
        if(prevTier !== 's' && prevTier !== 'm' && prevTier !== 'l' && prevTier !== 'xl') prevTier = 'm';
        st.textOverlay._textByTier[prevTier] = String(st.text || '');

        var v = String(toteSizeSelect.value || 'm').toLowerCase();
        if(v !== 's' && v !== 'm' && v !== 'l' && v !== 'xl') v = 'm';
        st.textOverlay.sizeTier = v;
        if(st.textOverlay._textByTier[v] != null){
          st.text = String(st.textOverlay._textByTier[v] || '');
        }
        try{
          if(textInput && String(effectiveKind() || '') === 'text'){
            var beforeTxt2 = String(st.text || '');
            var clampedTxt2 = clampTextByLimit(beforeTxt2);
            if(clampedTxt2 !== beforeTxt2){
              st.text = clampedTxt2;
            }
            st.textOverlay._textByTier[v] = String(st.text || '');
          }
        }catch(e){}
        syncUiFromState();
        renderPreview();
      });
    }
    if(toteRotTabs){
      toteRotTabs.addEventListener('click', function(ev){
        var tgt = ev.target;
        if(!tgt) return;
        var btn = tgt.closest ? tgt.closest('button[data-capkov-tote-rot]') : null;
        if(!btn) return;
        var next = parseInt(btn.getAttribute('data-capkov-tote-rot') || '0', 10) || 0;
        next = ((next % 360) + 360) % 360;
        if(next !== 90 && next !== 180 && next !== 270) next = 0;

        var st = activeState();
        if(!st) return;
        if(!st.overlay) st.overlay = { x:0.5, y:0.5, scale:100, flipX:false, flipY:false, rot:0 };
        st.overlay.rot = next;
        syncUiFromState();
        updateImageOverlayPreview();
      });
    }
    if(toteFlipTabs){
      toteFlipTabs.addEventListener('click', function(ev){
        var tgt = ev.target;
        if(!tgt) return;
        var btn = tgt.closest ? tgt.closest('button[data-capkov-tote-flip]') : null;
        if(!btn) return;
        var axis = String(btn.getAttribute('data-capkov-tote-flip') || '').toLowerCase();
        var st = activeState();
        if(!st) return;
        if(!st.overlay) st.overlay = { x:0.5, y:0.5, scale:100, flipX:false, flipY:false, rot:0 };
        if(axis === 'x'){
          st.overlay.flipX = !st.overlay.flipX;
          if(st.overlay.flipX) st.overlay.flipY = false;
        }
        if(axis === 'y'){
          st.overlay.flipY = !st.overlay.flipY;
          if(st.overlay.flipY) st.overlay.flipX = false;
        }
        syncUiFromState();
        updateImageOverlayPreview();
      });
    }
    if(contentKindTabs){
      contentKindTabs.addEventListener('click', function(ev){
        var tgt = ev.target;
        if(!tgt) return;
        var btn = tgt.closest ? tgt.closest('button[data-capkov-content-kind]') : null;
        if(!btn) return;
        if(!isImageMixed) return;

        var p = activePlacement();

        var next = String(btn.getAttribute('data-capkov-content-kind') || '').toLowerCase();
        var st = state.byPlacement[p];
        if(!st) return;
        st.contentKind = (next === 'text') ? 'text' : 'image';
        syncModeUI();
        syncUiFromState();
        renderThreadColors();
        renderPreview();
        try{ updatePricesUI(); }catch(e){}
      });
    }

    if(textInput){
      textInput.addEventListener('input', function(){
        var st = activeState();
        var before = textInput.value || '';
        var caret = 0;
        try{ caret = (typeof textInput.selectionStart === 'number') ? textInput.selectionStart : before.length; }catch(e){ caret = before.length; }
        var clamped = clampTextByLimit(before);
        if(clamped !== before){
          var prefix = before.slice(0, caret);
          var clampedPrefix = clampTextByLimit(prefix);
          textInput.value = clamped;
          var newPos = clampedPrefix.length;
          try{ textInput.setSelectionRange(newPos, newPos); }catch(e){}
        }
        st.text = textInput.value || '';
        if(isSocks) renderTextLimitHelp();
        if(isTote){
          try{
            if(st && st.textOverlay){
              st.textOverlay._textByTier = st.textOverlay._textByTier || {};
              var __tierI = String(st.textOverlay.sizeTier || 'm').toLowerCase();
              if(__tierI !== 's' && __tierI !== 'm' && __tierI !== 'l' && __tierI !== 'xl') __tierI = 'm';
              st.textOverlay._textByTier[__tierI] = String(st.text || '');
            }
          }catch(e){}
        }
        renderPreview();
        try{ updateTabsFilled(); }catch(e){}
      });
    }

    if(fontSelect){
      fontSelect.addEventListener('change', function(){
        var st = activeState();
        st.font = fontSelect.value || '';
        var opt = fontSelect.querySelector('option[value="' + cssEscape(st.font) + '"]');
        var p = null;
        if(opt){
          var url = String(opt.getAttribute('data-font-url')||'').trim();
          if(url) p = ensureFontLoaded({ family: st.font, url: url });
        }
        try{
          if(isTote && textInput && String(effectiveKind() || '') === 'text'){
            var beforeF = String(st.text || '');
            var clampedF = clampTextByLimit(beforeF);
            if(clampedF !== beforeF){
              st.text = clampedF;
              textInput.value = clampedF;
            }
            if(st.textOverlay){
              st.textOverlay._textByTier = st.textOverlay._textByTier || {};
              var __tierF = String(st.textOverlay.sizeTier || 'm').toLowerCase();
              if(__tierF !== 's' && __tierF !== 'm' && __tierF !== 'l' && __tierF !== 'xl') __tierF = 'm';
              st.textOverlay._textByTier[__tierF] = String(st.text || '');
            }
          }
        }catch(e){}
        renderPreview();
        try{
          if(p && typeof p.then === 'function'){
            p.then(function(){
              try{
                if(isTote && textInput && String(effectiveKind() || '') === 'text'){
                  var beforeF2 = String(st.text || '');
                  var clampedF2 = clampTextByLimit(beforeF2);
                  if(clampedF2 !== beforeF2){
                    st.text = clampedF2;
                    textInput.value = clampedF2;
                    if(st.textOverlay){
                      st.textOverlay._textByTier = st.textOverlay._textByTier || {};
                      var __tierF2 = String(st.textOverlay.sizeTier || 'm').toLowerCase();
                      if(__tierF2 !== 's' && __tierF2 !== 'm' && __tierF2 !== 'l' && __tierF2 !== 'xl') __tierF2 = 'm';
                      st.textOverlay._textByTier[__tierF2] = String(st.text || '');
                    }
                    renderPreview();
                  }
                }
              }catch(e){}
            });
          }
        }catch(e){}
      });
    }

    if(fileInput){
      fileInput.addEventListener('change', async function(){
        showError('');
        var st = activeState();
        revokePreviewUrl(st);
        st.file = null;
        st.bitmap = null;

        var file = fileInput.files && fileInput.files[0] ? fileInput.files[0] : null;
        if(!file){
          syncUiFromState();

          renderPreview();

          requestAnimationFrame(function(){

            resizeCanvasToImage();

            renderPreview();

            requestAnimationFrame(function(){

              resizeCanvasToImage();

              renderPreview();

            });

          });
          return;
        }

        st.file = file;
        try{
          var pv = await fileToPreview(file);
          st.previewUrl = pv.url || '';
        }catch(e){
          st.previewUrl = '';
          showError(RT('n.b1a6ae7', 'Soubor se nepodařilo načíst.'));
        }
        st.overlay = { x: 0.5, y: 0.5, scale: 100, flipX: false, flipY: false, rot: 0 };
        syncUiFromState();
        renderPreview();
        try{ updateTabsFilled(); }catch(e){}
      });
    }

    if(clearFileBtn){
      clearFileBtn.addEventListener('click', function(){
        var st = activeState();
        revokePreviewUrl(st);
        st.file = null;
        st.bitmap = null;
        st.overlay = { x: 0.5, y: 0.5, scale: 100, flipX: false, flipY: false, rot: 0 };
        if(fileInput) fileInput.value = '';
        syncUiFromState();
        renderPreview();
        try{ updateTabsFilled(); }catch(e){}
      });
    }

    if(scaleInput){
      scaleInput.addEventListener('input', function(){
        var st = activeState();
        if(!st || !st.overlay) return;
        var v = parseInt(String(scaleInput.value||'100'),10) || 100;
        var min = parseInt(String(scaleInput.min||'1'),10) || 1;
        var max = parseInt(String(scaleInput.max||'100'),10) || 100;
        if(min > max) min = max;
        if(v < min) v = min;
        if(v > max) v = max;
        st.overlay.scale = v;
        scaleInput.value = String(v);
        if(scaleLabel) scaleLabel.textContent = String(v) + '%';
        updateImageOverlayPreview();
      });
    }
    function hasPlacementContent(p){
      var st = state.byPlacement[p];
      if(!st) return false;
      var pk = placementContentKind(p);
      if(pk === 'text') return !!normalizeSpaces(st.text);
      if(pk === 'image') return !!st.file;
      if(pk === 'color') return true;
      return false;
    }

    function selectedPlacements(){
      return PLACEMENTS.filter(function(p){ return hasPlacementContent(p); });
    }

    function computePaidPlacements(sel){
      if(isSocks || kind === 'color') return [];
      if(isTote){
        return hasPlacementContent('back') ? ['back'] : [];
      }
      var selected = sel || selectedPlacements();
      if(!selected.length) return [];
      var free = selected.indexOf('front') !== -1 ? 'front' : selected[0];
      return selected.filter(function(p){ return p !== free; });
    }
    // Read-only UI snapshot: use the same placement predicates as cart submission.
    root.__capkovBuilderState = function(){
      var selected = selectedPlacements();
      var colors = {};
      selected.forEach(function(p){
        if(placementContentKind(p) !== 'text' && kind !== 'color') return;
        var c = String(state.byPlacement[p].threadColor || '').trim();
        colors[p] = { color: c, paid: !!c && !isNoFeeColor(c) };
      });
      return { selected: selected, paid: computePaidPlacements(selected), colors: colors };
    };
    var lastBuilderState = '';
    function publishBuilderState(){
      if(!root.__capkovBuilderState) return;
      var snapshot = root.__capkovBuilderState();
      var signature = JSON.stringify(snapshot);
      if(signature === lastBuilderState) return;
      lastBuilderState = signature;
      document.dispatchEvent(new CustomEvent('capkov:builder-state', {
        detail: { root: root, selected: snapshot.selected, paid: snapshot.paid, colors: snapshot.colors }
      }));
    }
    function buildCustomerSummary(kind, selectedPlacements){
      function fontLabel(family){
        family = normalizeSpaces(family);
        if(!family) return '';
        var list = (Array.isArray(fonts) && fonts.length) ? fonts : (capkovConfig.fonts || []);
        for(var i=0;i<list.length;i++){
          if(list[i] && String(list[i].family||'') === family){
            return String(list[i].label || list[i].family || family);
          }
        }
        return family;
      }
      function trunc(s, n){
        s = normalizeSpaces(s);
        if(!s) return '';
        if(s.length <= n) return s;
        return s.slice(0, Math.max(0, n-1)) + '…';
      }
      function uniq(arr){
        return Array.from(new Set(arr.filter(function(x){ return x != null && String(x).trim() !== ''; }).map(function(x){ return String(x); })));
      }

      var parts = [];
      var placeLabels = (function(){
        if(isTote){
          return { front: RT('n.4498838', 'Přední strana'), back: RT('n.93968bf', 'Zadní strana') };
        }
        if(isApparel){
          var apOut = {};
          APPAREL_PLACEMENTS.forEach(function(p){ apOut[p] = placementLabel(p); });
          return apOut;
        }
        return { front: RT('n.a63b944', 'Předek'), back: RT('n.4dd1bda', 'Zadek'), side_left: RT('n.1257ae9', 'Levá strana'), side_right: RT('n.42781f0', 'Pravá strana') };
      })();
      var L = {
        text: RT('n.96090c7', 'Text'),
        font: RT('n.10b4ab9', 'Písmo'),
        thread: RT('n.2a191e1', 'Nit'),
        image: RT('n.b599124', 'Obrázek'),
        threadColor: RT('n.8088487', 'Barva nitě')
      };
      function labelFor(p){ return placeLabels[p] || p; }

      if(kind === 'text'){
        var withText = (selectedPlacements||[]).filter(function(p){
          var t = state.byPlacement[p] && state.byPlacement[p].text;
          return normalizeSpaces(t) !== '';
        });

        if(withText.length){
          var textPairs = withText.map(function(p){
            var t = String(state.byPlacement[p] && state.byPlacement[p].text || '');
            t = t.split(/\r?\n/)[0] || '';
            t = trunc(t, 24);
            return labelFor(p) + ' „' + t + '"';
          });
          parts.push(L.text + ': ' + textPairs.join(', '));
        }else{
          parts.push(L.text + ': —');
        }
        var fontPairs = withText.map(function(p){
          var f = state.byPlacement[p] && state.byPlacement[p].font;
          return { p: p, f: normalizeSpaces(f) };
        }).filter(function(x){ return x.f !== ''; });

        if(fontPairs.length){
          var uniqFonts = uniq(fontPairs.map(function(x){ return x.f; }));
          if(uniqFonts.length === 1){
            parts.push(L.font + ': ' + fontLabel(uniqFonts[0]));
          }else{
            parts.push(L.font + ': ' + fontPairs.map(function(x){
              return labelFor(x.p) + '=' + fontLabel(x.f);
            }).join(', '));
          }
        }
        var threadPairs = withText.map(function(p){
          var c = state.byPlacement[p] && state.byPlacement[p].threadColor;
          return { p: p, c: normalizeSpaces(c) };
        }).filter(function(x){ return x.c !== ''; });

        if(threadPairs.length){
          var uniqThreads = uniq(threadPairs.map(function(x){ return x.c; }));
          if(uniqThreads.length === 1){
            parts.push(L.thread + ': ' + uniqThreads[0]);
          }else{
            parts.push(L.thread + ': ' + threadPairs.map(function(x){
              return labelFor(x.p) + '=' + x.c;
            }).join(', '));
          }
        }

        return parts.join(' • ');
      }

      if(kind === 'image'){
        if(isImageMixed){
          var sel = (selectedPlacements || []);
          var imgPl = sel.filter(function(p){
            return placementContentKind(p) === 'image' && (state.byPlacement[p] && state.byPlacement[p].file);
          });
          var txtPl = sel.filter(function(p){
            return placementContentKind(p) === 'text' && normalizeSpaces(state.byPlacement[p] && state.byPlacement[p].text) !== '';
          });

          parts.push(L.image + ': ' + (imgPl.length ? imgPl.map(labelFor).join(', ') : '—'));

          if(txtPl.length){
            var textPairs2 = txtPl.map(function(p){
              var t = String(state.byPlacement[p] && state.byPlacement[p].text || '');
              t = t.split(/\r?\n/)[0] || '';
              t = trunc(t, 24);
              return labelFor(p) + ' „' + t + '"';
            });
            parts.push(L.text + ': ' + textPairs2.join(', '));
            var fontPairs2 = txtPl.map(function(p){
              var f = state.byPlacement[p] && state.byPlacement[p].font;
              return { p: p, f: normalizeSpaces(f) };
            }).filter(function(x){ return x.f !== ''; });
            if(fontPairs2.length){
              var uniqFonts2 = uniq(fontPairs2.map(function(x){ return x.f; }));
              if(uniqFonts2.length === 1){
                parts.push(L.font + ': ' + fontLabel(uniqFonts2[0]));
              }else{
                parts.push(L.font + ': ' + fontPairs2.map(function(x){
                  return labelFor(x.p) + '=' + fontLabel(x.f);
                }).join(', '));
              }
            }
            var threadPairs2 = txtPl.map(function(p){
              var c = state.byPlacement[p] && state.byPlacement[p].threadColor;
              return { p: p, c: normalizeSpaces(c) };
            }).filter(function(x){ return x.c !== ''; });
            if(threadPairs2.length){
              var uniqThreads2 = uniq(threadPairs2.map(function(x){ return x.c; }));
              if(uniqThreads2.length === 1){
                parts.push(L.thread + ': ' + uniqThreads2[0]);
              }else{
                parts.push(L.thread + ': ' + threadPairs2.map(function(x){
                  return labelFor(x.p) + '=' + x.c;
                }).join(', '));
              }
            }
          }

          return parts.join(' • ');
        }

        parts.push(L.image + ': ' + (selectedPlacements||[]).map(labelFor).join(', '));
        return parts.join(' • ');
      }

      if(kind === 'color'){
        var st = state.byPlacement.front || {};
        parts.push(L.threadColor + ': ' + (st.threadColor || '—'));
        return parts.join(' • ');
      }

      return '';
    }
    function cssEscape(s){
      try{ if(window.CSS && CSS.escape) return CSS.escape(String(s)); }catch(e){}
      return String(s).replace(/"/g,'\"');
    }

    function upsertHidden(form, name, value){
      if(!form) return;
      var sel = 'input[type="hidden"][name="' + cssEscape(name) + '"]';
      var el = form.querySelector(sel);
      if(!el){
        el = document.createElement('input');
        el.type = 'hidden';
        el.name = name;
        form.appendChild(el);
      }
      try{ el.setAttribute('data-capkov-prop', '1'); }catch(e){}
      el.value = String(value == null ? '' : value);
    }

    function upsertFile(form, name, file){
      if(!form) return;
      var sel = 'input[type="file"][name="' + cssEscape(name) + '"]';
      var el = form.querySelector(sel);
      if(!el){
        el = document.createElement('input');
        el.type = 'file';
        el.name = name;
        el.style.display = 'none';
        form.appendChild(el);
      }
      var dt = new DataTransfer();
      dt.items.add(file);
      el.files = dt.files;
    }

    function renameFile(file, newName){
      try{
        return new File([file], newName, { type: file.type });
      }catch(e){
        file.__capkov_renamed = newName;
        return file;
      }
    }
    var __imgMemo = {}, __imgMemoKeys = [];
    function loadImage(src){
      /* ATCFB 7.10: základ mockupu se předehřeje při otevření okna; při kliknutí na Přidat už se nestahuje ani nedekóduje znovu */
      var memo = /^(https?:)?\//.test(String(src || ''));
      if(memo && __imgMemo[src]) return __imgMemo[src];
      var p = new Promise(function(resolve,reject){
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function(){ resolve(img); };
        img.onerror = function(){ reject(new Error('img load failed')); };
        img.src = src;
      });
      if(memo){
        __imgMemo[src] = p; __imgMemoKeys.push(src);
        if(__imgMemoKeys.length > 12){ delete __imgMemo[__imgMemoKeys.shift()]; }
        p.catch(function(){ if(__imgMemo[src] === p) delete __imgMemo[src]; });
      }
      return p;
    }
    function prewarmMockupBases(){
      try{
        var ps = [];
        try{ ps = (kind === 'color') ? ['front'] : selectedPlacements().slice(); }catch(e){ ps = []; }
        if(!ps.length) ps = ['front'];
        for(var i = 0; i < ps.length && i < 4; i++){
          var p = ps[i], s = getDefaultPreviewSrc(modeKey, p), sw = currentSwatch(), ss = swatchImageFor(modeKey, p, sw);
          if(ss) s = ss || s;
          if(s) loadImage(s).catch(function(){});
        }
      }catch(e){}
    }

    async function makeTextMockup(placement, baseSrc){
      var base = await loadImage(baseSrc);
      var st = state.byPlacement[placement] || {};
      var rawText = String(st.text || '').replace(/\r\n/g,'\n').replace(/\r/g,'\n');
      if(!rawText.replace(/\s+/g,'').length) return null;

      var ff = st.font || capkovConfig.default_font_family || 'system-ui';
      try{
        var ffUrl = fontUrlForFamily(ff);
        if(ffUrl){
          await ensureFontLoaded({ family: ff, url: ffUrl });
        }else{
          await ensureFontLoaded(ff);
        }
      }catch(_e){}

      var c = document.createElement('canvas');
      var nW = base.naturalWidth || base.width || 0;
      var nH = base.naturalHeight || base.height || 0;
      if(!nW || !nH) return null;

      var targetW = Math.min(1200, nW);
      var ratio = targetW / nW;
      var targetH = Math.round(nH * ratio);
      c.width = targetW;
      c.height = targetH;

      var cctx = c.getContext('2d');
      cctx.drawImage(base, 0, 0, targetW, targetH);

      var fill = threadColorHex(st.threadColor || '') || '#ffffff';

      if(isTote){
        var fr = getFrameForPlacement(placement);
        if(!fr) return null;
        var ref = baseImageNatural();
        var sx = targetW / (ref.w || 1600);
        var sy = targetH / (ref.h || 1600);
        var rect = { left: fr.left * sx, top: fr.top * sy, w: fr.w * sx, h: fr.h * sy };
        if(!rect.w || !rect.h) return null;

        if(!st.textOverlay) st.textOverlay = { x:0.5, y:0.5, orient:'h', mirror:false, rot:0, sizeTier:'m' };

        var tier = String(st.textOverlay.sizeTier || 'm').toLowerCase();
        if(tier !== 's' && tier !== 'm' && tier !== 'l' && tier !== 'xl') tier = 'm';
        st.textOverlay.sizeTier = tier;
        var SAFE_W_MM = 250;
        var SAFE_H_MM = 310;

        var pxPerMm = Math.min(rect.w / SAFE_W_MM, rect.h / SAFE_H_MM);
        if(!isFinite(pxPerMm) || pxPerMm <= 0){
          pxPerMm = Math.min(rect.w, rect.h) / 250;
        }
        var mm = (tier === 's') ? 15 : (tier === 'm') ? 20 : (tier === 'l') ? 25 : (tier === 'xl') ? 40 : 20;
        var basePct = (config && config.tote && config.tote.text_base_pct != null) ? Number(config.tote.text_base_pct) : 100;
        if(!isFinite(basePct) || basePct <= 0) basePct = 100;

        var fontSize = Math.max(1, Math.round(mm * pxPerMm * (basePct / 100)));

        function setFont(fs){
          cctx.font = embW(ff) + ' ' + fs + 'px "' + ff + '", system-ui, -apple-system, Segoe UI, Roboto, Arial';
        }

        function wrapLinesToWidth(rawLines, maxW, fs, maxTotal){
          maxTotal = maxTotal || 200;
          if(maxTotal < 1) maxTotal = 1;
          setFont(fs);

          var out = [];
          for(var i=0; i<rawLines.length; i++){
            var line = String(rawLines[i]||'');
            if(!line.replace(/\s+/g,'').length){
              out.push('');
              if(out.length >= maxTotal) break;
              continue;
            }
            var words = line.trim().split(/\s+/);
            var cur = '';
            for(var wi=0; wi<words.length; wi++){
              var word = words[wi];
              if(!word) continue;
              while(word && cctx.measureText(word).width > maxW){
                var part = '';
                for(var ci=0; ci<word.length; ci++){
                  var next = part + word[ci];
                  if(cctx.measureText(next).width > maxW){
                    break;
                  }
                  part = next;
                }
                if(!part){
                  part = word.slice(0,1);
                }
                out.push(part);
                if(out.length >= maxTotal) return out.slice(0,maxTotal);
                word = word.slice(part.length);
              }

              var test = cur ? (cur + ' ' + word) : word;
              if(cctx.measureText(test).width <= maxW){
                cur = test;
              }else{
                if(cur) out.push(cur);
                if(out.length >= maxTotal) break;
                cur = word;
              }
            }
            if(out.length >= maxTotal) break;
            if(cur || cur === '') out.push(cur);
            if(out.length >= maxTotal) break;
          }
          return out.slice(0,maxTotal);
        }

        var lineHeightFactor = 1.15;

        function measureBox(fs, lines, rotDeg){
          setFont(fs);
          var maxW = 0;
          for(var i=0; i<lines.length; i++){
            var s = String(lines[i] || '');
            if(!s) continue;
            var mw = cctx.measureText(s).width;
            if(mw > maxW) maxW = mw;
          }
          var lineH = Math.max(1, Math.round(fs * lineHeightFactor));
          var totalH = lines.length * lineH;

          var rawW = maxW;
          var rawH = totalH;

          rotDeg = parseInt(rotDeg || 0, 10) || 0;
          rotDeg = ((rotDeg % 360) + 360) % 360;
          var wR = rawW, hR = rawH;
          if(rotDeg === 90 || rotDeg === 270){
            wR = rawH;
            hR = rawW;
          }
          return { w:wR, h:hR, rawW:rawW, rawH:rawH, lineH:lineH, totalH:totalH };
        }
        var orient = String(st.textOverlay.orient || st.textOverlay.orientation || '').toLowerCase();
        orient = (orient === 'v') ? 'v' : 'h';
        st.textOverlay.orient = orient;

        var dirFlip = !!st.textOverlay.mirror;
        var rot = (orient === 'v') ? (dirFlip ? 270 : 90) : 0;
        st.textOverlay.rot = rot;

        var lineH = Math.max(1, Math.round(fontSize * lineHeightFactor));
        var availH = (orient === 'v') ? rect.w : rect.h;
        var maxLinesFit = Math.floor(availH / lineH);
        if(!isFinite(maxLinesFit) || maxLinesFit < 1) maxLinesFit = 1;
        if(maxLinesFit > 120) maxLinesFit = 120;
        var maxLineW = (orient === 'v') ? (rect.h * 0.98) : (rect.w * 0.98);

        var rawLines = rawText.split('\n');
        if(rawLines.length > 80) rawLines = rawLines.slice(0, 80);

        var lines = wrapLinesToWidth(rawLines, maxLineW, fontSize, Math.min(200, maxLinesFit));

        var hasAny = false;
        for(var li=0; li<lines.length; li++){
          if(String(lines[li] || '').replace(/\s+/g,'').length){
            hasAny = true;
            break;
          }
        }
        if(!hasAny) return null;
        var box = measureBox(fontSize, lines, rot);
        var ox = isFinite(st.textOverlay.x) ? st.textOverlay.x : 0.5;
        var oy = isFinite(st.textOverlay.y) ? st.textOverlay.y : 0.5;
        var minX = (box.w / 2) / rect.w;
        var maxX = 1 - minX;
        var minY = (box.h / 2) / rect.h;
        var maxY = 1 - minY;
        if(minX > maxX){ minX = maxX = 0.5; }
        if(minY > maxY){ minY = maxY = 0.5; }
        ox = Math.max(minX, Math.min(maxX, ox));
        oy = Math.max(minY, Math.min(maxY, oy));

        var cx = rect.left + (rect.w * ox);
        var cy = rect.top + (rect.h * oy);
        function isLightHex(hex){
          hex = String(hex||'').trim();
          var m = /^#([0-9a-f]{6})$/i.exec(hex);
          if(!m) return false;
          var n = m[1];
          var r = parseInt(n.slice(0,2), 16);
          var g = parseInt(n.slice(2,4), 16);
          var b = parseInt(n.slice(4,6), 16);
          if(!isFinite(r) || !isFinite(g) || !isFinite(b)) return false;
          var lum = (0.2126*r + 0.7152*g + 0.0722*b) / 255;
          return lum > 0.65;
        }
        var outline = isLightHex(fill) ? 'rgba(0,0,0,0.35)' : 'rgba(255,255,255,0.35)';
        cctx.save();
        cctx.beginPath();
        cctx.rect(rect.left, rect.top, rect.w, rect.h);
        cctx.clip();

        cctx.translate(cx, cy);
        cctx.rotate(rot * Math.PI / 180);
        setFont(fontSize);
        /* iOS WebKit misaligns textAlign:'center' when the string contains emoji — center manually */
        cctx.textAlign = 'left';
        cctx.textBaseline = 'middle';
        cctx.fillStyle = fill;

        cctx.lineJoin = 'round';
        cctx.miterLimit = 2;
        cctx.lineWidth = Math.max(1, Math.round(fontSize * 0.08));
        cctx.strokeStyle = outline;

        var startY2 = -(box.totalH / 2) + (box.lineH / 2);
        for(var j2=0; j2<lines.length; j2++){
          var s2 = lines[j2];
          if(!String(s2 || '').length) continue;
          var yy2 = startY2 + (j2 * box.lineH);
          var lw2 = 0;
          try{ lw2 = cctx.measureText(s2).width; }catch(eM){}
          try{ cctx.strokeText(s2, -(lw2 / 2), yy2); }catch(e2){}
          cctx.fillText(s2, -(lw2 / 2), yy2);
        }

        cctx.restore();
      }else{
        var anchor = pickTextAnchor(placement);
        var __limM = null; try{ __limM = currentTextLimit(placement); }catch(__e){}
        var __maxLinesM = (__limM && __limM.count) ? __limM.count : 1;   /* stejné pravidlo jako drawTextPreview (zimní čepice = 1 řádek) */
        var lines2 = rawText.split('\n').slice(0, __maxLinesM).map(function(s){ return String(s||'').trim(); });

        var hasAny2 = false;
        for(var li2=0; li2<lines2.length; li2++){
          if(lines2[li2]){ hasAny2 = true; break; }
        }
        if(!hasAny2) return null;

        /* JEDEN renderer s živým náhledem (drawTextPreview): rozložení (velikost písma, zalomení, prahy malého náhledu, 12px podlaha) se počítá
           ve velikosti, v jaké zákazník náhled viděl (baseImg.clientWidth/Height), a výstup se jen zvětší přes ctx.scale (saténový renderer si DPR
           vezme z transformace). Bez viditelného náhledu se použije stejný poměr stran při šířce 420 px. */
        var w = targetW;
        var h = targetH;
        var __pw = 0, __ph = 0;
        try{ __pw = baseImg ? baseImg.clientWidth : 0; __ph = baseImg ? baseImg.clientHeight : 0; }catch(__e){}
        if(__pw > 0 && __ph > 0 && Math.abs((__pw/__ph) - (targetW/targetH)) < 0.04 * (targetW/targetH)){ w = __pw; h = __ph; }
        else if(__pw > 0){ w = __pw; h = __pw * targetH / targetW; }
        else { w = 420.5; h = 420.5 * targetH / targetW; }
        var __lk = targetW / w;
        var base2 = Math.min(w,h);
        var fontSize2 = isApparel
          ? Math.max(1, base2 * 0.10 * (anchor.size / 100))
          : Math.max(1, base2 * 0.10 * (anchor.size / 100));
        var sizePct2 = fontSizePctForFamily(ff);
        if(sizePct2 && sizePct2 != 100){
          fontSize2 = isApparel ? Math.max(1, fontSize2 * (sizePct2 / 100))
                                : Math.max(1, fontSize2 * (sizePct2 / 100));
        }
        fontSize2 = socksCalibratedFontSize(cctx, ff, fontSize2, h, anchor.size);
        var isSmallStage = false;
        var maxW2 = w * (placement === 'front' ? (isSmallStage ? 0.58 : 0.65) : (placement === 'back' ? (isSmallStage ? 0.46 : 0.50) : (isSmallStage ? 0.30 : 0.32)));
        if(isSocks) maxW2 = w * 0.12;
        if(isWinter) maxW2 = w * (isSmallStage ? 0.70 : 0.75);
        var maxH2 = h * (placement === 'front' ? (isSmallStage ? 0.18 : 0.22) : (placement === 'back' ? (isSmallStage ? 0.16 : 0.18) : (isSmallStage ? 0.14 : 0.16)));
        if(isWinter) maxH2 = h * (isSmallStage ? 0.22 : 0.26);
        /* Same rule as the live preview: apparel text keeps the configured size. */
        if(isApparel){ maxW2 = w * 0.94; maxH2 = h * 0.94; }
        cctx.save();
        cctx.font = embW(ff) + ' ' + fontSize2 + 'px "' + String(ff).replace(/"/g,'\\"') + '", system-ui, -apple-system, Segoe UI, Roboto, Arial';
        var longest = 0;
        for(var mi=0; mi<lines2.length; mi++){
          var t = lines2[mi] || '';
          var mw = cctx.measureText(t).width;
          if(mw > longest) longest = mw;
        }
        cctx.restore();

        if(longest > maxW2 && longest > 0){
          var k = maxW2 / longest;
          fontSize2 = Math.max(1, fontSize2 * k);
        }

        var x = (anchor.x / 100) * w;
        var y = (anchor.y / 100) * h;

        var lineGap = fontSize2 * 1.15;
        var totalH = lines2.length * lineGap;
        if(totalH > maxH2 && totalH > 0){
          var kh = maxH2 / totalH;
          fontSize2 = Math.max(1, fontSize2 * kh);
          lineGap = fontSize2 * 1.15;
          totalH = lines2.length * lineGap;
        }
        var startY = y - (totalH / 2) + (lineGap / 2);

        cctx.save();
        cctx.scale(__lk, __lk);
        for(var i=0; i<lines2.length; i++){
          if(lines2[i]) drawEmbroideryTextLine(cctx, lines2[i], x, startY + (i*lineGap), fontSize2, ff, fill);
        }
        cctx.restore();
      }

      var blob = await canvasToBlob(c, 'image/jpeg', 0.92);
      return new File([blob], 'mockup.jpg', { type: 'image/jpeg' });
    }

async function makeImageMockup(placement, baseSrc){
      var base = await loadImage(baseSrc);
      var st = state.byPlacement[placement] || {};
      if(!st.file || !st.previewUrl) return null;
      var bmp = await loadImage(st.previewUrl);
      if(!bmp) return null;

      var c = document.createElement('canvas');
      var nW = base.naturalWidth || base.width || 0;
      var nH = base.naturalHeight || base.height || 0;
      if(!nW || !nH) return null;

      var targetW = Math.min(1200, nW);
      var ratio = targetW / nW;
      var targetH = Math.round(nH * ratio);
      c.width = targetW;
      c.height = targetH;

      var cctx = c.getContext('2d');
      cctx.drawImage(base, 0, 0, targetW, targetH);
      var frameNat = getFrameForPlacement(placement);
      var frame = null;
      if(frameNat && frameNat.w && frameNat.h){
        var ref = baseImageNatural();
        var refW = (ref && ref.w) ? ref.w : 1600;
        var refH = (ref && ref.h) ? ref.h : 1600;
        var sx = targetW / refW;
        var sy = targetH / refH;
        frame = {
          left: (frameNat.left || 0) * sx,
          top: (frameNat.top || 0) * sy,
          w: (frameNat.w || 0) * sx,
          h: (frameNat.h || 0) * sy
        };
      }
      if(!frame || !frame.w || !frame.h){
        frame = { left: 0, top: 0, w: targetW, h: targetH };
      }
      var bW = bmp.naturalWidth || bmp.width || 0;
      var bH = bmp.naturalHeight || bmp.height || 0;
      if(!bW || !bH) return null;

      var scalePct = ((st.overlay && st.overlay.scale) || 100);
      var r = getScaleRangeForPlacement(placement);
      scalePct = clampNum(parseInt(scalePct, 10) || (r.max || 100), r.min, r.max);

      var fit = Math.min(frame.w / bW, frame.h / bH);
      var s = fit * (scalePct / 100);
      var drawW = bW * s;
      var drawH = bH * s;
      var rot = (st.overlay && st.overlay.rot != null) ? (parseInt(st.overlay.rot, 10) || 0) : 0;
      rot = ((rot % 360) + 360) % 360;
      if(rot !== 90 && rot !== 180 && rot !== 270) rot = 0;
      var bboxW = (rot === 90 || rot === 270) ? drawH : drawW;
      var bboxH = (rot === 90 || rot === 270) ? drawW : drawH;

      var ox = (st.overlay && isFinite(st.overlay.x)) ? st.overlay.x : 0.5;
      var oy = (st.overlay && isFinite(st.overlay.y)) ? st.overlay.y : 0.5;
      var minX = (bboxW/2) / frame.w;
      var maxX = 1 - minX;
      var minY = (bboxH/2) / frame.h;
      var maxY = 1 - minY;
      if(minX > maxX){ minX = maxX = 0.5; }
      if(minY > maxY){ minY = maxY = 0.5; }
      ox = Math.max(minX, Math.min(maxX, ox));
      oy = Math.max(minY, Math.min(maxY, oy));

      var cx = frame.left + frame.w * ox;
      var cy = frame.top + frame.h * oy;

      cctx.save();
      cctx.beginPath();
      cctx.rect(frame.left, frame.top, frame.w, frame.h);
      cctx.clip();

      var fx = (st.overlay && st.overlay.flipX) ? -1 : 1;
      var fy = (st.overlay && st.overlay.flipY) ? -1 : 1;
      var rotRad = rot * Math.PI / 180;
      cctx.translate(cx, cy);
      cctx.rotate(rotRad);
      cctx.scale(fx, fy);
      cctx.drawImage(bmp, -(drawW / 2), -(drawH / 2), drawW, drawH);

      cctx.restore();

      var blob = await canvasToBlob(c, 'image/jpeg', 0.92);
      return new File([blob], 'mockup.jpg', { type: 'image/jpeg' });
    }
    function capkovDelay(ms){ return new Promise(function(res){ setTimeout(res, ms); }); }

    // CAPKOV FONT FIX: before a text design is saved / added to cart, make sure every
    // webfont it uses is really loaded. Otherwise the canvas silently falls back to the
    // browser default font and the customer buys a mockup drawn with the wrong font.
    // Returns { ok:true } or { ok:false, family:'...' }. Browsers without the FontFace
    // API keep the legacy behavior (no gate).
    async function ensureTextFontsReady(placements){
      var supported = false;
      try{ supported = !!(window.FontFace && document.fonts && document.fonts.check); }catch(e){ supported = false; }
      if(!supported) return { ok: true };

      var fams = [];
      try{
        for(var i=0; i<placements.length; i++){
          var p = placements[i];
          var stp = state.byPlacement[p] || {};
          var txt = String(stp.text || '').replace(/\s+/g,'');
          if(!txt) continue;
          if(stp.font){
            if(fams.indexOf(stp.font) === -1) fams.push(stp.font);
          }else{
            // Mirror both render paths: preview may use the select value,
            // the mockup may use the configured default family.
            var selFam = (fontSelect && fontSelect.value) ? String(fontSelect.value).trim() : '';
            if(selFam && fams.indexOf(selFam) === -1) fams.push(selFam);
            var defFam = String((capkovConfig && capkovConfig.default_font_family) || '').trim();
            if(defFam && fams.indexOf(defFam) === -1) fams.push(defFam);
          }
        }
      }catch(e){}

      for(var j=0; j<fams.length; j++){
        var family = String(fams[j] || '').trim();
        if(!family) continue;
        var url = '';
        try{ url = fontUrlForFamily(family); }catch(e){ url = ''; }
        if(!url) continue;
        var ok = false;
        for(var attempt=0; attempt<3 && !ok; attempt++){
          if(attempt > 0){ try{ await capkovDelay(700); }catch(e){} }
          try{ ok = (await ensureFontLoaded({ family: family, url: url })) === true; }catch(e){ ok = false; }
          if(!ok){
            try{ ok = document.fonts.check('900 20px "' + family.replace(/"/g,'\\"') + '"'); }catch(e){}
          }
        }
        if(!ok) return { ok: false, family: family };
      }
      return { ok: true };
    }

    /* r3: apply se nikdy nepřekrývá (starší běh s dřívějším stavem panelu, např. Červená, nesmí po novějším běhu přepsat vlastnosti a příplatky; vždy doběhne poslední stav) */
    var __applyBusy = null, __applyAgain = false;
    async function applyToFormAndExtras(){
      if(__applyBusy){ __applyAgain = true; return __applyBusy; }
      __applyBusy = (async function(){ var res; do{ __applyAgain = false; res = await applyToFormAndExtrasInner(); }while(__applyAgain); return res; })();
      try{ return await __applyBusy; } finally{ __applyBusy = null; }
    }
    function socksTextError(){
      if(!isSocks) return '';
      var text = String(state.byPlacement.front && state.byPlacement.front.text || '');
      var uiText = textInput ? String(textInput.value || '') : text;
      var max = currentTextLimit('front').limits[0];
      if(!text.trim() || text.length > max || /[\r\n\u2028\u2029]/.test(text) || uiText !== text){
        return RT('n.ec6a8d7', 'Napiš 1–{0} znaky na jeden řádek.').replace('{0}', max);
      }
      return '';
    }
    async function applyToFormAndExtrasInner(){
      showError('');
      var socksError = socksTextError();
      if(socksError){ showError(socksError); return null; }
      state.designName = designInput ? (designInput.value || '') : (state.designName || '');
      state.note = noteInput ? (noteInput.value || '') : (state.note || '');
      var sizeErr = '';
      try{ sizeErr = sizeSelectionError(); }catch(e){ sizeErr = ''; }
      if(sizeErr){ showError(sizeErr); return null; }
      var selected = selectedPlacements();
      /* bld2: u hotových designů (Změna Barvy) může zákazník volitelně přidat vlastní text na zadek / boky (modul capkov-rd-sideback) */
      var sbItems = [];
      if(kind === 'color'){ try{ sbItems = (window.RdSideBack && window.RdSideBack.read()) || []; }catch(e){ sbItems = []; } }
      var sbMap = {};
      sbItems.forEach(function(it){ sbMap[it.p] = it; selected.push(it.p); });
      if(kind !== 'color' && !selected.length){
        showError(RT('n.a08d5cf', 'Vyber alespoň jedno umístění (text / upload).'));
        return null;
      }
      if(isTote){
        var checkPlacements = [];
        if(kind === 'text'){
          checkPlacements = selected.slice();
        }else if(isImageMixed){
          checkPlacements = selected.filter(function(p){ return placementContentKind(p) === 'text'; });
        }
        if(checkPlacements && checkPlacements.length){
          for(var ci=0; ci<checkPlacements.length; ci++){
            var pp = checkPlacements[ci];
            var stp = state.byPlacement[pp] || {};
            var txt = String(stp.text || '').replace(/\s+/g,'').trim();
            if(!txt) continue;
            var ok = true;
            try{
              ok = !(stp.textOverlay && stp.textOverlay._fitOk === false);
            }catch(e){ ok = true; }
            if(!ok){
              showError(RT('n.daafa3f', 'Text se nevejde do rámečku ({0}). Zkrať ho nebo zvol menší velikost.').replace('{0}', placementLabel(pp)));
              return null;
            }
          }
        }
      }
      var textSelected = (kind === 'text')
        ? selected.slice()
        : (isImageMixed ? selected.filter(function(p){ return placementContentKind(p) === 'text'; }) : []);
      var imageSelected = (kind === 'image')
        ? (isImageMixed ? selected.filter(function(p){ return placementContentKind(p) === 'image'; }) : selected.slice())
        : [];

      // CAPKOV FONT FIX: block save/add-to-cart while the selected font isn't loaded.
      if(textSelected.length){
        var fontGate = { ok: true };
        try{ fontGate = await ensureTextFontsReady(textSelected); }catch(e){ fontGate = { ok: true }; }
        if(!fontGate.ok){
          showError(RT('n.445b572', 'Písmo „{0}“ se nepodařilo načíst, náhled by nebyl správný. Zkontroluj připojení k internetu a zkus to znovu.').replace('{0}', fontGate.family));
          return null;
        }
      }
      var designClean = '';
      if(kind === 'image'){
        designClean = normalizeSpaces(state.designName);
        if(!designClean){
          var p0i = 'front';
          for(var si=0; si<selected.length; si++){
            var pt = selected[si];
            if(placementContentKind(pt) === 'image' && state.byPlacement[pt] && state.byPlacement[pt].file){
              p0i = pt;
              break;
            }
          }
          var f0 = (state.byPlacement[p0i] && state.byPlacement[p0i].file) ? state.byPlacement[p0i].file : null;
          if(f0 && f0.name){
            designClean = normalizeSpaces(String(f0.name).replace(/\.[^.]+$/, ''));
          }
        }
        if(!designClean) designClean = 'design';
      }else if(kind === 'text'){
        var p0 = (selected && selected[0]) ? selected[0] : 'front';
        var t0 = normalizeSpaces(state.byPlacement[p0] ? state.byPlacement[p0].text : '');
        designClean = t0 ? t0.slice(0, 30) : 'text';
      }else{
        designClean = '';
      }

      state.designName = designClean;
      var designSlug = slugifyDesignName(designClean || 'design');
      var paid = computePaidPlacements(selected);
      if(sbItems.length) paid = sbItems.map(function(it){ return it.p; });

      var form = getForm();
      if(!form){
        showError(RT('n.5435afc', 'Produktový formulář nebyl nalezen.'));
        return null;
      }

      var previousToken = '';
      try{
        var prevTokenInput = form.querySelector('[name="properties[__capkov_bundle_token]"]');
        previousToken = prevTokenInput ? String(prevTokenInput.value || '').trim() : '';
      }catch(e){}
      var token = 'cap_' + Math.random().toString(36).slice(2,10) + '_' + Date.now().toString(36);

      if(previousToken && previousToken !== token){
        try{ sessionStorage.removeItem('capkov_extras:' + previousToken); }catch(e){}
        try{
          if(window.__capkov_files_by_token && window.__capkov_files_by_token[previousToken]){
            delete window.__capkov_files_by_token[previousToken];
          }
        }catch(e){}
      }
      var customerSummary = buildCustomerSummary(kind, selected);
      try{
        var capkovEls = form.querySelectorAll('input[data-capkov-prop="1"]');
        capkovEls.forEach(function(el){ el.remove(); });
      }catch(e){}
      var keysToNuke = [
        'properties[Personalizace]',
        'properties[Personalization]',
        'properties[Design / SBE]',
        'properties[Název designu / SBE]',
        'properties[Poznámka]',
        'properties[Poznámka k objednávce]',
        'properties[Note]',
        'properties[Order note]',
        'properties[__capkov_bundle_token]',
        'properties[_capkov_mode]',
        'properties[_capkov_design_name]',
        'properties[_capkov_design_slug]',
        'properties[_capkov_thread_color]',
        'properties[_capkov_thread_colors_json]',
        'properties[_capkov_selected_placements]',
        'properties[_capkov_paid_placements]',
        'properties[_capkov_placement_kind_json]',
        'properties[_capkov_text_json]',
        'properties[_capkov_text_layout_json]',
        'properties[_capkov_font_json]',
        'properties[_capkov_image_json]',
        'properties[_capkov_addons_json]',
        'properties[_capkov_files_json]',
        'properties[_nahled_v]'
      ];
      PLACEMENTS.forEach(function(p){
        keysToNuke.push('properties[' + p + ']');
        keysToNuke.push('properties[' + p + '_mockup]');
        keysToNuke.push('properties[_' + p + '_mockup]');
        keysToNuke.push('properties[_capkov_upload_' + p + ']');
        keysToNuke.push('properties[_capkov_upload_name_' + p + ']');
        keysToNuke.push('properties[_capkov_mockup_' + p + ']');
        keysToNuke.push('properties[_capkov_mockup_name_' + p + ']');
        keysToNuke.push('properties[_capkov_textmockup_' + p + ']');
      });
      keysToNuke.forEach(function(name){
        try{
          var els = form.querySelectorAll('[name="' + cssEscape(name) + '"]');
          els.forEach(function(el){ el.remove(); });
        }catch(e){}
      });
      /* PRODUKCE: klíče a hodnoty properties jsou VŽDY kanonická čeština (ERP je parsuje), bez ohledu na jazyk obchodu; překládá se jen zobrazení. */
      var isEnP = false;
      var placeLabelsCZ = isTote
        ? { front:'Přední strana', back:'Zadní strana', side_left:'Levá strana', side_right:'Pravá strana' }
        : { front:'Předek', back:'Zadek', side_left:'Levá strana', side_right:'Pravá strana' };
      var placeLabelsEN = isTote
        ? { front:'Front', back:'Back', side_left:'Left side', side_right:'Right side' }
        : { front:'Front', back:'Back', side_left:'Left side', side_right:'Right side' };
      var apparelLabelMap = {};
      if(isApparel){
        APPAREL_PLACEMENTS.forEach(function(p){
          var a = apparelFor(p);
          var custom = a ? (isEnP ? a.label_en : a.label_cs) : '';
          if(custom){ apparelLabelMap[p] = custom; return; }
          if(isEnP){
            apparelLabelMap[p] = (p === 'front') ? 'Front' : (p === 'back') ? 'Back' : (p === 'side_left') ? 'Left sleeve' : 'Right sleeve';
          }else{
            apparelLabelMap[p] = (p === 'front') ? 'Předek' : (p === 'back') ? 'Záda' : (p === 'side_left') ? 'Levý rukáv' : 'Pravý rukáv';
          }
        });
      }

      var sideSelectedCount = 0;
      if(selected.indexOf('side_left') >= 0) sideSelectedCount++;
      if(selected.indexOf('side_right') >= 0) sideSelectedCount++;

      function placementLabel(p){
        if(sbMap[p]) return sbMap[p].label;
        if(isApparel) return apparelLabelMap[p] || p;
        if(isEnP){
          if(p === 'side_left' || p === 'side_right'){
            if(sideSelectedCount === 1) return 'Side';
            return p === 'side_left' ? 'Left side' : 'Right side';
          }
          return placeLabelsEN[p] || p;
        }
        if(p === 'side_left' || p === 'side_right'){
          if(sideSelectedCount === 1) return 'Strana';
          return p === 'side_left' ? 'Levá strana' : 'Pravá strana';
        }
        return placeLabelsCZ[p] || p;
      }

      function feeMoney(amount){
        var n = Number(amount);
        if(!isFinite(n) || n === 0) return '';
        return ' (' + formatFee(n) + ')';
      }

      function fontLabel(family){
        family = normalizeSpaces(family);
        if(!family) return '';
        try{
          var list = (Array.isArray(fonts) && fonts.length) ? fonts : ((capkovConfig && capkovConfig.fonts) || []);
          for(var i=0;i<list.length;i++){
            var it = list[i] || {};
            if(String(it.family||'') === family){
              return String(it.label || it.family || family);
            }
          }
        }catch(e){}
        return family;
      }

      /* Shopify translates the font block's label AND its family ("Rukopis" -> "Manuscript"),
         so the name alone is useless to production. The font file never gets translated,
         so append it: "Manuscript · Kaushan Script regular". */
      function fontFileName(family){
        family = normalizeSpaces(family);
        if(!family) return '';
        try{
          var list = (Array.isArray(fonts) && fonts.length) ? fonts : ((capkovConfig && capkovConfig.fonts) || []);
          for(var i=0;i<list.length;i++){
            var it = list[i] || {};
            if(String(it.family||'') === family){
              var f = String(it.url||'').split('?')[0].split('/').pop();
              return f.replace(/\.(woff2?|otf|ttf)$/i,'').replace(/[_-]+/g,' ').trim();
            }
          }
        }catch(e){}
        return '';
      }

      function fontOrderValue(family){
        var lbl = fontLabel(family);
        var file = fontFileName(family);
        return (file && normalizeKey(file) !== normalizeKey(lbl) && !/^latest\b/i.test(file)) ? (lbl + ' · ' + file) : lbl;
      }

      function setProp(key, val){
        val = normalizeSpaces(val);
        if(!val) return;
        upsertHidden(form, 'properties[' + key + ']', val);
      }

      var shownPaidColor = {};
      function colorValueWithFee(color){
        var c = normalizeSpaces(color);
        if(!c) return '';
        /* English storefront: keep what the customer picked, but append the Czech name
           production works from, so nobody has to translate the order by hand. */
        var freeC = isNoFeeColor(c);
        try{
          var cz = toCzechThreadColor(c);
          if(cz && normalizeKey(cz) !== normalizeKey(c)) c = cz;
        }catch(e){}
        if(freeC || isNoFeeColor(c)) return c;
        var norm = c.toLowerCase();
        if(shownPaidColor[norm]) return c;
        shownPaidColor[norm] = true;
        return c + feeMoney(fees.color || 50);
      }

      if(kind === 'text'){
        var fontsByPlacement = {};
        var uniqueFonts = [];
        selected.forEach(function(p){
          var f = '';
          try{ f = String(state.byPlacement[p] && state.byPlacement[p].font || (fontSelect && fontSelect.value) || '').trim(); }catch(e){ f=''; }
          fontsByPlacement[p] = f;
          if(f && uniqueFonts.indexOf(f)===-1) uniqueFonts.push(f);
        });
        var showFontsPerPlacement = (uniqueFonts.length > 1);

        selected.forEach(function(p){
          var pl = placementLabel(p);
          var tc = '';
          try{ tc = String(state.byPlacement[p] && state.byPlacement[p].threadColor || '').trim(); }catch(e){ tc=''; }
          if(tc){
            setProp((isEnP ? 'Thread color' : 'Barva výšivky') + ' (' + pl + ')', colorValueWithFee(tc));
          }
          if(showFontsPerPlacement && fontsByPlacement[p]){
            setProp((isEnP ? 'Font' : 'Písmo') + ' (' + pl + ')', fontOrderValue(fontsByPlacement[p]));
          }
          var raw = '';
          try{ raw = cleanPlText(p, state.byPlacement[p] && state.byPlacement[p].text || ''); }catch(e){ raw=''; }
          var lines = raw.split(/\r?\n/).map(function(x){ return normalizeSpaces(x); }).filter(Boolean);
          for(var i=0;i<lines.length;i++){
            var k = isEnP ? ('Text line ' + (i+1) + ' (' + pl + ')') : ('Text ' + (i+1) + '. řádek (' + pl + ')');
            setProp(k, lines[i]);
          }
        });

        if(uniqueFonts.length === 1){
          setProp(isEnP ? 'Font' : 'Písmo', fontOrderValue(uniqueFonts[0]));
        }
        if(isApparel){
          paid.forEach(function(p){
            setProp((isEnP ? 'Extra placement' : 'Další umístění') + ' – ' + placementLabel(p) + feeMoney(apparelFeeFor(p)), isEnP ? 'Yes' : 'Ano');
          });
        }else{
        var placementFee = parseFloat(fees.placement||100)||100;
        if(paid.indexOf('back') >= 0){
          if(isTote){
            setProp(placementLabel('back') + feeMoney(placementFee), isEnP ? 'Yes' : 'Ano');
          }else{
            setProp((isEnP ? 'Back embroidery' : 'Výšivka zadek') + feeMoney(placementFee), isEnP ? 'Yes' : 'Ano');
          }
        }
        var sidePaidCount = 0;
        if(paid.indexOf('side_left') >= 0) sidePaidCount++;
        if(paid.indexOf('side_right') >= 0) sidePaidCount++;
        if(sidePaidCount){
          setProp((isEnP ? 'Side embroidery' : 'Výšivka bok') + feeMoney(placementFee * sidePaidCount), isEnP ? 'Yes' : 'Ano');
        }
        }
      }

      if(kind === 'image'){
        (isImageMixed ? (imageSelected || []) : selected).forEach(function(p){
          var pl = placementLabel(p);
          var stp = state.byPlacement[p] || {};
          if(stp.file && stp.file.name){
            setProp((isEnP ? 'Image' : 'Obrázek') + ' (' + pl + ')', stp.file.name);
          }
          var sc = stp.overlay ? stp.overlay.scale : null;
          if(sc){
            setProp((isEnP ? 'Size' : 'Velikost') + ' (' + pl + ')', String(sc) + '%');
          }
        });
        if(isImageMixed && textSelected && textSelected.length){
          var fontsByPlacement2 = {};
          var uniqueFonts2 = [];
          textSelected.forEach(function(p){
            var f = '';
            try{ f = String(state.byPlacement[p] && state.byPlacement[p].font || (fontSelect && fontSelect.value) || '').trim(); }catch(e){ f=''; }
            fontsByPlacement2[p] = f;
            if(f && uniqueFonts2.indexOf(f)===-1) uniqueFonts2.push(f);
          });
          var showFontsPerPlacement2 = (uniqueFonts2.length > 1);

          textSelected.forEach(function(p){
            var pl = placementLabel(p);
            var tc = '';
            try{ tc = String(state.byPlacement[p] && state.byPlacement[p].threadColor || '').trim(); }catch(e){ tc=''; }
            if(tc){
              setProp((isEnP ? 'Thread color' : 'Barva výšivky') + ' (' + pl + ')', colorValueWithFee(tc));
            }
            if(showFontsPerPlacement2 && fontsByPlacement2[p]){
              setProp((isEnP ? 'Font' : 'Písmo') + ' (' + pl + ')', fontOrderValue(fontsByPlacement2[p]));
            }
            var raw = '';
            try{ raw = String(state.byPlacement[p] && state.byPlacement[p].text || ''); }catch(e){ raw=''; }
            var lines = raw.split(/\r?\n/).map(function(x){ return normalizeSpaces(x); }).filter(Boolean);
            for(var i=0;i<lines.length;i++){
              var k = isEnP ? ('Text line ' + (i+1) + ' (' + pl + ')') : ('Text ' + (i+1) + '. řádek (' + pl + ')');
              setProp(k, lines[i]);
            }
          });

          if(uniqueFonts2.length === 1){
            setProp(isEnP ? 'Font' : 'Písmo', fontOrderValue(uniqueFonts2[0]));
          }
        }
        if(isApparel){
          paid.forEach(function(p){
            setProp((isEnP ? 'Extra placement' : 'Další umístění') + ' – ' + placementLabel(p) + feeMoney(apparelFeeFor(p)), isEnP ? 'Yes' : 'Ano');
          });
        }else{
        var placementFee2 = parseFloat(fees.placement||100)||100;
        if(paid.indexOf('back') >= 0){
          if(isTote){
            setProp(placementLabel('back') + feeMoney(placementFee2), isEnP ? 'Yes' : 'Ano');
          }else{
            setProp((isEnP ? 'Back embroidery' : 'Výšivka zadek') + feeMoney(placementFee2), isEnP ? 'Yes' : 'Ano');
          }
        }
        var sidePaidCount2 = 0;
        if(paid.indexOf('side_left') >= 0) sidePaidCount2++;
        if(paid.indexOf('side_right') >= 0) sidePaidCount2++;
        if(sidePaidCount2){
          setProp((isEnP ? 'Side embroidery' : 'Výšivka bok') + feeMoney(placementFee2 * sidePaidCount2), isEnP ? 'Yes' : 'Ano');
        }
        }
      }

      if(kind === 'color'){
        var onlyColor = '';
        try{ onlyColor = String(state.byPlacement.front && state.byPlacement.front.threadColor || '').trim(); }catch(e){ onlyColor=''; }
        if(onlyColor){
          setProp(isEnP ? 'Thread color' : 'Barva výšivky', colorValueWithFee(onlyColor));
        }
        /* bld2: vlastní výšivka na zadek / bok u hotového designu: stejné názvy vlastností jako u vlastního textu (ERP je čte stejně) */
        if(sbItems.length){
          var sbFee = parseFloat(fees.placement||100)||100, sbSides = 0;
          sbItems.forEach(function(it){
            var pl = placementLabel(it.p);
            String(it.text || '').split(/\r?\n/).map(function(x){ return normalizeSpaces(x); }).filter(Boolean).forEach(function(line, li){
              setProp(isEnP ? ('Text line ' + (li+1) + ' (' + pl + ')') : ('Text ' + (li+1) + '. řádek (' + pl + ')'), line);
            });
            if(it.fontValue) setProp((isEnP ? 'Font' : 'Písmo') + ' (' + pl + ')', it.fontValue);
            if(it.thread) setProp((isEnP ? 'Thread color' : 'Barva výšivky') + ' (' + pl + ')', colorValueWithFee(it.thread));
            if(it.p === 'side_left' || it.p === 'side_right') sbSides++;
          });
          if(sbMap.back) setProp((isEnP ? 'Back embroidery' : 'Výšivka zadek') + feeMoney(sbFee), isEnP ? 'Yes' : 'Ano');
          if(sbSides) setProp((isEnP ? 'Side embroidery' : 'Výšivka bok') + feeMoney(sbFee * sbSides), isEnP ? 'Yes' : 'Ano');
        }
      }

      if(state.note){
        setProp(isEnP ? 'Order note' : 'Poznámka k objednávce', state.note);
      }
      upsertHidden(form, 'properties[__capkov_bundle_token]', token);
      upsertHidden(form, 'properties[_capkov_mode]', String(config.builder_mode || ''));
      upsertHidden(form, 'properties[_capkov_design_name]', designClean);
      upsertHidden(form, 'properties[_capkov_design_slug]', designSlug);
      var threadPlacements = (kind === 'color')
        ? ['front'].concat(sbItems.map(function(it){ return it.p; }))
        : (kind === 'text' ? selected.slice() : (isImageMixed ? (textSelected || []) : []));
      var threadMap = {};
      var threadVals = [];
      if(threadPlacements && threadPlacements.length){
        threadPlacements.forEach(function(p){
          var c = '';
          try{ c = sbMap[p] ? String(sbMap[p].thread || '').trim() : String(state.byPlacement[p] && state.byPlacement[p].threadColor || '').trim(); }catch(e){ c=''; }
          threadMap[p] = c;
          if(c && threadVals.indexOf(c)===-1) threadVals.push(c);
        });
        upsertHidden(form, 'properties[_capkov_thread_colors_json]', JSON.stringify(threadMap));
        var single = (threadVals.length === 1) ? threadVals[0] : '';
        if(kind === 'color' && threadMap.front) single = threadMap.front;   /* karta „Váš návrh“ přebarvuje fotku předku */
        upsertHidden(form, 'properties[_capkov_thread_color]', single);
      }
      upsertHidden(form, 'properties[_capkov_selected_placements]', selected.join(','));
      upsertHidden(form, 'properties[_capkov_paid_placements]', paid.join(','));
      if(isImageMixed){
        var kmap = {};
        selected.forEach(function(p){
          kmap[p] = placementContentKind(p);
        });
        upsertHidden(form, 'properties[_capkov_placement_kind_json]', JSON.stringify(kmap));
      }
      if(kind === 'text' || (isImageMixed && textSelected && textSelected.length)){
        var tmap = {};
        var fmap = {};
        var tpl = (kind === 'text') ? selected : (textSelected || []);
        tpl.forEach(function(p){
          tmap[p] = cleanPlText(p, state.byPlacement[p] && state.byPlacement[p].text || '');
          fmap[p] = String(state.byPlacement[p] && state.byPlacement[p].font || (fontSelect && fontSelect.value) || '');
        });
        upsertHidden(form, 'properties[_capkov_text_json]', JSON.stringify(tmap));
        upsertHidden(form, 'properties[_capkov_font_json]', JSON.stringify(fmap));
        if(isTote){
          var layout = {};
          tpl.forEach(function(p){
            var st = state.byPlacement[p] || {};
            var to = st.textOverlay || {};
            var tier = String(to.sizeTier || 'm');
            if(tier !== 's' && tier !== 'm' && tier !== 'l' && tier !== 'xl') tier = 'm';
            var rot = parseInt(to.rot || 0, 10) || 0;
            rot = ((rot % 360) + 360) % 360;
            var o = String(to.orient || to.orientation || '').toLowerCase();
            if(o !== 'h' && o !== 'v') o = (rot === 90 || rot === 270) ? 'v' : 'h';
            var flipDir = !!to.mirror;
            rot = (o === 'v') ? (flipDir ? 270 : 90) : 0;
            var fam = String(fmap[p] || '').trim();
            layout[p] = {
              x: (to.x != null ? Number(to.x) : 0.5),
              y: (to.y != null ? Number(to.y) : 0.5),
              rot: rot,
              orientation: (o === 'v') ? 'vertical' : 'horizontal',
              direction: (o === 'v') ? (flipDir ? 'bottom_up' : 'top_down') : 'ltr',
              flip: flipDir,
              size_tier: tier,
              size_pct: fontSizePctForFamilyTier(fam, tier),
              base_pct: (config && config.tote && config.tote.text_base_pct != null) ? Number(config.tote.text_base_pct) : 100,
              font_px: (to._fontPx != null ? Number(to._fontPx) : null),
              box_w: (to._boxW != null ? Number(to._boxW) : null),
              box_h: (to._boxH != null ? Number(to._boxH) : null)
            };
          });
          upsertHidden(form, 'properties[_capkov_text_layout_json]', JSON.stringify(layout));
        }
      }
      if(kind === 'color' && sbItems.length){
        var sbT = {}, sbF = {};
        sbItems.forEach(function(it){ sbT[it.p] = String(it.text || ''); sbF[it.p] = String(it.font || ''); });
        upsertHidden(form, 'properties[_capkov_text_json]', JSON.stringify(sbT));
        upsertHidden(form, 'properties[_capkov_font_json]', JSON.stringify(sbF));
      }
      if(kind === 'image'){
        var imap = {};
        var ipl = isImageMixed ? (imageSelected || []) : selected;
        ipl.forEach(function(p){
          var st = state.byPlacement[p] || {};
          imap[p] = {
            file: st.file ? st.file.name : '',
            x: st.overlay ? st.overlay.x : 0.5,
            y: st.overlay ? st.overlay.y : 0.5,
            scale: st.overlay ? st.overlay.scale : 100,
            flipX: st.overlay ? !!st.overlay.flipX : false,
            flipY: st.overlay ? !!st.overlay.flipY : false,
            rot: st.overlay ? (parseInt(st.overlay.rot || 0, 10) || 0) : 0
          };
        });
        upsertHidden(form, 'properties[_capkov_image_json]', JSON.stringify(imap));
      }
      var extraItems = [];
      var backVar = String(addonVariants.back || '').trim();
      var sideVar = String(addonVariants.side || '').trim();

      /* Apparel placement blocks may define their own add-on variant; otherwise the
         builder-level Back / Side add-on IDs are used, exactly like on the caps. */
      function addonVariantForPlacement(p){
        var vid = apparelAddonVariantFor(p);
        if(vid) return vid;
        if(p === 'back') return backVar;
        if(p === 'side_left' || p === 'side_right') return sideVar;
        return '';
      }

      function placementFeeForPaid(p){
        if(isApparel) return apparelFeeFor(p);
        return fees.placement || 100;
      }

      if(paid.length){
        var missingVid = [];
        paid.forEach(function(p){
          if(!addonVariantForPlacement(p)) missingVid.push(placementLabel(p));
        });
        if(missingVid.length){
          showError(RT('n.0314018', 'Chybí variant ID pro příplatek za další umístění: {0}. Nastav je v nastavení builderu v šabloně.').replace('{0}', missingVid.join(', ')));
          return null;
        }
      }

      paid.forEach(function(p){
        var vid = addonVariantForPlacement(p);
        if(!vid) return;
        extraItems.push({
          id: String(vid),
          quantity: 1,
          properties: {
            '__capkov_hidden_addon': '1',
            '__capkov_bundle_token': token,
            '__capkov_addon_type': 'placement',
            '__capkov_addon_placement': p,
            '__capkov_addon_fee': String(placementFeeForPaid(p))
          }
        });
      });
      var paidColorMap = {};
      var paidColors = [];
      var needsColorAddon = false;
      if(threadPlacements && threadPlacements.length){
        (threadPlacements || []).forEach(function(p){
          var c = '';
          try{ c = String(threadMap && threadMap[p] || '').trim(); }catch(e){ c=''; }
          if(!c) return;
          if(isNoFeeColor(c)) return;
          if(!paidColorMap[c]) paidColorMap[c] = [];
          paidColorMap[c].push(p);
        });
        paidColors = Object.keys(paidColorMap);
        needsColorAddon = paidColors.length > 0;
        var paidColorVidMap = {};
        var missingPaid = [];
        paidColors.forEach(function(color){
          var cvTest = String(threadVariantMap[color] || threadVariantMapNorm[normalizeKey(color)] || '').trim();
          if(!cvTest) missingPaid.push(String(color));
          else paidColorVidMap[color] = cvTest;
        });
        if(missingPaid.length){
          showError(RT('n.4d0b69f', 'Chybí variant ID pro barvu nitě: {0}. Doplň to v Nastavení tématu → blok Capkov Builder → "Thread add-on variant IDs".').replace('{0}', missingPaid.join(', ')));
          return null;
        }

        paidColors.forEach(function(color){
          var cv = String(paidColorVidMap[color] || '').trim();
          if(!cv) return;
          extraItems.push({
            id: String(cv),
            quantity: 1,
            properties: {
              '__capkov_hidden_addon': '1',
              '__capkov_bundle_token': token,
              '__capkov_addon_type': 'thread_color',
              '__capkov_addon_color': String(color),
              '__capkov_addon_placements': String((paidColorMap[color] || []).join(',')),
              '__capkov_addon_fee': String(fees.color || 50)
            }
          });
        });
      }

      var paidPlacementFees = {};
      paid.forEach(function(p){ paidPlacementFees[p] = placementFeeForPaid(p); });
      /* souhrn příplatků pro PDP (panel Umístění, tlačítko): umístění + každá placená barva nitě JEDNOU (bez ohledu na počet umístění) */
      try{
        var sumPl = 0; paid.forEach(function(p){ sumPl += Number(placementFeeForPaid(p)) || 0; });
        var sumCol = paidColors.length * (Number(fees.color || 50) || 0);
        window.__rdAddons = { nPlacements: paid.length, placementFee: fees.placement || 100, placementTotal: sumPl, colors: paidColors.slice(), colorFee: fees.color || 50, colorTotal: sumCol, total: sumPl + sumCol, token: token };
        document.dispatchEvent(new CustomEvent('rd-addons:summary', { detail: window.__rdAddons }));
      }catch(e){}

      upsertHidden(form, 'properties[_capkov_addons_json]', JSON.stringify({
        placement_fee: fees.placement || 100,
        placement_fees: paidPlacementFees,
        color_fee: fees.color || 50,
        paid_placements: paid,
        thread_colors: threadMap || {},
        paid_thread_colors: paidColors,
        needs_color_addon: needsColorAddon
      }));
      /* 8.10.: marker verze buildera pro ERP pojistku (pf2 = proporce mockupu nezávislé na zařízení) + šířka náhledu, ve které zákazník návrh viděl */
      try{ var __swm = (typeof baseImg !== 'undefined' && baseImg && baseImg.clientWidth) || 0; upsertHidden(form, 'properties[_nahled_v]', 'pf2;sw=' + Math.round(__swm)); }catch(e){}
      var placementsForFiles = (kind === 'color') ? ['front'] : selected.slice();
      var filesByKey = {};
      var filesMeta = {};
      var __mockJobs = []; /* ATCFB 7.10: mockupy umístění se skládají souběžně */
      for(var i=0;i<placementsForFiles.length;i++){
        var p = placementsForFiles[i];
        var baseSrc = getDefaultPreviewSrc(modeKey, p);
        var sw = currentSwatch();
        var swSrc = swatchImageFor(modeKey, p, sw);
        if(swSrc) baseSrc = swSrc || baseSrc;

        var stp = state.byPlacement[p] || {};
        var isFileOk = !!(stp.file && stp.file.size && stp.file.name);
        var placementIsImage = (kind === 'image') && (!isImageMixed || placementContentKind(p) === 'image');
        var placementIsText = (kind === 'text') || (isImageMixed && kind === 'image' && placementContentKind(p) === 'text');
        if(placementIsImage && isFileOk){
          var ext = '';
          var lower = String(stp.file.name||'').toLowerCase();
          var m = lower.match(/\.([a-z0-9]{1,6})$/);
          ext = m ? m[1] : '';
          if(!ext && stp.file.type === 'application/pdf') ext = 'pdf';
          if(!ext) ext = 'bin';
          var uploadName = 'capkov_' + String(product.handle||'product') + '_' + p + '_' + designSlug + '.' + ext;
          var renamedUpload = renameFile(stp.file, uploadName);
          filesByKey['properties[' + p + ']'] = renamedUpload;
          try{
            if(!filesMeta[p]) filesMeta[p] = {};
            filesMeta[p].upload_name = uploadName;
          }catch(e){}
        }
        var __mj = null;
        if(baseSrc){
          __mj = (async function(pp, src, isImg, isTxt){
            try{
              var __mf = null;
              if(isImg) __mf = await makeImageMockup(pp, src);
              else if(isTxt) __mf = await makeTextMockup(pp, src);
              if(__mf && isWinter && pp === 'back') __mf = await stampBackMockup(__mf);
              return __mf;
            }catch(e){}
            return null;
          })(p, baseSrc, (placementIsImage && isFileOk), placementIsText);
        }
        __mockJobs.push({ p: p, pr: __mj });
      }
      for(var __ji = 0; __ji < __mockJobs.length; __ji++){
        var __job = __mockJobs[__ji], mock = null;
        try{ mock = __job.pr ? await __job.pr : null; }catch(e){ mock = null; }
        if(mock){
          var p = __job.p;
          var mockName = 'capkov_' + String(product.handle||'product') + '_' + p + '_' + designSlug + '_mockup.jpg';
          var renamedMock = renameFile(mock, mockName);
          filesByKey['properties[_' + p + '_mockup]'] = renamedMock;
          try{
            if(!filesMeta[p]) filesMeta[p] = {};
            filesMeta[p].mockup_name = mockName;
          }catch(e){}
        }
      }
      try{
        if(kind === 'image' && Object.keys(filesMeta).length){
          upsertHidden(form, 'properties[_capkov_files_json]', JSON.stringify(filesMeta));
        }
      }catch(e){}

      try{
        window.__capkov_files_by_token = window.__capkov_files_by_token || {};
        if(Object.keys(filesByKey).length){
          window.__capkov_files_by_token[token] = filesByKey;
        }else{
          delete window.__capkov_files_by_token[token];
        }
      }catch(e){}
      if(extraItems.length){
        try{
          sessionStorage.setItem('capkov_extras:' + token, JSON.stringify({ items: extraItems }));
        }catch(e){}
      }
      if(summaryEl) summaryEl.textContent = customerSummary;
      updateSummaryActions();

      // CAPKOV FIX: lock builder's chosen variant as source of truth for the cart.
      // The form's variant input may later be changed by external PDP swatches,
      // but at form submit time we restore this value (see setupCapkovCartIntegration).
      // Also publish into a token-keyed global map so the /cart/add fetch interceptor
      // can override the 'id' field as a second layer of defense.
      try{
        var __vidEl = form.querySelector('input[name="id"]');
        state.savedVariantId = __vidEl ? String(__vidEl.value || '').trim() : '';
        state.bundleToken = token;
        try{
          window.__capkov_saved_variant_by_token = window.__capkov_saved_variant_by_token || {};
          if(state.savedVariantId){
            window.__capkov_saved_variant_by_token[token] = state.savedVariantId;
          }
        }catch(e){}
      }catch(e){}

      return { token: token, selected: selected, paid: paid };
    }
    var __capkov_prevBodyStyle = { position:'', top:'', width:'', overflow:'' };
    var __capkov_scrollY = 0;
    var __capkov_scrollLocked = false;
    function lockPageScroll(){
      if(__capkov_scrollLocked) return;
      __capkov_scrollLocked = true;
      try{
        __capkov_scrollY = window.scrollY || window.pageYOffset || 0;
        __capkov_prevBodyStyle.position = document.body.style.position || '';
        __capkov_prevBodyStyle.top = document.body.style.top || '';
        __capkov_prevBodyStyle.width = document.body.style.width || '';
        __capkov_prevBodyStyle.overflow = document.body.style.overflow || '';
        document.body.style.position = 'fixed';
        document.body.style.top = (-__capkov_scrollY) + 'px';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
      }catch(e){}
    }
    function unlockPageScroll(){
      if(!__capkov_scrollLocked) return;
      __capkov_scrollLocked = false;
      try{
        document.body.style.position = __capkov_prevBodyStyle.position;
        document.body.style.top = __capkov_prevBodyStyle.top;
        document.body.style.width = __capkov_prevBodyStyle.width;
        document.body.style.overflow = __capkov_prevBodyStyle.overflow;
      }catch(e){}
      try{ window.scrollTo(0, __capkov_scrollY || 0); }catch(e){}
    }

    function openModal(){
      if(!modal) return;
      try{ setTimeout(prewarmMockupBases, 600); }catch(e){}
      modal.setAttribute('data-open','true');
      modal.setAttribute('aria-hidden','false');
      try{ lockPageScroll(); }catch(e){}
      try{ document.documentElement.classList.add('capkov-b2-open'); }catch(e){}
      try{ if(scrollEl) scrollEl.scrollTop = 0; }catch(e){}
      try{ startPreviewWatch(); }catch(e){}
      try{ preloadBuilderFonts(); }catch(e){}
      try{ ensureAvailableVariant(); }catch(e){}
      if(!openModal._zoomReady){ openModal._zoomReady = true; try{ setupZoom(); }catch(e){} }
      syncModeUI();
      renderTabs();
      renderThreadColors();
      renderSwatches();
      try{ renderSizes(); }catch(e){}
      syncUiFromState();
      renderPreview();
      requestAnimationFrame(function(){
        try{ resizeCanvasToImage(); }catch(e){}
        try{ updateFramePreview(); }catch(e){}
        try{ updateImageOverlayPreview(); }catch(e){}
        try{ drawTextPreview(); }catch(e){}
        requestAnimationFrame(function(){
          try{ resizeCanvasToImage(); }catch(e){}
          try{ updateFramePreview(); }catch(e){}
        try{ updateImageOverlayPreview(); }catch(e){}
          try{ drawTextPreview(); }catch(e){}
        });
      });
    }
    function closeModal(){
      if(!modal) return;
      modal.setAttribute('data-open','false');
      modal.setAttribute('aria-hidden','true');
      try{ document.documentElement.classList.remove('capkov-b2-open'); }catch(e){}
      try{ if(zoomResetExternal) zoomResetExternal(); }catch(e){}
      try{ stopPreviewWatch(); }catch(e){}
      try{ unlockPageScroll(); }catch(e){}
    }

    if(openBtn) openBtn.addEventListener('click', openModal);
    if(newBtn){
      newBtn.addEventListener('click', function(){
        resetBuilderState({ open: true });
      });
    }
    if(resetBtns && resetBtns.length){
      resetBtns.forEach(function(btn){
        try{
          btn.addEventListener('click', function(){
            resetBuilderState({ open: false });
          });
        }catch(e){}
      });
    }
    closeEls.forEach(function(el){ el.addEventListener('click', closeModal); });
    if(saveBtn){
      saveBtn.addEventListener('click', async function(){
        saveBtn.disabled = true;
        try{
          var res = await applyToFormAndExtras();
          if(res) closeModal();
        }finally{
          saveBtn.disabled = false;
        }
      });
    }

    if(addBtn){
      /* ATCFB 7.10: okamžitá odezva (spinner + „Přidávám…“, bez štítku a ceny), souběžné předehřátí, chyba přímo u tlačítka. Okno zůstane otevřené, dokud se košík neotevře. */
      var __addBusy = false, __addMsgEl = null, __addHtml = '';
      var __FAIL = RT('n.428a91f', 'Nepodařilo se přidat do košíku. Zkus to prosím znovu.');
      function addMsg(kind, txt){
        try{
          if(!__addMsgEl){
            var act = addBtn.parentNode; if(!act) return;
            __addMsgEl = document.createElement('div');
            __addMsgEl.className = 'capkov-b2__addmsg';
            act.insertBefore(__addMsgEl, act.firstChild);
          }
          __addMsgEl.setAttribute('data-kind', kind || '');
          __addMsgEl.setAttribute('role', kind === 'err' ? 'alert' : 'status');
          __addMsgEl.textContent = txt || '';
        }catch(e){}
      }
      function addUi(on, label){
        try{
          if(on){
            if(!__addHtml) __addHtml = addBtn.innerHTML;
            addBtn.setAttribute('aria-busy', 'true'); addBtn.setAttribute('aria-disabled', 'true'); addBtn.setAttribute('data-rd-hold', '1');
            addBtn.innerHTML = '<span class="capkov-b2__spin" aria-hidden="true"></span><span>' + label + '</span>';
          }else{
            addBtn.removeAttribute('aria-busy'); addBtn.removeAttribute('aria-disabled'); addBtn.removeAttribute('data-rd-hold');
            if(__addHtml){ addBtn.innerHTML = __addHtml; __addHtml = ''; }
          }
        }catch(e){}
      }
      function addWait(maxMs){
        return new Promise(function(resolve){
          var started = false, t1 = 0, t2 = 0;
          function off(){ window.removeEventListener('capkov:add-start', onS); window.removeEventListener('capkov:add-result', onR); clearTimeout(t1); clearTimeout(t2); }
          function onS(){ started = true; clearTimeout(t1); }
          function onR(e){ off(); resolve((e && e.detail) || { ok: false }); }
          window.addEventListener('capkov:add-start', onS); window.addEventListener('capkov:add-result', onR);
          t1 = setTimeout(function(){ if(!started){ off(); resolve({ none: true }); } }, 2500);
          t2 = setTimeout(function(){ off(); resolve({ timeout: true }); }, 30000);
        });
      }
      function drawerOpened(maxMs){
        return new Promise(function(resolve){
          var d = document.getElementById('cart-drawer'), t0 = Date.now();
          if(!d){ resolve(); return; }
          (function chk(){ if(d.hasAttribute('open') || Date.now() - t0 > maxMs){ resolve(); return; } setTimeout(chk, 50); })();
        });
      }
      ['pointerdown','touchstart','focus'].forEach(function(ev){ addBtn.addEventListener(ev, function(){ prewarmMockupBases(); }, { passive: true }); });
      addBtn.addEventListener('click', async function(){
        if(__addBusy) return;
        __addBusy = true;
        var keepOpen = false;
        addMsg('', '');
        addUi(true, RT('n.e990132', 'Přidávám…'));
        addMsg('hint', kind === 'image' ? RT('n.0dd27a4', 'Nahráváme tvůj obrázek a připravujeme náhled…') : RT('n.87026f8', 'Připravujeme náhled…'));
        try{
          var res = await applyToFormAndExtras();
          if(!res){
            keepOpen = true;
            var em = (errorEl && errorEl.getAttribute('data-show') === 'true') ? String(errorEl.textContent || '') : '';
            addMsg(em ? 'err' : '', em);
            return;
          }
          var form = getForm();
          if(!form){ keepOpen = true; addMsg('err', __FAIL); return; }
          var waiting = addWait();
          var submitBtn = form.querySelector('[type="submit"]');
          if(submitBtn) submitBtn.click();
          else if(form.requestSubmit) form.requestSubmit();
          else form.submit();
          var r = await waiting;
          if(r && r.none){ addMsg('', ''); closeModal(); return; }
          if(r && r.ok){
            addMsg('', '');
            addUi(false); addUi(true, RT('n.4bff5e6', 'Přidáno ✓'));
            await drawerOpened(1500);
            closeModal();
            return;
          }
          keepOpen = true;
          addMsg('err', (r && r.timeout) ? RT('n.f3c5c92', 'Trvá to déle než obvykle. Zkontroluj košík, nebo to zkus znovu.') : __FAIL);
        }catch(e){
          keepOpen = true; addMsg('err', __FAIL);
        }finally{
          __addBusy = false;
          addUi(false);
        }
      });
    }
    /* bld2: změna v modulu „výšivka na bok / dozadu“ znovu zapíše vlastnosti řádku a add-on položky */
    if(kind === 'color'){
      document.addEventListener('rd-sideback:change', function(){ try{ applyToFormAndExtras(); }catch(e){} });
      setTimeout(function(){ try{ if(window.RdSideBack && window.RdSideBack.read().length) applyToFormAndExtras(); }catch(e){} }, 0);
    }
    buildFontOptions();
    syncModeUI();
    renderTabs();
    renderThreadColors();
    renderSwatches();
      try{ renderSizes(); }catch(e){}
    resizeCanvasToImage();
    syncUiFromState();
    renderPreview();

    // CAPKOV FIX: Builder ("Vytvořit výšivku") is the source of truth for the cart.
    //
    // CRITICAL: this builder block is rendered BEFORE the buy_buttons block, so at
    // the moment this script tag runs, the product form does NOT exist in the DOM
    // yet. We must NOT bind to the form element at script-execution time, otherwise
    // getForm() returns null and the override never attaches.
    //
    // Strategy:
    //   1) Document-level capture-phase submit handler: works regardless of when
    //      (or how) the form is added, and runs BEFORE the theme's submit listener
    //      reads FormData(form). At submit time we restore input[name="id"] to the
    //      variant the customer designed against, so cart line variant = saved
    //      design's variant — even if a different PDP swatch was clicked after Save.
    //   2) Form-level variant observer: deferred via requestAnimationFrame retry
    //      until the form is in the DOM. Only used for visual sync of the builder
    //      preview when NO design is saved (so the modal opens against the cap
    //      colour the customer is currently browsing).
    (function setupCapkovCartIntegration(){
      // 1) Submit override — document level, capture phase.
      document.addEventListener('submit', function(ev){
        if(isSocks && ev.target === getForm()){
          var socksError = socksTextError();
          if(socksError){
            ev.preventDefault();
            ev.stopImmediatePropagation();
            openModal();
            showError(socksError);
            return;
          }
        }
        try{
          var saved = String(state && state.savedVariantId || '').trim();
          if(!saved) return;
          var f = ev.target;
          if(!f || !f.tagName || f.tagName.toLowerCase() !== 'form') return;
          if(productFormId && String(f.getAttribute('id') || '') !== String(productFormId)) return;
          var idInput = f.querySelector('input[name="id"]');
          if(!idInput) return;
          if(String(idInput.value || '').trim() !== saved){
            idInput.value = saved;
            try{ idInput.dispatchEvent(new Event('change', { bubbles:true })); }catch(e){}
          }
        }catch(e){}
      }, true);

      // 2) Variant observer — defer until the form appears in DOM.
      function attachVariantObserver(){
        var form = getForm();
        var idInput = form ? form.querySelector('input[name="id"]') : null;
        if(!form || !idInput){
          attachVariantObserver._tries = (attachVariantObserver._tries || 0) + 1;
          if(attachVariantObserver._tries < 120){
            try{ requestAnimationFrame(attachVariantObserver); }catch(e){}
          }
          return;
        }
        var lastVal = String(idInput.value || '');
        function onVariantChanged(){
          var nv = '';
          try{ nv = String(idInput.value || ''); }catch(e){ return; }
          if(nv === lastVal) return;
          lastVal = nv;
          /* Design saved → the variant used to be frozen, so a colour picked on the PDP
             afterwards was shown to the customer but never reached the cart (order #7509:
             chose Washed Vínová, received Washed Denim). What the customer sees has to be
             what they get, so a switch to another real variant of this product moves the
             lock with them and the mockups are regenerated for the new colour. */
          if(state && state.savedVariantId){
            var _vs = Array.isArray(product.variants) ? product.variants : [];
            var _valid = nv && _vs.some(function(v){ return String(v.id) === String(nv); });
            if(!_valid) return;
            state.savedVariantId = String(nv);
            try{
              if(state.bundleToken && window.__capkov_saved_variant_by_token){
                window.__capkov_saved_variant_by_token[state.bundleToken] = String(nv);
              }
            }catch(e){}
            try{ if(autoApplyTimer) clearTimeout(autoApplyTimer); }catch(e){}
            autoApplyTimer = setTimeout(function(){
              try{ applyToFormAndExtras(); }catch(e){}
            }, 300);
          }
          try{
            /* the customer may have changed the size on the PDP — re-read it */
            try{ state.size = ''; renderSizes(); }catch(e){}
            var idx = determineActiveSwatchIndex();
            if(idx >= 0 && idx !== state.swatchIndex){
              state.swatchIndex = idx;
              updateSwatchActiveUI();
              if(isTote || isSocks){
                try{ maybeAutoSetToteThreadColor(); }catch(e){}
                try{ renderThreadColors(); }catch(e){}
              }
              renderPreview();
            }
          }catch(e){}
        }
        idInput.addEventListener('change', onVariantChanged);
        idInput.addEventListener('input', onVariantChanged);
        try{
          var mo = new MutationObserver(function(){ onVariantChanged(); });
          mo.observe(idInput, { attributes: true, attributeFilter: ['value'] });
        }catch(e){}
      }
      /* Also on load: the PDP frequently lands on a sold-out variant. */
      function initialAvailability(){
        var form = getForm();
        if(!form || !form.querySelector('input[name="id"]')){
          initialAvailability._tries = (initialAvailability._tries || 0) + 1;
          if(initialAvailability._tries < 120){
            try{ requestAnimationFrame(initialAvailability); }catch(e){}
          }
          return;
        }
        try{ ensureAvailableVariant(); }catch(e){}
        try{ renderSwatches(); }catch(e){}
      }

      if(document.readyState === 'loading'){
        document.addEventListener('DOMContentLoaded', attachVariantObserver);
        document.addEventListener('DOMContentLoaded', initialAvailability);
      } else {
        attachVariantObserver();
        initialAvailability();
      }
    })();

    };

  /* Boot any builder already in the DOM. The inline snippet also calls
     __capkovBuilderInit directly, so builders injected later (quick view, Section
     Rendering API) still start; data-capkov-inited keeps that from double-running. */
  function capkovBootAll(){
    var nodes = document.querySelectorAll('[data-capkov-builder][data-capkov-uid]');
    for(var i = 0; i < nodes.length; i++){
      var n = nodes[i];
      if(n.getAttribute('data-capkov-inited') === '1') continue;
      n.setAttribute('data-capkov-inited', '1');
      try{ window.__capkovBuilderInit(n.getAttribute('data-capkov-uid')); }catch(e){}
    }
  }
  window.__capkovBuilderBoot = capkovBootAll;

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', capkovBootAll);
  }else{
    capkovBootAll();
  }
})();
